import React, { useState, useEffect, useRef, memo, forwardRef, useImperativeHandle, startTransition, } from "react";
import { Grid, GridColumn as Column, } from "@progress/kendo-react-grid";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { AUTOMATION, ApplicationConfigurationKeys, BILLBOARD_TYPES, COLUMNSTYPE, ENTITYNAME, FILEURL, FORMATVARIATIONTYPE, FrameEquivalentOfMilliSecond, LOCALSTORAGE_KEY, LOGEVENT, MAM_ASSET_REPORT_STATUS, MEDIACATEGORIES, MEDIACATEGORYTYPES, MEDIATYPE, MEDIATYPEENUM, MEDIA_TYPE, MILLISECONDSINADAY, MODULE, OFFSET, PLATFORMTYPE, REPLACEMENTMODE, SCHEDULECONSTRAINTS, SCHEDULETYPE, SCHEDULE_CHILDREN_TYPE, SCTE_TYPE, SEGMENT_DETAILS_CREDIT_TYPE, SOCKET_ACTION, SOCKET_EVENTS, TOAST_TYPES, TX_MODE, TX_STATUS, USER_RESTRICTED_ACTIONS } from "../../../framework/constant/constant";
import { utility } from "../../../framework/utility/utilityProvider";
import { SchedulingHelper } from "../helper/SchedulingHelper";
import * as API from "../../../framework/API/api";
import { orderBy } from "@progress/kendo-data-query";
import { TimeCell, TimeHyperLinkCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { DateOnlyCell } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { ScheduleTypeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ScheduleTypeCell";
import SecondaryEventIcon from "@mui/icons-material/Image";
import TheatersIcon from '@mui/icons-material/Theaters';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';
import RouterIcon from '@mui/icons-material/Router';
import MicIcon from '@mui/icons-material/Mic';
import { ContextMenu } from "primereact/contextmenu";
import { useTranslation } from "../../../locale/useTranslation";
import PlanningEditForm from "../../Planning/PlanningEditForm";
import { ConfirmAlert, ConfirmAlertOneTime } from "../../../ConfirmAlert";
import moment from "moment";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import GlobalReplacement from "../GlobalReplacement";
import { SchedulePrototypeOverview } from "../SchedulePrototypeOverview";
import useSocket from "../../../framework/socket/useSocket";
import CheckLists from "../../CheckList/CheckLists";
import ContractCollectionSelection from "../../Contract/ContractCollectionSelection";
import { PlanningHelper } from "../../Planning/helper/PlanningHelper";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AutoPlotPromo from "../AutoPlotPromo";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { VirtualSegmentationPopup } from "../VirtualSegmentationPopup";
import MediaFastSegmentationPopup from "../../Segment/MediaFastSegmentationPopup";
import { SalesHelper } from "../../Sales/SalesHelper";
import GoToSchedulePopup from "./GoToSchedulePopup";
import { TreeList, TreeListDraggableRow } from "@progress/kendo-react-treelist";
import ArchiveIconCell from "../../../components/ArchiveIconCell";
import MyInfoCell from "../../../framework/forms/helpercomponents/CustomGridCells/MyInfoCell";
import contextMenuItem from "../../../components/contextMenuItem";
import ScheduleDraftEditForm from "./ScheduleDraftEditForm";
import { SegmentCountCell } from "../../../framework/forms/helpercomponents/CustomGridCells/SegmentCountCell";
import { EditPageHeader } from "../../../components/EditPageHeader";
import { TXModeCell, TXStatusCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TXModeCell";
import BossDialog from "../../../components/BossDialog";
import HeaderLockPopup from "../../Planning/headerLockPopup";
import AddProgramSchedulePopup from "./AddProgramSchedulePopup";
import MyStatusCell from "../../../components/MyStatusCell";
import bossAIPng from '../../../img/BOSS-AI.png';
import ImportCommercialPopup from "./ImportCommercialPopup";
import CreateLoopForm from "./CreateLoopForm";
import ScheduleMAMAssetReportPopup from "./ScheduleMAMAssetReportPopup";
import { MediaMamAssetColumns } from "../../../framework/utility/customColumns";
import { getNoMamAttachedMedia } from "../../CheckList/checkListHelper";
import { v4 as uuidv4 } from 'uuid';
import ToastNotification from "../../../components/ToastNotification";

const DATA_ITEM_KEY = "_id";
const SELECTED_FIELD = "selected";
const EXPAND_FIELD = "expanded";
const SUB_ITEM_FIELD = "children";
const SELECTED_HEADER = "isHeaderSelected";
const editField = "inEdit";
const IS_BREAK = "IsBreak";
const IS_BREAK_CHILDREN = "IsBreakChildren";
const UNDERRUN = "UR";
const OVERRUN = "OR";
const ROW_HEIGHT = 40;

const SchedulingMainTree = (props, ref) => {

  // const lastScrollTop = useRef(0);
  const gridRef = useRef(null);
  const treeListRef = useRef(null);
  const scteGridRef = useRef(null);

  const enableBossAI = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableBossAI) ?? false;
  const enableMamIdChecklist = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.enableMamIdChecklist) ?? false;

  const { selectedChannel, lockStatus, isBreakOnly, showBreakOnly, handleLiveEventPopup, showGoToSchedulePopup, setShowGoToSchedulePopup, setIsDraftMode, isDraftMode } = props;

  const selectedDateRef = useRef(props.date.getTime());
  const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);

  // const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours(); //OLD

  const offSetHours = new Date(PlanningHelper.getDayStartTime([selectedChannel]) ?? 0).getUTCHours();
  const mainTimeZone = PlanningHelper.getMainTimeZone([selectedChannel]);

  //ALWAYS SUBTRACT OFFSET
  const offsetTime = (offSetHours * 3600000) - (mainTimeZone.IsNegativeOffset ? -mainTimeZone.Offset : mainTimeZone.Offset);

  const offsetTimeWithoutTimeZone = (offSetHours * 3600000);

  const pageSize = 40;
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  const isDraftModeRef = useRef(isDraftMode);
  const isBreakOnlyRef = useRef(isBreakOnly);
  //user
  let user = utility.getValue(LOCALSTORAGE_KEY.userData);
  const applicationConfigurationValue = utility.getValue(LOCALSTORAGE_KEY.applicationConfiguration);
  const enableScheduleInsertLiveEvent = applicationConfigurationValue ? (applicationConfigurationValue.find(x => x.Key == 'EnableScheduleInsertLiveEvent')?.Value ?? false) : false;
  const appconfig = utility.getValue(LOCALSTORAGE_KEY.applicationConfiguration);

  var savingSchedule = false;

  // Schedule Related Properties
  const [skip, setSkip] = useState(0);
  const [schedulerData, setSchedulerData] = useState([]);
  const schedulerDataRef = useRef(schedulerData);
  const nextDayHeaderRef = useRef([]);
  const [isSchduleLoading, _setIsSchduleLoading] = useState(false);
  const setIsSchduleLoading = (data) => {
    _setIsSchduleLoading(data)
    props.onIsSchduleLoading(data)
  }
  const schedulerDataRefSetter = (data) => {
    schedulerDataRef.current = data;
    setSchedulerData(data);
    props.setSchedulingData(data);
    let statusCount = SchedulingHelper.getCommercialOverRunUnderRunCounts(data);
    props.setStatusInfo({ ...statusCount, selectedChannel: selectedChannel, selectedScheduleDate: props.selectedScheduleDate });
  };

  // Selected Item Properties
  const [selectedState, setSelectedState] = useState([]); //children multiple selection grid
  const selectedStateRef = useRef(selectedState);
  const selectedStateRefSetter = (data) => {
    selectedStateRef.current = data;
    setSelectedState(data);
    //seeting header data
    setSelectedHeadersDataItems(data.filter(x => x.Type == SCHEDULETYPE.Header));
    props.setSelectedState(data);
  };

  const copyPasteDataItemRef = useRef([]);
  const copyPasteDataItemSetter = (data) => {
    copyPasteDataItemRef.current = data;
    props.setCopyPasteDataItem(data.length);
  };

  const payloadref = useRef();
  const [categories, setCategories] = useState([]);

  const selectedHeadersDataItemsRef = useRef([]);
  const setSelectedHeadersDataItems = (data) => {
    selectedHeadersDataItemsRef.current = data;
  }
  const selectedHeader = useRef({});
  const setSelectedHeader = (data) => {
    selectedHeader.current = data;
    props.setSelectedHeader(data);
  };

  const [dataColumns, setDataColumns] = useState([]);
  const setStatusMessage = (message) => {
    props.setStatusMessage(message);
  };

  const [showPlanningEditForm, setShowPlanningEditForm] = useState(false);
  const [showFilterGrid, _setShowFilterGrid] = useState(false);
  const showFilterGridRef = useRef(showFilterGrid);
  const setShowFilterGrid = (data) => {
    _setShowFilterGrid(data);
    showFilterGridRef.current = data;
  }

  const txStatusRef = useRef();
  const [txStatus, _setTxStatus] = useState({});
  const setTxStatus = (data) => {
    _setTxStatus(data);
    txStatusRef.current = data
  }

  const commentRef = useRef();
  const [comment, _setComment] = useState({});
  const setComment = (data) => {
    _setComment(data);
    commentRef.current = data
  }

  const routerCommandRef = useRef();
  const [routerCommand, _setRouterCommand] = useState({});
  const setRouterCommand = (data) => {
    _setRouterCommand(data);
    routerCommandRef.current = data
  }

  const scteHeaderDataRef = useRef([]);
  const [scteHeaderData, _setScteHeaderData] = useState([]);
  const setSCTEHeaderData = (data) => {
    _setScteHeaderData(data);
    scteHeaderDataRef.current = data;
  }

  const hcm = useRef(); //FOR SCHEDULER RIGHT CLICK ON HEADER: CONTEXT MENU
  const cm = useRef(); //FOR SCHEDULER RIGHT CLICK ON CHILDREN ELEMENT : CONTEXT MENU
  const bc = useRef(); //FOR SCHEDULER break children right Click
  const fg = useRef(); //FOR SCHEDULER filter grid right Click
  const scteg = useRef(); //FOR SCHEDULER Update SCTE Grid

  const lockStatusRef = useRef(lockStatus);
  const [showInsertPlaceHolderFilter, setShowInsertPlaceHolderFilter] =
    useState(false);
  const [showProgramReplacementDialog, setShowProgramReplacementDialog] =
    useState(false);
  const [showGlobalReplacementDialog, setShowGlobalReplacementDialog] =
    useState(false);
  const [showHeaderRippleDialog, setShowHeaderRippleDialog] =
    useState(false);
  const [showAddProgramPopup, setShowAddProgramPopup] = useState(false);
  const [showImportCommercialPopup, setShowImportCommercialPopup] = useState(false);

  const [showFilterGridData, _setShowFilterGridData] = useState([]);
  const showFilterGridDataRef = useRef(showFilterGridData);
  const filterSearchWordRef = useRef('');
  const setShowFilterGridData = (data) => {

    startTransition(() =>
      _setShowFilterGridData(data)
    );

    showFilterGridDataRef.current = data;
  }
  const [showCheckList, setShowCheckList] = useState(false);
  const lang = useTranslation();

  const schedulerChildrenFilterRef = useRef();
  const [styleSheetSelectionOpen, setStyleSheetSelectionOpen] = useState(false);

  const [showFormatSelection, setShowFormatSelection] = useState(false);

  const [showSecondaryEventOverviewDialog, setShowSecondaryEventOverviewDialog] = useState(false);
  const [showSaveScheduleDraftPopup, setShowSaveScheduleDraftPopup] = useState(false);

  const [showProgressBar, setShowProgressBar] = useState({
    okButton: false,
    progressBarPopup: false,
  });
  const [progressData, setProgressData] = React.useState({
    message: '',
    progress: 0,
  });

  const [txStatusData, setTxStatusData] = useState([]);

  // const [interstitialGroupSelectionOpen, setInterstitialGroupSelectionOpen] = useState(false);
  const [fastSegmentationPopupOpen, setFastSegmentationPopupOpen] = useState(false);
  const [updateTxStatusPopupOpen, setUpdateTxStatusPopupOpen] = useState(false);
  const [updateCommentPopupOpen, setUpdateCommentPopupOpen] = useState(false);
  const [updateRouterCommandPopupOpen, setUpdateRouterCommandPopupOpen] = useState(false);
  const [updateSCTEPopupOpen, setUpdateSCTEPopupOpen] = useState(false);
  const [editDurationPopupOpen, setEditDurationPopupOpen] = useState(false);
  const [customSlotDuration, _setCustomSlotDuration] = useState("00:00:00:00");
  const [showCreateLoopPopup, setShowCreateLoopPopup] = useState(false);
  const [splitSegmentPopupOpen, setSplitSegmentPopupOpen] = useState(false);

  const customSlotDurationRef = useRef("00:00:00:00");
  const setCustomSlotDuration = (data) => {
    _setCustomSlotDuration(data);
    customSlotDurationRef.current = data
  }

  const [splitSegmentDuration, _setSplitSegmentDuration] = useState("00:00:00:00");
  const splitSegmentDurationRef = useRef("00:00:00:00");
  const setSplitSegmentDuration = (data) => {
    _setSplitSegmentDuration(data);
    splitSegmentDurationRef.current = data
  }


  const [slotTime, _setSlotTime] = useState("00:00:00:00");
  const slotTimeRef = useRef("00:00:00:00");
  const setSlotTime = (data) => {
    _setSlotTime(data);
    slotTimeRef.current = data
  }

  const [showVirtualSegmentation, setShowVirtualSegmentation] = useState(false);
  const [virtualSegmentationData, setVirtualSegmentationData] = useState({
    duration: "00:00:00:00",
    noOfSeg: 2,
    diffDur: "00:00:00:00",
    totalDur: "00:00:00:00",
    gridData: []
  });

  const outSideFocusRef = useRef(props.outSideFocus);
  const scheduleScrollRef = useRef();
  const scrollPosition = useRef(0);

  const isCut = useRef(false);
  const setIsCut = (data) => {
    isCut.current = data;
  }

  // for program replacement
  const programToReplaceRef = useRef({});
  const setProgramToReplace = (data) => {
    programToReplaceRef.current = data;
  };
  const [showMediaDealRightsPopup, setShowMediaDealRightsPopup] = useState(false);

  //
  const selectedPromoRef = useRef([]);
  const setSelectedPromo = (data) => {
    selectedPromoRef.current = data
  }

  //LOCK
  const [headerLockPopup, setHeaderLockPopup] = useState({
    show: false,
    segments: [],
    header: null,
    nextHeaderStartTime: null
  });

  const [showAutoPlotPromo, setShowAutoPlotPromo] = useState(false);
  const [mediaCategory, setMediaCategory] = useState([]);
  const [mediaCategoryType, setMediaCategoryType] = useState([]);
  const [filterMediaCategoryType, setFilterMediaCategoryType] = useState([]);
  const [treeListHeight, setTreeListHeight] = useState('100%');

  const [showMissingMamIDPopup, setShowMissingMamIDPopup] = useState(false);
  const [missingMamIDReportData, setMissingMamIDReportData] = useState([]);
  const [importCommercialProgress, setImportCommercialProgress] = useState({ message: "", progress: 0 });
  const [showMamAssetCollectionSelection, setShowMamAssetCollectionSelection] = useState(false);

  let blankDataItem = {
    AssetId: 'BREAK',
    Title: "",
    Content: {},
    Description: "",
    MediaCategory: {},
    MediaCategoryType: {},
    Duration: "00:00:00:00",
    IsBreak: true
  };

  const [breakdataItemForPopup, setBreakdataItemForPopup] = useState(blankDataItem);
  //socket
  const socket = useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {
    console.log(socketData);
    //  console.log(socketData);
    if (socketData.module != MODULE.SCHEDULING) return;

    // if same user working on same date but different channel, it was reflecting in both channels.
    if (selectedChannel.SID != socketData.data.selectedChannelSID || socketData.data.selectedScheduleDate != props.selectedScheduleDate) return; //no need to filter active user from module 

    // let remoteUser = socketData.user;
    // setStatusMessage(`${lang.last_updated_from_label_msg}` + remoteUser?.name)

    switch (socketData.action) {
      case SOCKET_ACTION.SCHEDULE_REFRESH:
        loaddata(true);
        break;
      case SOCKET_ACTION.SCHEDULE_ADDITEM:

        console.log("coming in socket schedule add");
        // addScheduleItemsMain(socketData.data.destinationDataItem, socketData.data.dataItems, false)
        let schedulerDataLocal = schedulerDataRef.current;
        let level_0_index = socketData.data.level_0_index;
        let level_1_index = socketData.data.level_1_index;

        if (socketData.data.insertType == SCHEDULE_CHILDREN_TYPE.break_children) {
          schedulerDataLocal[level_0_index].children[level_1_index].children = socketData.data.children;
          //ripple
          schedulerDataLocal[level_0_index].children[level_1_index].children = getRippleBreakChildrens(schedulerDataLocal[level_0_index].children[level_1_index], schedulerDataLocal[level_0_index].children[level_1_index].children);
        }
        else {
          schedulerDataLocal[level_0_index].children = socketData.data.children
          //ripple
          schedulerDataLocal[level_0_index].children = getRippleChildrens(schedulerDataLocal[level_0_index], schedulerDataLocal[level_0_index].children, schedulerDataLocal);
        }

        // setting updated values on UI binded property and reference.
        schedulerDataRefSetter(schedulerDataLocal);
        break;
      case SOCKET_ACTION.SCHEDULE_DELETEITEM:
        deleteScheduleItemsExecute(socketData.data.dataItems);
        break;
      case SOCKET_ACTION.SCHEDULE_BOOKING_REFRESH:
        props.loadBookingCommercialdata();
        break;
      default:
        break;
    }
  });

  useEffect(() => {
    if (isSchduleLoading == false) {
      treeListRef?.current?.element?.addEventListener('scroll', onTreeViewscroll);
    }

    return () => {
      treeListRef?.current?.element?.removeEventListener('scroll', onTreeViewscroll);
    }
  }, [isSchduleLoading]);




  // on screen RESOLUTION change
  useEffect(() => {
    let divHeight = document.getElementById('content-scroll')?.offsetHeight;
    setTreeListHeight(divHeight + 'px');
    // listen for resize event
    window.addEventListener('resize', () => {
      let divHeight = document.getElementById('content-scroll')?.offsetHeight;
      setTreeListHeight(divHeight + 'px');
    });

    return () => {
      window.removeEventListener('resize', () => {
        let divHeight = document.getElementById('content-scroll')?.offsetHeight;
        setTreeListHeight(divHeight + 'px');
      });
    }
  }, []);

  useEffect(() => {
    lockStatusRef.current = lockStatus;
    isDraftModeRef.current = isDraftMode;
    isBreakOnlyRef.current = isBreakOnly;
  }, [lockStatus, isDraftMode, isBreakOnly]);


  useEffect(() => {
    createPayload();
    loaddata();
    loadCombo();
    selectedDateRef.current = props.date.getTime();
  }, [props.doLoad]);

  useEffect(() => {
    loaddata(true);
  }, [props.doSilentLoad]);

  useEffect(() => {
    outSideFocusRef.current = props.outSideFocus;
  }, [props.outSideFocus]);


  useEffect(() => {
    document.addEventListener("copy", onCopy);
    document.addEventListener("paste", onPaste);
    document.addEventListener("keyup", handleArrowAndOtherKeys);
    document.addEventListener("keydown", handleDeleteKeys);


    return () => {
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("paste", onPaste);
      document.removeEventListener("keyup", handleArrowAndOtherKeys);
      document.removeEventListener("keydown", handleDeleteKeys);


    };
  }, [showVirtualSegmentation]);

  useImperativeHandle(ref, () => {
    return {
      onExpand(e) {
        onHeaderExpandChange(e)
      },

      onDeleteAllFooter() {
        ConfirmAlert(
          () => {
            deleteAllFooter();
          }, // on Click yes
          () => { }, // on click no
          'Confirm', //title
          'Do you really want to delete all footers ?' // message
        );
      },

      onDeleteAllSecondary() {
        ConfirmAlert(
          () => {
            deleteAllSecondaryEvent();
          }, // on Click yes
          () => { }, // on click no
          'Confirm', //title
          'Do you really want to delete all secondary events ?' // message
        );
      },

      onDeleteSelectedSecondary({ selectedItem, selectedPrototype }) {
        ConfirmAlert(
          () => {
            deleteSelectedSecondaryEvent({ selectedItem, selectedPrototype });
          }, // on Click yes
          () => { }, // on click no
          'Confirm', //title
          'Do you really want to delete this secondary event ?' // message
        );
      },

      onDeleteSelectedAllSecondaryEvent({ selectedItem, selectedPrototype }) {
        ConfirmAlert(
          () => {
            deleteSelectedAllSecondaryEvent({ selectedItem, selectedPrototype });
          }, // on Click yes
          () => { }, // on click no
          'Confirm', //title
          'Do you really want to delete this secondary events from whole playlist ?' // message
        );
      },

      onAppleStyleSheet() {
        onStyleSheetSelection()
      },

      onShowGlobalReplacement() {

        showGlobalReplacement();
      },
      onSetDoOnCheckList() {
        onCheckList()
      },

      onExportSchedule({ automation, channel, doSftp, isPartial, isDeliver, withSCTE, isCommercial }) {
        exportSchedule(automation, channel, [], doSftp, isPartial, isDeliver, withSCTE, isCommercial)
      },

      onExportAnnouncement() {
        exportScheduledAnnouncement()
      },

      onFillUnderOverRun(scheduleTimeInfo, isForMultipleDays = false, multipleDayPayload = undefined) {
        //setInterstitialGroupSelectionOpen(true);
        fillUnderOverRun(scheduleTimeInfo, isForMultipleDays, multipleDayPayload);
      },
      onSearch(e) {
        onSearchLocal(e)
      },
      onAutomaticBreakDistribution() {
        onAutomaticBreakDistribution();
      },
      onAutoFillBookedCommercial(bookingData) {


        ConfirmAlert(
          () => {
            autoFillBookedCommercial(bookingData, true)
          }, // on Click yes
          () => {
            autoFillBookedCommercial(bookingData, false)
          }, // on click no
          'Place spots inside breaks ?', //title
          'Press YES to fill booked spots inside available commercial breaks or click NO to fill outside commercial breaks' // message
        );

      },
      onAutoPlotPromoInSchedule(media) {

        ConfirmAlert(
          () => {
            onAutoPlotPromoInSchedule(media, true)
          }, // on Click yes
          () => {
            onAutoPlotPromoInSchedule(media, false)
          }, // on click no
          'Fill Selected Promos ?', //title
          'Press YES to fill selected promos or click NO to fill all available promos having targets configured' // message
        );

      },
      onReturnSlotDateTimeToPlannedNominalTime() {
        onReturnSlotDateTimeToPlannedNominalTime()
      },
      onDeleteAnnouncement(announcement) {
        //need selected item 
        handleDeleteAnnouncement(announcement);
      },
      onLiveEventInsertInSchedule(liveEventData) {
        let data = SchedulingHelper.prepareData(ENTITYNAME.MediaEpisode, getSelectedChannel(), [liveEventData], schedulerChildrenFilterRef.current.dataItem, schedulerDataRef.current, true);
        console.log(data)
        addScheduleItems(schedulerChildrenFilterRef.current.dataItem, data)
      },
      onResetAutoFillPlaylistChildren() {

        ConfirmAlert(
          () => {
            ResetAutoFillPlaylistChildren(false);
          }, // on Click yes
          () => {

          }, // on click no
          'Reset Auto Filled Elements', //title
          'Press YES to delete all items from schedule which were added by auto fill playlist.' // message
        );
      },
      onResetSchedule() {

        ConfirmAlert(
          () => {
            ResetAutoFillPlaylistChildren(true);
          }, // on Click yes
          () => {

          }, // on click no
          'Reset Playlist', //title
          'Do you want to delete all schedule elements other than segments.' // message
        );
      },
      onDelete() {
        onDelete();
      },
      onCut() {
        onDelete(true);
      },
      onCopy() {
        onCopy();
      },
      onPaste() {
        onPaste();
      },
      deleteSelectedSecondaryEvent() {
        deleteSelectedSecondaryEvent();
      },
      showSecondaryEventOverviewDialogProp() {
        showSecondaryEventOverviewDialogProp();
      },
      showInsertBreakPopup(e) {
        showInsertBreakPopup(e);
      },
      onRevertVirtualSegmentation() {
        onRevertVirtualSegmentation();
      },
      handleLiveEventPopup() {
        handleLiveEventPopup();
      },
      handleSaveScheduleDraftPopup() {
        handleSaveScheduleDraftPopup();
      },
      loadDraftdata(draftSchedule) {
        loaddata(false, true, draftSchedule);
      },
      onMatchPreviousDayEndTime(scheduleTimeInfo) {
        onMatchPreviousDayEndTime(scheduleTimeInfo);
      },
      onManageUnderOverRunForSelectedHeader() {

        const selectedHead = selectedStateRef.current.filter(x => x.Type == SCHEDULETYPE.Header);
        if (selectedHead == undefined || selectedHead.length == 0) {
          ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "No header selected" });
          return;
        }
        ManageUnderAndOverRuns(selectedHead.map(x => x._id), false)
      },
      autoFillPlaylistWithMusic() {
        autoFillPlaylistWithMusic(schedulerDataRef.current);
      },
      onApplySCTEMarkers(channel) {
        onApplySCTEMarkers(schedulerDataRef.current, channel);
      },
      onAutoSchedule() {
        onAutoSchedule(schedulerDataRef.current);
      },
      onImportCommercials() {
        onImportCommercials();
      },
      onDeleteAllSCTEMarkers() {

        ConfirmAlert(
          () => {
            onDeleteAllSCTEMarkers(schedulerDataRef.current);
          }, // on Click yes
          () => { }, // on click no
          'Confirm', //title
          'Do you really want to remove all SCTE Marker ?' // message
        );

      },
      onExecutePromoCampaign() {
        executePromoCampaign();
      },

      // Re-sync segments
      onReSyncHeaderSegments() {
        onReSyncHeaderSegments();
      },
    };
  }, []);


  const onTreeViewscroll = (e) => {
    scrollPosition.current = e.target.scrollTop;
  }

  const getSelectedChannel = () => {
    if (selectedChannel == undefined || Object.keys(selectedChannel).length == 0) {

      return schedulerDataRef.current && schedulerDataRef.current.length > 0 ? schedulerDataRef.current[0].Channel : {}

    }
    return selectedChannel
  }

  const onAutomaticBreakDistribution = async () => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "LOCKED", message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "DRAFT", message: "Schedule is in draft mode" });
      return;
    }

    var parents = schedulerDataRef.current;

    //LOOP : parents
    if (parents.length > 0) {

      setShowProgressBar({ okButton: false, progressBarPopup: true });

      for (var i = 0; i < parents.length; i++) {
        const parent = parents[i];

        // updating progress bar
        setProgressData({ message: 'creating promo & commercial breaks', progress: Math.ceil((100 * (i + 1)) / parents.length) });

        const parentSegments = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);


        //SKIP : if breaks are already attached 
        const alreadyBreakAttached = parent.children.some(x => x.IsBreak == true);
        if (alreadyBreakAttached) continue;


        //FETCH : break formats
        var breakFormats = await API.getData(ENTITYNAME.BreakFormat, { query: [['SlotDuration', '=', parent.Duration], ['SegmentCount', '=', `${parentSegments.length}`]] });
        // console.log(breakFormats)


        //INSERT : breaks after every segment
        if (breakFormats.data.length == 0) continue;

        var formatDetail = breakFormats.data[0].BreakFormatDetail;

        while (formatDetail.length > 0) {
          var breakFormatDetail = formatDetail.sort((a, b) => a.BreakNumber - b.BreakNumber)[0];

          formatDetail = formatDetail.filter(
            (obj) => obj.BreakNumber != breakFormatDetail.BreakNumber
          );

          const breakCommercialData = await SchedulingHelper.getCommercialPromoBreak(
            utility.convertStringWithFramesToMilliseconds(breakFormatDetail.CommercialDuration),
            MEDIACATEGORIES.Commercial,
            MEDIACATEGORYTYPES.Commercial
          );

          const breakPromoData = await SchedulingHelper.getCommercialPromoBreak(
            utility.convertStringWithFramesToMilliseconds(breakFormatDetail.PromoDuration),
            MEDIACATEGORIES.Interstitial,
            MEDIACATEGORYTYPES.Promo
          );

          if (parentSegments && parentSegments.length > 0) {
            console.log("breakFormatDetail.BreakNumber--" + breakFormatDetail.BreakNumber);
            var destination = breakFormatDetail.BreakNumber == 0
              ? parent
              : parentSegments.find(x => x.BreakNo == breakFormatDetail.BreakNumber);

            const dataToSaveCommercial = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              breakCommercialData,
              destination,
              schedulerDataRef.current
            );
            console.log("adding item in schedule");
            console.log(dataToSaveCommercial);
            await addScheduleItems(destination, dataToSaveCommercial);

            if (utility.convertStringWithFramesToMilliseconds(breakFormatDetail.PromoDuration) > 0) {
              const dataToSavePromo = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                breakPromoData,
                destination,
                schedulerDataRef.current
              );
              await addScheduleItems(destination, dataToSavePromo);
            }

          }
        }

        let logData = { event: LOGEVENT.CREATE_AUTOMATIC_BREAKS, module: MODULE.SCHEDULING, data: parent, message: LOGEVENT.CREATE_AUTOMATIC_BREAKS };
        API.SaveLogs(logData);

      }

      setProgressData({ message: 'process completed', progress: 100 });
      setShowProgressBar({ progressBarPopup: true, okButton: true })

    }
    console.log('here in main')
  }


  const updateScheduleColorPreferenceOnFirstLoad = async () => {
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    await API.getDataLookup(ENTITYNAME.UserPreference, {
      query: [["entityName", "=", "schedulepreference"], ["user_id", "=", user._id]],
      sort: { SID: 1 },
      page: null,
      perPage: null
    }, LOCALSTORAGE_KEY.schedulepreference);
  }
  const isNotValidBreakOnlyCutPasteDelete = (isCutDelete = false) => {

    let isValid = selectedStateRef.current.some((data) => {
      let { isBreak, isInsideBreak } = SchedulingHelper.getChildInfo(data, schedulerDataRef.current);
      if (isCutDelete) return isInsideBreak;
      else return isInsideBreak || isBreak;
    });
    if (!isValid) {
      return true;
    }

    return false;
  }
  //paste
  const onPaste = async () => {

    if (isBreakOnly && isNotValidBreakOnlyCutPasteDelete()) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `You can only paste in break items.` });
      return;
    };

    if (savingSchedule) return;

    if (outSideFocusRef.current) return;

    let itemToPaste = utility.getValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS) ?? copyPasteDataItemRef.current;

    if (itemToPaste.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.first_cut_or_copy_item_error_message });
      return;
    }

    //CHECK TIME RESTRICTIONS
    if (!SchedulingHelper.IsValidDropDestinationSlot(selectedStateRef.current[0], itemToPaste, offsetTime, selectedDateRef.current, true, getSelectedChannel())) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_paste_due_to_time_restriction_error_message });
      return;
    }

    if (selectedStateRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_Item_to_paste_error_message });
      return;
    }

    if (selectedStateRef.current.length != 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.Please_select_one_Item_where_need_to_paste_error_message });
      return;
    }

    if (!selectedStateRef.current.some(data => SchedulingHelper.canModify(data, schedulerDataRef.current))) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot paste because header is locked." });
      return;
    }

    let draggedData = itemToPaste;
    let destinationDataItem = selectedStateRef.current[0];
    let src = ENTITYNAME.ProgramSchedule; //becouase it should ne new item no source required

    const dataToSave = SchedulingHelper.prepareData(
      src,
      getSelectedChannel(),
      draggedData,
      destinationDataItem,
      schedulerDataRef.current,
      true
    );
    addScheduleItems(destinationDataItem, dataToSave);

    if (isCut.current) {
      copyPasteDataItemSetter([]);
      utility.setValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS, []);
      setIsCut(false);
    }
  };

  //delete
  const onDelete = (isCut = false) => {

    if (isDraftModeRef.current) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "DRAFT", message: "Schedule is in draft mode" });
      return;
    }

    if (isBreakOnlyRef.current && isNotValidBreakOnlyCutPasteDelete(true)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `You can only ${isCut ? 'cut' : 'delete'} break items.` });
      return;
    }

    if (!lockStatusRef.current.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "LOCKED", message: "Schedule Locked by " + lockStatusRef.current.lockedBy.name });
      return;
    }

    let message = isCut ? `${lang.cut_msg}` : `${lang.delete_msg}`;
    setIsCut(isCut);
    if (!lockStatusRef.current.canModifyHeader &&
      selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.UnderRun || data.Type == SCHEDULETYPE.OverRun)
    ) {
      setStatusMessage("Planning is locked.");

      ToastNotification({ type: TOAST_TYPES.ERROR, title: "LOCKED", message: "Planning is locked." });
      return;
    }


    if (selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.Header)) {
      setStatusMessage(lang.cannot_delete_header_label_msg);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_delete_header_please_unselect_header_error_message });
      return;
    }

    console.log('---')
    let lastSchedulerItem = schedulerDataRef.current[schedulerDataRef.current.length - 1];
    let lastChild = lastSchedulerItem.children[lastSchedulerItem.children.length - 1];

    //NOT DONE
    // if(selectedStateRef.current.some((x) => !x.IsBreakChildren) && (selectedStateRef.current.length == 1 && selectedStateRef.current[0]._id == lastChild._id) )){
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot delete last break item" });
    //   return;
    // }

    if (selectedStateRef.current.some((x) => !x.IsBreakChildren)) {
      if (!selectedStateRef.current.some(data => SchedulingHelper.canModify(data, schedulerDataRef.current))) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Your selected item contains locked schedule headers" });
        return;
      }
    }

    const canDeleteSegment = (appconfig?.length > 0 && appconfig?.find(x => x?.Key == "canDeleteSegment")?.Value) ?? false;
    if (!canDeleteSegment && selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.Segment)) {
      setStatusMessage(lang.cannot_delete_segment_label_msg);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_segment_please_unselect_segment_error_message });
      return;
    }

    if (selectedStateRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.select_item_to_error_message} ${message}` });
      return;
    }

    if (
      selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.UnderRun || data.Type == SCHEDULETYPE.OverRun) && isCut
    ) {
      setStatusMessage(lang.cannot_cut_footer_msg_scheduling);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_cut_footer_msg_scheduling });
      return;
    }



    if (selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.UnderRun || data.Type == SCHEDULETYPE.OverRun) && selectedStateRef.current.length > 1) {
      setStatusMessage(`${lang.cannot_delete_multiple_footer_msg_scheduling}`);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_delete_multiple_footer_please_select_one_footer_at_a_time_msg_scheduling });
      return;
    }

    if (selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.UnderRun || data.Type == SCHEDULETYPE.OverRun)) {

      ConfirmAlert(
        () => {
          deleteFooter(selectedStateRef.current[0]);
        }, // on Click yes
        () => { }, // on click no
        `${lang.Confirmation_label}`, //title
        `${lang.are_you_sure_you_want_to_delete_footer_label}` // message
      );
      return;

    }
    //if isBreak has childrens than dont allow
    if (selectedStateRef.current.some((data) => data[IS_BREAK] && data.children && data.children.filter(x => x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun).length > 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "There are some break items present. Please delete break items" });
      return;

    }
    if (isCut) {

      //save in copy
      let copyBreakItems = selectedStateRef.current.filter((data) => data.Type != SCHEDULETYPE.Segment && !data[IS_BREAK]);
      copyPasteDataItemSetter(copyBreakItems);

      utility.setValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS, copyBreakItems);

      deleteScheduleItems(selectedStateRef.current, true);


    }
    else {

      let categoryTypes = [...new Set(selectedStateRef.current.map((x) => x.mediaEpisode?.MediaCategoryType?.Description))];
      let confirmAlertOneTime = utility.getValue(LOCALSTORAGE_KEY.schedulepreference);
      confirmAlertOneTime = confirmAlertOneTime?.data?.length > 0 ? confirmAlertOneTime?.data[0]?.value?.hideDeleteConfirmation : false;

      //CONFIRMATION ALERT ONLY IN SEGMENT AND COMMERCIAL 
      let isValidForDelete = selectedStateRef.current.every((data) =>
        data.mediaEpisode &&
        data.mediaEpisode.MediaCategory &&
        !data.mediaEpisode.MediaCategory.isLong &&
        data.mediaEpisode.MediaCategory.SID != MEDIACATEGORIES.Commercial
      );

      if (confirmAlertOneTime || isValidForDelete) {
        deleteScheduleItems(selectedStateRef.current, true);
      } else {
        ConfirmAlertOneTime(
          () => {
            deleteScheduleItems(selectedStateRef.current, true);
          }, // on Click yes
          () => { }, // on click no
          `${lang.Confirmation_label}`, //title
          `${lang.Are_you_sure_you_want_to_items_label_confirm_alert} ${message} ${selectedStateRef.current.length} items ${categoryTypes.join('/')}`, // message
        );
      }

    }

  };

  const handleShiftMultiSelect = (dataItem) => {

    if (dataItem.Type == SCHEDULETYPE.OverRun || dataItem.Type == SCHEDULETYPE.UnderRun) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_select_footer_error_message });
      return;
    };

    if (selectedStateRef.current.length == 0) {
      selectedStateRefSetter([dataItem]);
      return;
    }

    let lastSelectedDataItem = selectedStateRef.current[0];
    var dataItems = [];

    //getting index of first selected and current seklected

    if (showFilterGrid) {

      let firstItemIndex = showFilterGridData.indexOf(lastSelectedDataItem);
      let lastSelectedItemIndex = showFilterGridData.indexOf(dataItem);
      dataItems = showFilterGridData.slice(Math.min(firstItemIndex, lastSelectedItemIndex), Math.max(firstItemIndex, lastSelectedItemIndex) + 1);

    }
    else {
      let { level_0_index: lst_selected_dataItem_lvl_0_index, level_1_index: lst_selected_dataItem_lvl_1_index, level_2_index: lst_selected_dataItem_lvl_2_index, isInsideBreak: isLastChildInsideBreak } = SchedulingHelper.getChildInfo(lastSelectedDataItem, schedulerDataRef.current)

      let { level_0_index: curr_lvl_0_index, level_1_index: curr_lvl_1_index, level_2_index: curr_lvl_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(dataItem, schedulerDataRef.current)

      if (lst_selected_dataItem_lvl_0_index != curr_lvl_0_index && !showFilterGrid) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_multi_select_items_from_different_headers_error_message });
        return;
      }

      //if inside break item
      if (isInsideBreak) {
        //if last selected item is inside break then select all items from last selected item to current item
        if (isLastChildInsideBreak) {
          dataItems = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children[curr_lvl_1_index].children.slice(
            Math.min(lst_selected_dataItem_lvl_2_index, curr_lvl_2_index),
            Math.max(lst_selected_dataItem_lvl_2_index, curr_lvl_2_index) + 1
          );
        }
        else {
          let firstLevelDataItems = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children.slice(
            Math.min(lst_selected_dataItem_lvl_1_index, curr_lvl_1_index),
            Math.max(lst_selected_dataItem_lvl_1_index, curr_lvl_1_index) + 1
          ).filter(data => data.Type != SCHEDULETYPE.UnderRun && data.Type != SCHEDULETYPE.OverRun && data._id != dataItem.ParentProgramSchedule_id);

          let startIndexForBreakChildren = 0;
          if (curr_lvl_1_index < lst_selected_dataItem_lvl_1_index) {
            startIndexForBreakChildren = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children[curr_lvl_1_index].children.length - 1;
          }

          dataItems = [...firstLevelDataItems,
          ...schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children[curr_lvl_1_index].children.slice(
            Math.min(startIndexForBreakChildren, curr_lvl_2_index),
            Math.max(startIndexForBreakChildren, curr_lvl_2_index) + 1
          ).filter(data => data.Type != SCHEDULETYPE.UnderRun && data.Type != SCHEDULETYPE.OverRun)];
        }

      }
      else if (isLastChildInsideBreak) {
        let startIndexForBreakChildren = 0;
        if (curr_lvl_1_index > lst_selected_dataItem_lvl_1_index) {
          startIndexForBreakChildren = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children[lst_selected_dataItem_lvl_1_index].children.length;
        }
        let breakLevelDataItems = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children[lst_selected_dataItem_lvl_1_index].children.slice(
          Math.min(startIndexForBreakChildren, lst_selected_dataItem_lvl_2_index),
          Math.max(startIndexForBreakChildren, lst_selected_dataItem_lvl_2_index) + 1
        ).filter(data => data.Type != SCHEDULETYPE.UnderRun && data.Type != SCHEDULETYPE.OverRun);
        dataItems = [...breakLevelDataItems,
        ...schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children.slice(
          Math.min(lst_selected_dataItem_lvl_1_index + 1, curr_lvl_1_index),
          Math.max(lst_selected_dataItem_lvl_1_index - 1, curr_lvl_1_index) + 1
        ).filter(data => data.Type != SCHEDULETYPE.UnderRun && data.Type != SCHEDULETYPE.OverRun)];
      }
      else {
        dataItems = schedulerDataRef.current[lst_selected_dataItem_lvl_0_index].children.slice(
          Math.min(lst_selected_dataItem_lvl_1_index, curr_lvl_1_index),
          Math.max(lst_selected_dataItem_lvl_1_index, curr_lvl_1_index) + 1
        );
      }
    }


    selectedStateRefSetter(dataItems);
  }

  const handleShiftUpDown = (shiftUp) => {
    //shiftUp = true means shift up
    //shiftUp = false means shift down
    if (selectedStateRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_first_error_message });
      return;
    };

    var selectedItems = selectedStateRef.current;
    let lastSelectedItem = selectedStateRef.current[selectedStateRef.current.length - 1];

    //for search grid
    if (showFilterGridRef.current) {
      let lastSelectedItemIndex = showFilterGridDataRef.current.findIndex(x => x._id == lastSelectedItem._id);

      if ((lastSelectedItemIndex == 0 && shiftUp) || (lastSelectedItemIndex == showFilterGridDataRef.current.length - 1 && !shiftUp)) {
        return;
      } else {
        let item = showFilterGridDataRef.current[shiftUp ? lastSelectedItemIndex - 1 : lastSelectedItemIndex + 1];
        selectedItems = [...selectedItems, item];
      }
      selectedStateRefSetter(selectedItems);
      return;
    }

    let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(lastSelectedItem, schedulerDataRef.current);

    let lastIndex = schedulerDataRef.current[level_0_index].children.length - 1;

    if ((level_1_index == 0 && shiftUp) || (level_1_index == lastIndex && !shiftUp)) {
      //if the last selected item is the first item in the header, then cannot shift up
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_select_items_from_different_headers_error_message });
    } else {
      //get item above last selected item
      let item = schedulerDataRef.current[level_0_index].children[shiftUp ? level_1_index - 1 : level_1_index + 1];
      if (item.Type == SCHEDULETYPE.OverRun || item.Type == SCHEDULETYPE.UnderRun) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_select_items_from_different_headers_error_message });
        return;
      }
      selectedItems = [...selectedItems, item];
    }
    selectedStateRefSetter(selectedItems);

    return;
    //dont delete it we need reference from this code for conditions --rajat
    //for shift up
    if (shiftUp) {
      if (isInsideBreak) {
        //if inside break, then get the item above the last selected break item

        if (level_2_index == 0 && level_1_index == 0) {
          //if the item above break item is header, then cannot shift up
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot select items from different headers." });
          return;
        }
        if (level_2_index == 0) {
          //if the last selected item is the first item in the break, then get the item above break item
          let itemAbove = schedulerDataRef.current[level_0_index].children[level_1_index - 1];
          selectedItems = [...selectedItems, itemAbove];
        } else {
          //get item above last selected item
          let itemAbove = schedulerDataRef.current[level_0_index].children[level_1_index].children[level_2_index - 1];
          selectedItems = [...selectedItems, itemAbove];
        }
      }
      //if not inside break, then get the item above the last selected item
      else {
        let lastIndex = schedulerDataRef.current[level_0_index].children[level_1_index].children.length - 1;
        if (level_1_index == 0 || level_1_index == lastIndex) {
          //if the last selected item is the first item in the header, then cannot shift up
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot select items from different headers." });
        } else {
          //get item above last selected item
          let item = schedulerDataRef.current[level_0_index].children[shiftUp ? level_1_index - 1 : level_1_index + 1];
          selectedItems = [...selectedItems, item];
        }
      }


    }
    //for shift down
    else {
      //get item below the last selected item
      if (isInsideBreak) {
        //check if the last selected item is the last item in the break
        let lastIndex = schedulerDataRef.current[level_0_index].children[level_1_index].children.length - 1;

        if (level_2_index + 1 == lastIndex) {
          let itemBelow = schedulerDataRef.current[level_0_index].children[level_1_index].children[level_2_index + 1];
          //check if the item below is not a OverRun or underRun
          if (itemBelow.Type != SCHEDULETYPE.OverRun && itemBelow.Type != SCHEDULETYPE.UnderRun) {
            selectedItems = [...selectedItems, itemBelow];
          }
          //if it is OverRun or underRun, then get the item below the break
          else {
            let itemBelow = schedulerDataRef.current[level_0_index].children[level_1_index + 1];
            if (itemBelow.Type == SCHEDULETYPE.OverRun || itemBelow.Type == SCHEDULETYPE.UnderRun) {
              ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot select items from different headers." });
              return;
            }
            selectedItems = [...selectedItems, itemBelow];
          }
        } else {
          let itemBelow = schedulerDataRef.current[level_0_index].children[level_1_index].children[level_2_index + 1];
          selectedItems = [...selectedItems, itemBelow];
        }
      } else {
        let lastIndex = schedulerDataRef.current[level_0_index].children.length - 1;

        if (level_1_index == lastIndex) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot select items from different headers." });
        } else {
          let itemBelow = schedulerDataRef.current[level_0_index].children[level_1_index + 1];
          if (itemBelow.Type == SCHEDULETYPE.OverRun || itemBelow.Type == SCHEDULETYPE.UnderRun) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot select items from different headers." });
            return;
          }
          selectedItems = [...selectedItems, itemBelow];
        }
      }

    }
    selectedStateRefSetter(selectedItems);
  }

  const handleArrows = (isUp = true) => {
    if (outSideFocusRef.current) return;
    if (selectedStateRef.current.length == 0) return;
    let lastSelectedItem = selectedStateRef.current[selectedStateRef.current.length - 1];
    if (isUp) {
      let itemAbove = SchedulingHelper.getItemAbove(lastSelectedItem, schedulerDataRef.current);
      selectedStateRefSetter([itemAbove]);

    } else {
      let itemBelow = SchedulingHelper.getItemBelow(lastSelectedItem, schedulerDataRef.current);
      selectedStateRefSetter([itemBelow]);
    }

  }

  const handleExpandOnArrows = (expand = true) => {
    if (outSideFocusRef.current) return;
    if (selectedStateRef.current.length == 0) return;
    let lastSelectedItem = selectedStateRef.current[selectedStateRef.current.length - 1];
    if (lastSelectedItem.ParentProgramSchedule_id == null || lastSelectedItem[IS_BREAK]) {
      treeListRef.current.element.scrollTo({ left: 0, behavior: 'smooth' });
      expandChange({ dataItem: lastSelectedItem, value: expand });
    }
  }

  const handleArrowAndOtherKeys = async (event) => {

    event.preventDefault();

    if (event.shiftKey && event.key == "ArrowUp") {
      //true for up
      handleShiftUpDown(true);
      return;
    }
    if (event.shiftKey && event.key == "ArrowDown") {
      //false for down
      handleShiftUpDown(false);
      return;
    }

    if (event.key == "ArrowUp") {
      handleArrows(true);
      return;
    }
    if (event.key == "ArrowDown") {
      handleArrows(false);
      return;
    }
    if (event.key == "ArrowLeft") {
      handleExpandOnArrows(false);
      return;
    }
    if (event.key == "ArrowRight") {
      handleExpandOnArrows(true);
      return;
    }

    //NEED TO CHANGE THIS 'b' to 'g'
    if (event.ctrlKey && event.key == "b") {
      setShowGoToSchedulePopup(true);
      console.log(`You pressed handleGoToSchedule`);
      return;
    }

    //remove copy items and selected items on excape key
    if (event.keyCode == 27 || event.key == "Escape") {
      copyPasteDataItemSetter([]);
      utility.setValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS, []);
    }

  };

  const handleDeleteKeys = (event) => {

    if (outSideFocusRef.current) return;

    // detect CUT (Windows + Mac)
    if ((event.ctrlKey || event.metaKey) && event.key === "x") {
      onDelete(true);
      return;
    }

    // detect DELETE or Ctrl+Backspace
    if (
      event.key === "Delete" ||
      event.keyCode == 46 ||
      event.code === "Delete" ||
      (event.ctrlKey && event.key === "Backspace")
    ) {
      if (!showVirtualSegmentation) onDelete();
      return;
    }
  };

  const onCopy = () => {

    console.log(outSideFocusRef.current);

    if (outSideFocusRef.current) return;



    if (selectedStateRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_item_selected_to_copy_msg_scheduling });
      setStatusMessage(lang.no_item_selected_to_copy_msg_scheduling);
      return;
    }



    if (selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.Header)) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.cannot_copy_header_msg_scheduling });
      setStatusMessage(lang.cannot_copy_header_msg_scheduling);
      return;
    }

    if (
      selectedStateRef.current.some((data) => data.Type == SCHEDULETYPE.Segment)
    ) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.cannot_copy_segment_msg_scheduling });
      setStatusMessage(lang.cannot_copy_segment_msg_scheduling);
      return;
    }

    setIsCut(false);

    setStatusMessage(lang.copied_label);

    let copyBreakItems = selectedStateRef.current.filter((data) => data.Type != SCHEDULETYPE.Segment)
    copyPasteDataItemSetter(copyBreakItems);

    // saving break in local storage
    utility.setValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS, copyBreakItems);
  };

  const deleteAllFooterOld = async () => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    if (schedulerDataRef.current.length == 0) return;

    if (schedulerDataRef.current.some((data) => (data?.isLocked ?? false) == true)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some Schedule is locked so can't delete footer" });
      return;
    }

    let footerCount = 0;
    schedulerDataRef.current.map((parent) => {
      setStatusMessage(lang.deleting_footer_msg_scheduling);
      var footer = parent.children.find(
        (maindata) =>
          maindata.Type == SCHEDULETYPE.UnderRun ||
          maindata.Type == SCHEDULETYPE.OverRun
      );

      if (footer) {
        deleteFooter(footer);
        footerCount++;
      }
    });
    loaddata();
    setStatusMessage(footerCount + `${lang.footer_deleted_msg_scheduling}`);
    if (footerCount == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_footer_to_deleted_error_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.all_footer_deleted_error_message });
    }
  };

  const deleteAllFooter = async () => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    if (schedulerDataRef.current.length == 0) return;

    if (schedulerDataRef.current.some((data) => (data?.isLocked ?? false) == true)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some Schedule is locked so can't delete footer" });
      return;
    }

    let schedulerDataRefLocal = [...schedulerDataRef.current];
    let footerCount = 0;
    let changedParentIndexes = new Set();

    setStatusMessage(lang.deleting_footer_msg_scheduling);

    // Sort parents by SlotDateTime so we process in correct order
    schedulerDataRefLocal.sort((a, b) => a.SlotDateTime - b.SlotDateTime);

    // PASS 1: Process parents in order - shift next parents to close all gaps
    for (let i = 0; i < schedulerDataRefLocal.length - 1; i++) {
      let parent = schedulerDataRefLocal[i];

      //CASE : If next parent is fixed, skip (fixed parents can't be shifted)
      if (schedulerDataRefLocal[i + 1] && schedulerDataRefLocal[i + 1].isFixed) {
        continue;
      }

      console.log(`Processing parent ${parent.mediaEpisode.Title} at index ${i} with SlotDateTime ${parent.SlotDateTime}`);

      // Calculate real children end time (excluding OverRun/UnderRun footers)
      let childrenEndTime = parent.SlotDateTime;
      parent.children.forEach(c => {
        if (c.Type != SCHEDULETYPE.OverRun && c.Type != SCHEDULETYPE.UnderRun) {
          childrenEndTime += c.Duration;
        }
      });

      // Shift next parent's start time to close the gap
      schedulerDataRefLocal[i + 1].SlotDateTime = childrenEndTime;
      console.log(`Shifting parent ${parent.mediaEpisode.Title} at index ${i + 1} to ${childrenEndTime}`);
      changedParentIndexes.add(i + 1);
      footerCount++;

    }
    // PASS 2: Re-ripple ALL parents (strips old footers, recalculates children,
    // and only creates new footers if gaps remain - which there shouldn't be)
    for (let i = 0; i < schedulerDataRefLocal.length; i++) {
      schedulerDataRefLocal[i].children = getRippleChildrens(
        schedulerDataRefLocal[i],
        schedulerDataRefLocal[i].children,
        schedulerDataRefLocal
      );
    }

    // Update UI state once
    schedulerDataRefSetter(schedulerDataRefLocal);

    // Save all changed headers to backend and broadcast via socket
    for (let idx of changedParentIndexes) {
      updateHeaderSocket(schedulerDataRefLocal[idx]);
      await saveSchedule({
        dataToSave: [schedulerDataRefLocal[idx], ...schedulerDataRefLocal[idx].children]
      });
    }

    setStatusMessage(footerCount + ` ${lang.footer_deleted_msg_scheduling}`);
    if (footerCount == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_footer_to_deleted_error_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.all_footer_deleted_error_message });
    }
  };


  const deleteFooter = async (selectedItem) => {
    console.log("deletefooter");

    try {
      selectedStateRefSetter([]);
      var schedulerDataRefLocal = [...schedulerDataRef.current.sort((a, b) => a.SlotDateTime - b.SlotDateTime)];
      let canDeleteFooter = SchedulingHelper.canDeleteFooter(selectedItem, schedulerDataRefLocal);
      if (!canDeleteFooter) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot delete footer because next item is fixed / locked" });
        return;
      }
      var parent = SchedulingHelper.getParent(
        selectedItem.ParentProgramSchedule_id,
        schedulerDataRefLocal
      );
      var nextParent = SchedulingHelper.getNextParent(
        parent,
        schedulerDataRefLocal
      );
      var nextParentIndex = schedulerDataRefLocal.indexOf(nextParent);
      var currentParentIndex = schedulerDataRefLocal.indexOf(parent);

      // STEP 1: Calculate real children end time (same as deleteAllFooter)
      let childrenEndTime = parent.SlotDateTime;
      parent.children.forEach(c => {
        if (c.Type != SCHEDULETYPE.OverRun && c.Type != SCHEDULETYPE.UnderRun) {
          childrenEndTime += c.Duration;
        }
      });

      // STEP 2: Shift nextParent SlotDateTime FIRST so getRippleChildrens sees no gap
      if (nextParent && nextParentIndex > -1) {
        schedulerDataRefLocal[nextParentIndex].SlotDateTime = childrenEndTime;
      }

      // STEP 3: Ripple current parent (no gap with shifted nextParent = no footer re-created)
      if (currentParentIndex > -1) {
        schedulerDataRefLocal[currentParentIndex].children = getRippleChildrens(
          schedulerDataRefLocal[currentParentIndex],
          schedulerDataRefLocal[currentParentIndex].children,
          schedulerDataRefLocal
        );
      }

      // STEP 4: Ripple nextParent children from the new shifted start time
      if (nextParent && nextParentIndex > -1) {
        schedulerDataRefLocal[nextParentIndex].children = getRippleChildrens(
          schedulerDataRefLocal[nextParentIndex],
          schedulerDataRefLocal[nextParentIndex].children,
          schedulerDataRefLocal
        );

        // via socket updating header in planning and scheduling on footer delete
        updateHeaderSocket(schedulerDataRefLocal[nextParentIndex]);
        saveSchedule({ dataToSave: [schedulerDataRefLocal[nextParentIndex], ...schedulerDataRefLocal[nextParentIndex].children] });
      }

      // STEP 5: Update UI state once after both parents are rippled
      schedulerDataRefSetter(schedulerDataRefLocal);

      scheduleLog([selectedItem], LOGEVENT.DELETE_FOOTER);

    } catch (error) {
      console.log(error)
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error });
    }
  };


  const deleteFooterOld = async (selectedItem) => {
    console.log("deletefooter");

    try {
      selectedStateRefSetter([]);
      var schedulerDataRefLocal = schedulerDataRef.current;
      let canDeleteFooter = SchedulingHelper.canDeleteFooter(selectedItem, schedulerDataRefLocal);
      if (!canDeleteFooter) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot delete footer because next item is fixed / locked" });
        return;
      }
      var parent = SchedulingHelper.getParent(
        selectedItem.ParentProgramSchedule_id,
        schedulerDataRefLocal
      );
      var nextParent = SchedulingHelper.getNextParent(
        parent,
        schedulerDataRefLocal
      );
      var nextParentIndex = schedulerDataRef.current.indexOf(nextParent);

      deleteScheduleItems([selectedItem]);

      // Setting Header Start Time First and then rrippling its children

      if (nextParent) {
        schedulerDataRefLocal[nextParentIndex].SlotDateTime =
          selectedItem.SlotDateTime;
        schedulerDataRefLocal[nextParentIndex].children = getRippleChildrens(
          nextParent,
          nextParent.children.filter((item) => item._id != selectedItem._id),
          schedulerDataRefLocal
        );

        schedulerDataRefSetter(schedulerDataRefLocal);
        console.log(schedulerDataRefLocal[nextParentIndex]);

        // via socket updating header in planning and scheduling on footer delete
        updateHeaderSocket(schedulerDataRefLocal[nextParentIndex]);

        saveSchedule({ dataToSave: [schedulerDataRefLocal[nextParentIndex], ...schedulerDataRefLocal[nextParentIndex].children] });
      }

      let currentParentIndex = schedulerDataRefLocal.indexOf(parent);
      if (currentParentIndex > -1) {

        // ripple current header
        schedulerDataRefLocal[currentParentIndex].children = getRippleChildrens(
          parent,
          parent.children.filter((item) => item._id != selectedItem._id),
          schedulerDataRefLocal
        );

      }

      scheduleLog([selectedItem], LOGEVENT.DELETE_FOOTER);

    } catch (error) {
      console.log(error)
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error });
    }
  };

  const MySecondaryEventCountCell = (props) => {
    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.6em",
        size: "2.6em",
        marginRight: "0.12em",
      };
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        <SecondaryEventIcon style={IconsStyle(props.style.color)} />
        <span style={{ fontWeight: "400", fontSize: "14px" }}>
          {props.dataItem?.Prototypes?.length ?? 0}
        </span>
      </td>
    );
  };

  const MyMamAssetIconCell = (props) => {
    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.6em",
        size: "2.6em",
        marginRight: "0.12em",
      };
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        {props.dataItem?.Mam?._id && <TheatersIcon style={IconsStyle(props.style.color)} />}
      </td>
    );
  };

  const MySCTEMarkerCell = (props) => {

    // ROCK SCTE
    // CUE TONE IN-International
    // CUE TONE OUT-International
    // CUE2 OFF
    // CUE2 ON

    const markers = {
      SCTE_START: props.col && props.col == "Cue Tones" ? "CUE TONE IN" : "SCTE START",
      SCTE_END: props.col && props.col == "Cue Tones" ? "CUE TONE OUT" : "SCTE END",
      SCTE_BOTH: props.col && props.col == "Cue Tones" ? "CUE TONE IN/OUT" : "SCTE START/END",
    }

    let scteValue = props.dataItem?.SCTEType == SCTE_TYPE.SCTE_START ? markers.SCTE_START :
      props.dataItem?.SCTEType == SCTE_TYPE.SCTE_END ? markers.SCTE_END : props.dataItem?.SCTEType == SCTE_TYPE.SCTE_BOTH ? markers.SCTE_BOTH : "";


    return (
      <MyStatusCell {...props} title={scteValue} titleColor="black" tileBackColor="white" />
    );
  };

  const MyRouterCommandCell = (props) => {
    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.6em",
        size: "2.6em",
        marginRight: "0.12em",
      };
    };

    const routerCommand = props.dataItem?.RouterCommand;
    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        {routerCommand && routerCommand.length > 0 && <RouterIcon style={IconsStyle(props.style.color)} titleAccess={routerCommand} />}
      </td>
    );
  };

  const MySubtitleCell = (props) => {

    let hasSubtitle = false;

    if (props.dataItem?.Type == SCHEDULETYPE.Header) {
      hasSubtitle = props.dataItem?.segment?.Subtitle
    } else if (props.dataItem?.Type == SCHEDULETYPE.Segment) {
      let parent = SchedulingHelper.getParent(props.dataItem.ParentProgramSchedule_id, schedulerDataRef.current);
      if (parent) {
        hasSubtitle = parent?.segment?.Subtitle
      }
    }

    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.8em",
        size: "2.8em"
      };
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        {hasSubtitle && <ClosedCaptionIcon style={IconsStyle(props.style.color)} />}
      </td>
    );
  };

  const MyAnnouncementCountCell = (props) => {
    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.6em",
        size: "2.6em",
        marginRight: "0.12em",
      };
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        <MicIcon style={IconsStyle(props.style.color)} />
        <span style={{ fontWeight: "400", fontSize: "14px" }}>
          {props.dataItem?.Announcements?.length ?? 0}
        </span>
      </td>
    );
  };

  const MAMAssetStatusCell = (props) => {

    //SHOWING STATUS ACCORDING TO THE IMPORTED MAM ASSET.

    let value = "";
    let status = MAM_ASSET_REPORT_STATUS.MISSING

    if (props.dataItem?.Type == SCHEDULETYPE.Header && props.dataItem?.Segment_id) {
      status = props.dataItem?.segment?.MamAsset?.Status
    } else {
      status = props.dataItem?.mediaEpisode?.MamAsset?.Status
    }

    value = utility.getKeyByValue(MAM_ASSET_REPORT_STATUS, status);
    let tileBackColor = status == MAM_ASSET_REPORT_STATUS.TXREADY ? "#5CB338" :
      status == MAM_ASSET_REPORT_STATUS.MISMATCH_DURATION ? "#D39D55" :
        status == MAM_ASSET_REPORT_STATUS.MISSING ? "#FB4141" :
          "#FFFFFF";

    return <MyStatusCell {...props} title={value} tileBackColor={tileBackColor} />
  };

  const MyTXReadyImageCell = (props) => {
    var isVisibleInCell = false;
    var isTXReady = false;
    // console.log('here')
    // console.log(props.dataItem)

    if (props.dataItem.Type == SCHEDULETYPE.Segment) {
      isVisibleInCell = true;
      isTXReady = props.dataItem.TXReady
    } else if (props.dataItem.Type == SCHEDULETYPE.ShortForm) {
      isVisibleInCell = true
      isTXReady = props.dataItem.mediaEpisode.TXReady ?? false
    } else {
      isVisibleInCell = false
    }

    const IconsStyle = (color) => {
      return {
        color: color ?? "#E28C00",
        fontSize: "1.6em",
        size: "2.6em",
        // backgroundColor : 'white'
      };
    };

    return (
      <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...{
          [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        {...useTableKeyboardNavigation(props.id)}
        style={props?.style ?? {}}
      >
        {isVisibleInCell ? isTXReady ?
          <CheckCircleIcon style={IconsStyle('black')} /> :
          <CancelIcon style={IconsStyle('black')} /> : ''
        }
      </td>
    );
  };


  const createPayload = async (date = props.selectedScheduleDate, channelSid = props.selectedChannelSID) => {
    // let offsettime = PlanningHelper.getOffSetTimeWithTimeZone({ SID: channelSid });
    payloadref.current = SchedulingHelper.getPayload(
      date,
      channelSid,
      offsetTime
    );
  };

  const loaddata = async (isFromSocket = false, isFromDraft = false, draftSchedule = []) => {
    // try {
    await updateScheduleColorPreferenceOnFirstLoad();

    if (
      !payloadref.current.channelSID ||
      !payloadref.current.ScheduleDate ||
      !payloadref.current.ScheduleEndDate
    ) {
      return;
    }

    let lastParentExpandedValues = getlastparentExpandedStatus();
    setSelectedHeader({});
    selectedStateRefSetter([]);
    copyPasteDataItemSetter([]);
    setSelectedHeadersDataItems([]);
    setShowFilterGrid(false);
    !isFromSocket && schedulerDataRefSetter([]);
    !isFromSocket && setIsSchduleLoading(true);

    //columns
    var currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
    var columns = await API.getFormData(
      ENTITYNAME.SCHEDULE_MAIN_GRID,
      currentUserId
    );
    console.log(columns);

    if (!columns) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.there_are_some_at_server_side_please_contact_admin });
      return;
    }

    setDataColumns(columns);

    setStatusMessage(`${lang.loading_schedule_please_wait_msg_scheduling}`);
    var json = { success: false, data: [], message: 'failed' };
    if (isFromDraft) {
      json = { success: true, data: draftSchedule, message: 'success' };
    } else {
      json = await API.getScheduling(payloadref.current);
    }
    setStatusMessage(() => `${lang.loading_schedule_completed_msg_scheduling}`);
    console.log(json);
    console.log(payloadref.current);

    if (!json || json?.success == false) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: json?.message });
      return;
    }

    var parentData = json.data.filter((data) => {
      if (!data.ParentProgramSchedule_id) {
        return data;
      }
    });

    var orderedParent = parentData.sort(
      (a, b) => a.SlotDateTime - b.SlotDateTime
    );

    var finalData = [];

    for (var i = 0; i < orderedParent.length; i++) {
      var parent = orderedParent[i];
      var style = SchedulingHelper.getScheduleColorPreference(parent);
      parent.Style = style;
      // 1st level children
      var childrens = json.data
        .filter((maindata) => (maindata.ParentProgramSchedule_id == parent._id && maindata.Type != SCHEDULETYPE.Header))
        .sort((a, b) => a.SlotDateTime - b.SlotDateTime);
      var rippledChildrens = getRippleChildrens(
        parent,
        childrens,
        orderedParent,
        false
      );

      //to update info in header
      parent.Info = "";
      parent.SegmentCount = rippledChildrens.filter(x => x.Type == SCHEDULETYPE.Segment)?.length ?? 0;
      let lastRippleChildren = rippledChildrens[rippledChildrens.length - 1];
      if (lastRippleChildren?._id.includes("footer")) {
        parent.Info = setHeaderInfo(lastRippleChildren);
      }

      //expanded value
      parent.expanded = lastParentExpandedValues.find((item) => item._id == parent._id)?.expanded;

      // 2nd level children
      var childrensWithBreakChildrens = rippledChildrens.map((child) => {
        // if child is break
        if (child[IS_BREAK]) {
          var breakChildrens = json.data
            .filter(
              (breakChild) => (breakChild.ParentProgramSchedule_id == child._id && breakChild.Type != SCHEDULETYPE.Header)
            )
            .sort((a, b) => a.SlotDateTime - b.SlotDateTime);
          breakChildrens = getRippleBreakChildrens(child, breakChildrens);

          //to update info in break header
          let lastBreakRippleChildren =
            breakChildrens[breakChildrens.length - 1];
          child.Info = "";
          if (lastBreakRippleChildren?._id.includes("footer")) {
            child.Info = setHeaderInfo(lastBreakRippleChildren);
          }

          return { ...child, children: breakChildrens };
        } else {
          return child;
        }
      });

      finalData.push({
        ...parent,
        BreakNo: 0,
        children: childrensWithBreakChildrens,
      });
    }

    schedulerDataRefSetter(finalData);
    console.log(finalData);

    setScheduleTimeInfoValues(finalData, json.prevScheduleDayEndTime);


    setIsSchduleLoading(false);

    setTimeout(() => {

      treeListRef.current?.element?.scrollTo({
        left: 0, top: scrollPosition?.current, behavior: 'smooth'
      });
    }, 500);

    // } catch (error) {
    //     console.log("error", error);
    // }
  };

  const loadCombo = async () => {

    var mediaCategoryData = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    var filterMedia = mediaCategoryData.data.filter((obj) => obj.isLong === false);
    setMediaCategory(filterMedia);


    var mediaCategoryTypeData = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    setMediaCategoryType(mediaCategoryTypeData.data);

    let txStatusRes = await API.getDataLookup(ENTITYNAME.TXStatus, { sort: { SID: 1 } });
    setTxStatusData(txStatusRes.data);

    //this code is for?
    if (props.item?.SID > 0) {
      var mediaCategoryTypeTemp = mediaCategoryTypeData.data.filter((x) => x.MediaCategorySID == props.item.MediaCategory.SID);
      setFilterMediaCategoryType(mediaCategoryTypeTemp);
    }
  };

  const getlastparentExpandedStatus = () => {
    return schedulerDataRef.current.map((item, index) => {
      return { _id: item._id, expanded: item.expanded, index: index }
    })
  }

  const setHeaderInfo = (lastRippleChildren) => {
    return lastRippleChildren.Type == SCHEDULETYPE.OverRun
      ? OVERRUN +
      "-" +
      utility.convertMilisecondsToStringWithFrames(
        lastRippleChildren.Duration
      )
      : UNDERRUN +
      "-" +
      utility.convertMilisecondsToStringWithFrames(
        lastRippleChildren.Duration
      );

  }

  const setScheduleTimeInfoValues = (finalData, prevScheduleDayEndTime) => {

    let previousScheduleDayEndDateTime = prevScheduleDayEndTime == undefined || prevScheduleDayEndTime == 0
      ? 0 : prevScheduleDayEndTime;

    if (finalData.length > 0) {

      if (finalData[0]?.children.length > 0) {
        var firstChildren = finalData[0]?.children[0];
        var lastChildren = finalData[finalData.length - 1].children.length > 0 ?
          finalData[finalData.length - 1].children[finalData[finalData.length - 1].children.length - 1] :
          finalData[finalData.length - 2].children[finalData[finalData.length - 2].children.length - 1];
        props.setScheduleTimeInfo((old) => {
          return {
            StartDateTime: firstChildren.SlotDateTime,
            EndDateTime: lastChildren ? lastChildren.SlotDateTime + lastChildren.Duration : 0,
            PreviousScheduleEndDateTime: prevScheduleDayEndTime ? previousScheduleDayEndDateTime : old.PreviousScheduleEndDateTime,
          }
        })
      }
      else {
        props.setScheduleTimeInfo((old) => {
          return {
            StartDateTime: finalData[0].SlotDateTime,
            EndDateTime: finalData[0].SlotDateTime + finalData[0].Duration,
            PreviousScheduleEndDateTime: prevScheduleDayEndTime ? previousScheduleDayEndDateTime : old.PreviousScheduleEndDateTime,
          }
        })
      }
    } else {
      props.setScheduleTimeInfo({
        StartDateTime: 0,
        EndDateTime: 0,
        PreviousScheduleEndDateTime: previousScheduleDayEndDateTime,
      })

    }

  }

  // auto save is true by default
  const addScheduleItems = async (destinationDataItem, dataItems, autoSave = true, isProgramInProgram = false) => {
    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    const itemInfo = SchedulingHelper.getChildInfo(destinationDataItem, schedulerDataRef.current);

    if (itemInfo.isBreak || itemInfo.isInsideBreak) {

      let breakHeader = schedulerDataRef.current[itemInfo.level_0_index].children[itemInfo.level_1_index];

      if (!breakHeader.mediaEpisode.AllowAllCateogries && dataItems.some(item => item.mediaEpisode.MediaCategory.SID != breakHeader.mediaEpisode.MediaCategory.SID)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_choose_right_media_categor_error_message });
        if (dataItems.some(item => item.Source == "Booking")) {
          props.loadBookingCommercialdata();
        }
        return;
      }
    }

    const destinationItemInfo = SchedulingHelper.getDestinationItemInfo(itemInfo);
    const { level_0_index, level_1_index, level_2_index } = destinationItemInfo;
    //console.log({ level_0_index, level_1_index, destinationDataItem });
    let schedulerDataLocal = [...schedulerDataRef.current];
    let dataToSave = [];

    if (destinationItemInfo.insertType == SCHEDULE_CHILDREN_TYPE.break_children && !dataItems.some(x => x.IsBreak)) {
      //adding
      schedulerDataLocal[level_0_index].children[level_1_index].children.splice(level_2_index, 0, ...dataItems);
      //rippling
      dataToSave = schedulerDataLocal[level_0_index].children[level_1_index].children = getRippleBreakChildrens(schedulerDataLocal[level_0_index].children[level_1_index], schedulerDataLocal[level_0_index].children[level_1_index].children);
    } else {
      //adding
      //console.log(schedulerDataLocal[level_0_index].children);

      //Pull Mam field out of Media Episode Obj
      let items = dataItems.map((item) => {
        let newItem = { ...item, Mam: item?.mediaEpisode?.Mam ?? {} };
        return newItem;
      })

      schedulerDataLocal[level_0_index].children.splice(level_1_index, 0, ...items);
      //console.log(schedulerDataLocal[level_0_index].children);
      //rippling
      dataToSave = schedulerDataLocal[level_0_index].children = getRippleChildrens(schedulerDataLocal[level_0_index], schedulerDataLocal[level_0_index].children, schedulerDataLocal);
    }

    //ui
    // also inserting elements in filtergrid ui if it is open
    if (showFilterGrid) {
      const filterGridDataLocal = [...showFilterGridDataRef.current];
      const destinationItemIndex = filterGridDataLocal.findIndex(item => item._id == destinationDataItem._id);
      if (destinationItemIndex == -1) {
        filterGridDataLocal.push(...dataItems);
      } else {
        filterGridDataLocal.splice(destinationItemIndex + 1, 0, ...dataItems);
      }
      setShowFilterGridData(filterGridDataLocal);
    }
    schedulerDataRefSetter(schedulerDataLocal);


    // saving rippled data in database
    if (autoSave) {
      //console.log(dataToSave);
      await saveSchedule({
        destinationItemInfo: destinationItemInfo,
        dataToSave: dataToSave,
        deletedSchedules: [],
        isProgramInProgram: isProgramInProgram
      });
    }

    //logging
    //debugger
    scheduleLog(dataItems, LOGEVENT.SAVE_SCHEDULING);

  }

  const scheduleLog = (dataItems, logEvent) => {

    //console.log(dataItems);
    //console.log(logEvent);

    dataItems.map((item) => {
      let logData = {
        event: logEvent,
        data: item,
        message: logEvent,
        module: MODULE.SCHEDULING,
      };
      API.SaveLogs(logData);
    });
  }

  const removeItemsFromFilterGrid = (dataItems) => {

    let filterGridData = showFilterGridDataRef.current.filter(item => !dataItems.some(item2 => item2._id == item._id));
    setShowFilterGridData(filterGridData);
    if (filterGridData.length == 0 && filterSearchWordRef.current.length == 0) {
      setShowFilterGrid(false);
    }
  }

  const deleteScheduleItems = async (dataItems, deleteFromDatabase = false, isInternal = false) => {
    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    showFilterGridRef.current && removeItemsFromFilterGrid(dataItems);

    await deleteScheduleItemsExecute(dataItems, deleteFromDatabase, isInternal);

    let selectedChannel = getSelectedChannel();

    socket?.emit(SOCKET_EVENTS.onSocketData, {
      action: SOCKET_ACTION.SCHEDULE_DELETEITEM,
      module: MODULE.SCHEDULING,
      data: {
        selectedChannelSID: selectedChannel.SID,
        selectedScheduleDate: props.selectedScheduleDate,
        dataItems: dataItems
      },
      user: { name: user.name, _id: user._id }
    });

    scheduleLog(dataItems, LOGEVENT.DELETE_SCHEDULING);

  }

  const deleteScheduleItemsExecute = async (dataItems, deleteFromDatabase = false, isInternal = false) => {

    // removing duplicate enrty
    if (dataItems && dataItems.length > 0) {
      dataItems = Array.from(new Set(dataItems));
    }

    const schedulerDataLocal = [...schedulerDataRef.current];

    var deleteIndexes = [];

    dataItems.map((item) => {
      let {
        isHeader,
        isInsideBreak,
        isBreak,
        level_0_index,
        level_1_index,
        level_2_index,
      } = SchedulingHelper.getChildInfo(item, schedulerDataLocal);
      console.log(item);
      console.log(isHeader);
      if (isInsideBreak) {
        deleteIndexes.push([level_0_index, level_1_index, level_2_index]);
      } else if (isHeader) {
        deleteIndexes.push([level_0_index]);
      } else {
        console.log("Here i found");
        deleteIndexes.push([level_0_index, level_1_index]);
      }
    });

    // finally removing items by indexes
    const newDeleteIndexes = deleteIndexes
      .sort((a, b) => b[2] - a[2])
      .sort((a, b) => b[1] - a[1])
      .sort((a, b) => b[0] - a[0]);
    console.log(newDeleteIndexes);

    let uniqueParentIndex = [];


    newDeleteIndexes.map((index) => {
      if (index.length == 1) { // OK IT is Header
        schedulerDataLocal.splice(index[0], 1);
      } else if (index.length == 2) { // IT iS from commercial and segments
        schedulerDataLocal[index[0]].children.splice(index[1], 1);
        //ripple
        let parent = schedulerDataLocal[index[0]];
        let children = schedulerDataLocal[index[0]].children;
        schedulerDataLocal[index[0]].children = getRippleChildrens(parent, children, schedulerDataLocal);

        // adding in unique parent Index For saving children in schedule
        if (!uniqueParentIndex.includes(index[0])) uniqueParentIndex.push(index[0]);

      } else if (index.length == 3) { //IT is from break
        schedulerDataLocal[index[0]].children[index[1]].children.splice(index[2], 1);

        //ripple
        let parent = schedulerDataLocal[index[0]].children[index[1]];
        let children = schedulerDataLocal[index[0]].children[index[1]].children;
        schedulerDataLocal[index[0]].children[index[1]].children = getRippleBreakChildrens(parent, children);

        // saving children directly if it is inside break
        if (deleteFromDatabase) saveSchedule({ dataToSave: schedulerDataLocal[index[0]].children[index[1]].children });
      }
    });


    // Final Saving Children In DB
    if (deleteFromDatabase) {
      var finalSaveChildrenArray = [];
      uniqueParentIndex.map((pi) => {
        finalSaveChildrenArray = [...finalSaveChildrenArray, ...schedulerDataLocal[pi].children];
      });
      saveSchedule({ dataToSave: finalSaveChildrenArray });
    }

    // setting UI
    schedulerDataRefSetter(schedulerDataLocal);

    //reset
    selectedStateRefSetter([]);

    // updating in DB
    if (deleteFromDatabase) await saveSchedule({ deletedSchedules: dataItems });


    //refeshing booking
    if (dataItems.length > 0 && !isInternal && dataItems.some((item) => item.Booking_id || item.Source == "Booking")) {
      props.loadBookingCommercialdata();

      //ADD LOG
      SalesHelper.removeBookingLogFromSchedule(dataItems);
    }

  };

  const saveSchedule = async ({ destinationItemInfo, dataToSave = [], deletedSchedules = [], isProgramInProgram = false }) => {

    savingSchedule = true;
    let response = await API.saveSchedule({
      schedules: SchedulingHelper.prepareDataforbackend(dataToSave, isProgramInProgram),
      deletedschedules: SchedulingHelper.prepareDataforbackend(deletedSchedules),
    });
    // console.log(response)

    // after update need to set saved elements on UI,
    // ONLY ON NEW ITEMS ADDITION, NO Need In Case of Deleted Items
    if (response.success && dataToSave.length > 0 && destinationItemInfo) {
      const { level_0_index, level_1_index } = destinationItemInfo;
      let schedulerDataLocal = [...schedulerDataRef.current];

      //assuming during insertion and update full children would be ppassing to update the ripple time;
      response.data.savedschedules.map((res, i) => {

        if (res.success && res.message == "inserted") {

          if (destinationItemInfo.insertType == SCHEDULE_CHILDREN_TYPE.break_children && !res.data.IsBreak) {
            schedulerDataLocal[level_0_index].children[level_1_index].children[i]._id = res.data._id;
          }
          else {
            schedulerDataLocal[level_0_index].children[i]._id = res.data._id;
          }

          // setting updated values on UI binded property and reference.
          schedulerDataRefSetter(schedulerDataLocal);
        }
      });

      savingSchedule = false;

      let selectedChannel = getSelectedChannel();

      //notification to other client.
      socket?.emit(SOCKET_EVENTS.onSocketData,
        {
          action: SOCKET_ACTION.SCHEDULE_ADDITEM,
          module: MODULE.SCHEDULING,
          data: {
            selectedChannelSID: selectedChannel.SID,
            selectedScheduleDate: props.selectedScheduleDate,
            insertType: destinationItemInfo.insertType,
            level_0_index: level_0_index,
            level_1_index: level_1_index,
            children: destinationItemInfo.insertType == SCHEDULE_CHILDREN_TYPE.break_children ? schedulerDataLocal[level_0_index].children[level_1_index].children : schedulerDataLocal[level_0_index].children

          },
          user: { name: user.name, _id: user._id }
        });

    }
    else if (!response.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }

    savingSchedule = false;


  };

  const getRippleChildrens = (parent, childrens, allParentsData, isUpdateHeader = true) => {
    var startTime = parent.SlotDateTime;

    // removing under rover run if exists
    childrens = childrens.filter((data) => {
      if (
        data.Type != SCHEDULETYPE.OverRun &&
        data.Type != SCHEDULETYPE.UnderRun
      ) {
        return data;
      }
    });

    var index = 0;
    var rippledChildren = childrens.map((item) => {

      let breakNumber = item.Type == SCHEDULETYPE.Segment ? utility.getPositionIndex(item.Position) : item.BreakNo;

      item.ScheduleDate = startTime;
      item.SlotDateTime = startTime;
      startTime = startTime + item.Duration;
      item.Prototypes = item.Prototypes ?? [];
      item.Announcements = item.Announcements ?? [];
      item.Style = SchedulingHelper.getScheduleColorPreference(item);
      item.local_id = parent._id.toString() + "_" + index++;
      item.EndSlotDateTime = item.SlotDateTime + item.Duration;
      item.BreakNo = breakNumber;

      return item;
    });

    var nextParent = SchedulingHelper.getNextParent(parent, allParentsData);

    if (nextParent) {
      var footer = SchedulingHelper.getFooter(
        parent,
        rippledChildren,
        nextParent,
        selectedChannel
      );

      if (footer) {
        footer.Style = SchedulingHelper.getScheduleColorPreference(footer);
        footer.local_id = parent._id.toString() + "_" + index;
        footer.EndSlotDateTime = footer.SlotDateTime + footer.Duration;

        rippledChildren.push(footer);
        isUpdateHeader && updateParentInfo(parent, footer);
      }
      else {
        // no footer means all OK.
        updateParentInfo(parent, undefined);
      }
    }

    try {
      var parentIndex = allParentsData.findIndex((x) => x.Type == SCHEDULETYPE.Header && x._id == parent._id);

      //FOR LAST PARENT 
      if (parentIndex == allParentsData.length - 1) {
        setScheduleTimeInfoValues(schedulerDataRef.current)
      }


    } catch (error) {
      console.log(error)
    }

    return rippledChildren;
  };

  const getRippleBreakNo = (scheduleData) => {

    if (!scheduleData || scheduleData.length == 0) return [];

    let rippledScheduleData = scheduleData.map((header) => {
      let breakNo = 0;
      let newHeader = { ...header };

      newHeader.children = newHeader.children.map((child) => {

        if (child.Type == SCHEDULETYPE.Segment) {
          breakNo = child.BreakNo;
        } else {
          child.BreakNo = breakNo;
        }

        return child;

      })

      return newHeader;
    })

    return rippledScheduleData;

  }


  const updateParentInfo = (parent, footer) => {
    try {

      let schedulerDataRefLocal = schedulerDataRef.current;
      if (schedulerDataRefLocal.length == 0) return;

      let { level_0_index, level_1_index, isHeader } =
        SchedulingHelper.getChildInfo(parent, schedulerDataRefLocal);

      let info = ''
      if (footer != undefined) {
        info = setHeaderInfo(footer);
      }


      if (isHeader) {
        if (schedulerDataRefLocal[level_0_index]) schedulerDataRefLocal[level_0_index]["Info"] = info ?? '';
      } else {
        if (schedulerDataRefLocal[level_0_index] && schedulerDataRefLocal[level_0_index].children[level_1_index]) schedulerDataRefLocal[level_0_index].children[level_1_index]["Info"] = info ?? '';
      }

      schedulerDataRefSetter(schedulerDataRefLocal);
    } catch (e) {
      alert(e)
    }
  };

  const getRippleBreakChildrens = (parent, childrens, isUpdateHeader = true) => {
    var startTime = parent.SlotDateTime;
    childrens = childrens.filter((data) => {
      if (
        data.Type != SCHEDULETYPE.OverRun &&
        data.Type != SCHEDULETYPE.UnderRun
      ) {
        return data;
      }
    });
    var index = 0;
    var rippledChildren = childrens.map((item) => {
      item.ScheduleDate = startTime;
      item.SlotDateTime = startTime;
      startTime = startTime + item.Duration;
      item.Style = SchedulingHelper.getScheduleColorPreference(item);
      item.local_id = parent._id.toString() + "_" + index++;
      item[IS_BREAK_CHILDREN] = true;
      item.EndSlotDateTime = item.SlotDateTime + item.Duration;
      return item;
    });

    var footer = SchedulingHelper.getBreakFooter(
      parent,
      childrens,
      selectedChannel
    );

    if (footer) {
      footer.Style = SchedulingHelper.getScheduleColorPreference(footer);
      footer.local_id = parent._id.toString() + "_" + index++;
      footer.EndSlotDateTime = footer.SlotDateTime + footer.Duration
      rippledChildren.push(footer);
      isUpdateHeader && updateParentInfo(parent, footer);
    }
    else {
      // no footer means packed schedule so we will update info column as blank
      updateParentInfo(parent, undefined);
    }

    return rippledChildren;
  };

  // on drop end

  //grid rowRender start==============================================

  const GridRowRenderFilterGrid = (tr, props) => {

    const trProps = {
      style: props.dataItem.Style,
      draggable: false,
      onDragOver: (e) => {
        e.preventDefault();
      },
      onContextMenu: (e) => {
        e.preventDefault();
        fg.current?.show(e)
        hcm.current?.hide(e);
        bc.current?.hide(e);
        cm.current?.hide(e);
        scteg.current?.hide(e);
        schedulerChildrenFilterRef.current =
          props.children[e.target.cellIndex].props;
        let dataToSelect =
          selectedStateRef.current.length > 1
            ? selectedStateRef.current
            : [props.dataItem];

        selectedStateRefSetter(dataToSelect);
      },
      onDrop: (e) => onRowDrop(e, props.dataItem),
    };
    if (!props.dataItem[IS_BREAK]) {
      var children = tr.props.children.map((d, i) => {
        if (i !== 0) {
          return d;
        } else {
          return d;

          // BP-5853 : On Schedule Filter Grid value of first column is not showing -- Commenting for now
          // return <th className="k-header k-hierarchy-cell k-header"></th>;
        }
      });
      return React.cloneElement(tr, { ...trProps }, children);
    } else {
      return React.cloneElement(tr, { ...trProps }, tr.props.children);
    }
  };

  const GridRowRenderSCTEGrid = (tr, props) => {

    const trProps = {
      style: props.dataItem.Style,
      draggable: false,
      onDragOver: (e) => {
        e.preventDefault();
      },
      onContextMenu: (e) => {
        e.preventDefault();
        scteg.current?.show(e);
        fg.current?.hide(e)
        hcm.current?.hide(e);
        bc.current?.hide(e);
        cm.current?.hide(e);


        schedulerChildrenFilterRef.current =
          props.children[e.target.cellIndex].props;
        let dataToSelect =
          selectedStateRef.current.length > 1
            ? selectedStateRef.current
            : [props.dataItem];

        selectedStateRefSetter(dataToSelect);
      },
    };
    if (!props.dataItem[IS_BREAK]) {
      var children = tr.props.children.map((d, i) => {
        if (i !== 0) {
          return d;
        } else {
          return d;
        }
      });
      return React.cloneElement(tr, { ...trProps }, children);
    } else {
      return React.cloneElement(tr, { ...trProps }, tr.props.children);
    }
  };

  const deleteUsedBooking = (draggedData) => {
    props.deleteUsedBooking(draggedData);

    let sltdChnnl = selectedChannel ? selectedChannel : getSelectedChannel();

    //emit
    socket?.emit(SOCKET_EVENTS.onSocketData,
      {
        action: SOCKET_ACTION.SCHEDULE_BOOKING_REFRESH,
        module: MODULE.SCHEDULING,
        data: {
          selectedChannelSID: sltdChnnl.SID,
          selectedScheduleDate: props.selectedScheduleDate,
          draggedData: draggedData
        },
        user: { name: user.name, _id: user._id }
      });
  };

  //grid rowRender end==============================================

  const onSelectionChange = (event, isVirtual = true, datatem) => {
    //console.log(event);
    const skip = isVirtual ? event.target.props.skip : 0;
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    //remove event.target.props.skip to remove virtual scrolling
    const rowIndex = event.startRowIndex + skip;
    const dataItems = event.dataItems;
    const dataItem = datatem ? datatem : dataItems[rowIndex];
    if (ctrlKey) {
      let alreadySelected = selectedState.some(
        (item) => item._id == dataItem._id
      );
      if (selectedState.some((item) => (item.Type == SCHEDULETYPE.OverRun || item.Type == SCHEDULETYPE.UnderRun))) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please unselect OverRun or UnderRun" });
        return;
      }

      if (alreadySelected) {
        selectedStateRefSetter(
          selectedState.filter((item) => item._id != dataItem._id)
        );
      } else {
        if (
          dataItem.Type == SCHEDULETYPE.OverRun ||
          dataItem.Type == SCHEDULETYPE.UnderRun
        ) {
          return;
        }
        selectedStateRefSetter([...selectedState, dataItem]);
      }
    }
    else if (shiftKey) {
      if (selectedState.some((item) => (item.Type == SCHEDULETYPE.OverRun || item.Type == SCHEDULETYPE.UnderRun))) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please unselect OverRun or UnderRun" });
        return;
      }
      handleShiftMultiSelect(dataItem);
    }
    else {

      let alreadySelected =
        selectedState.length == 1 && selectedState[0]._id == dataItem._id
          ? true
          : false;
      if (alreadySelected) {
        selectedStateRefSetter([]);
      } else {

        // Single Footer Can be Selecetd, Commented Code By Vishal 04 Apr 24
        // if (
        //   dataItem.Type == SCHEDULETYPE.OverRun ||
        //   dataItem.Type == SCHEDULETYPE.UnderRun
        // ) {
        //   return;
        // }
        selectedStateRefSetter([dataItem]);
      }


    }

    console.log(selectedStateRef.current);
  }

  const hideContextMenus = (e) => {
    hcm.current?.hide(e);
    cm.current?.hide(e);
    bc.current?.hide(e);
    fg.current?.hide(e);
    scteg.current?.hide(e);
  }


  const expandChange = (event) => {
    // console.log(event);
    event.dataItem[EXPAND_FIELD] = event.value;
    setCategories([...categories]);
    if (!event.value || event.dataItem.details) {
      return;
    }
    let index = event.dataIndex;
    setCategories(schedulerDataRef.current[index].children);
  };

  //RIPPLE HEADER
  const onHeaderRipple = async () => {

    // console.log(slotTime);
    // console.log(selectedStateRef.current);

    let parentIndex = schedulerDataRef.current.indexOf(selectedStateRef.current[0]);
    let localUpdatedSchedulerData = [...schedulerDataRef.current].slice(parentIndex, schedulerDataRef.current.length);

    let timeDifference = utility.convertStringWithFramesToMilliseconds(slotTime) - utility.convertStringWithFramesToMilliseconds((utility.convertMilisecondsToStringWithFrames(selectedStateRef.current[0].SlotDateTime)));

    for (let i = 0; i < localUpdatedSchedulerData.length; i++) {
      let event = localUpdatedSchedulerData[i];

      let slotTimeLocal = utility.convertMilisecondsToStringWithFrames(event.SlotDateTime);
      const [hours, minutes, seconds, frames] = slotTimeLocal.replaceAll('_', '0').split(':');
      let slotDate = new Date(event.SlotDateTime).setHours(parseInt(hours), parseInt(minutes), parseInt(seconds), parseInt(frames) * FrameEquivalentOfMilliSecond);

      let newSlotDateTime = utility.getLocalDateTimeToUtcMiliseconds(new Date(slotDate)) + timeDifference;

      let updatedData = {
        SID: event.SID,
        _id: event._id,
        ScheduleDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(event.SlotDateTime)),
        SlotDateTime: newSlotDateTime,
        EndSlotDateTime: newSlotDateTime + event.Duration,
        Segment_id: event?.Segment_id ?? null,
        customDuration: event?.customDuration ?? 0,
      }

      const validDayPart = await PlanningHelper.getValidDayPartForTimeBand(updatedData);

      let segments = event?.segments ?? [];

      //Edit in ProgramScheduleTable
      var res = await API.savePlanning(updatedData, segments, false, false, 0, validDayPart);
      if (res.success) {

        //default duation  from the main item
        updatedData.NominalDuration = event.Duration;
        updatedData.ActualDuration = event.Duration;

        //if selected segment changed.
        if (updatedData.Segment_id) {
          let segment = segments.find((seg) => seg._id == updatedData.Segment_id);
          if (segment) {
            updatedData.ActualDuration = segment.ActualDuration;
          }

        }

        await onUpdateFromPlanningEditForm(updatedData);

      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }

    };

    setShowHeaderRippleDialog(false);

  }

  const onUpdateFromPlanningEditForm = async (updatedData) => {

    // checking if updated slot date time is other schedule range 
    if (updatedData.SlotDateTime < payloadref.current.ScheduleDate || updatedData.SlotDateTime > payloadref.current.ScheduleEndDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot change header start time outside schedule 24 hour range" });
      return;
    }

    var parent = SchedulingHelper.getParent(
      updatedData._id,
      schedulerDataRef.current
    );
    var parentIndex = schedulerDataRef.current.indexOf(parent);

    let schedulerDataRefLocal = schedulerDataRef.current;
    schedulerDataRefLocal[parentIndex].SlotDateTime = updatedData.SlotDateTime;
    schedulerDataRefLocal[parentIndex].EndSlotDateTime = updatedData.EndSlotDateTime;

    // ripplig cureent item
    schedulerDataRefLocal[parentIndex].children = getRippleChildrens(
      schedulerDataRefLocal[parentIndex],
      schedulerDataRefLocal[parentIndex].children,
      schedulerDataRefLocal
    );

    // previous item if exist should also be rippled to update footer, not saved 
    if (parentIndex > 0) {
      schedulerDataRefLocal[parentIndex - 1].children = getRippleChildrens(
        schedulerDataRefLocal[parentIndex - 1],
        schedulerDataRefLocal[parentIndex - 1].children,
        schedulerDataRefLocal
      );
    }

    saveSchedule({ dataToSave: [schedulerDataRefLocal[parentIndex], ...schedulerDataRefLocal[parentIndex].children] });
    if (parentIndex == 0) {
      setScheduleTimeInfoValues(schedulerDataRefLocal);
    }


    // via socket updating header in schedule and planning for other users...
    updateHeaderSocket(schedulerDataRefLocal[parentIndex]);


  };

  const updateHeaderSocket = (udpatedHeader, isForDelete = false) => {

    // socket?.emit for updating planning on real time
    if (isForDelete) {
      socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_DELETE, module: MODULE.PLANNING, data: [udpatedHeader] });
    }
    else {
      socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_UPDATE, module: MODULE.PLANNING, data: { ...udpatedHeader, NominalDuration: udpatedHeader.Duration } })
    }

    // socket for updating other schedulers as well
    refreshScheduleSocket(payloadref.current.channelSID, payloadref.current.ScheduleDate);

  }

  const addHeaderInPlanningSocket = (udpatedHeader, newMediaEpisode) => {

    const planningObjectForUI = {
      ...udpatedHeader,
      Channel: selectedChannel,
      MediaEpisode_id: newMediaEpisode._id,
      ParentProgramSchedule_id: null,
      ActualDuration: newMediaEpisode.Duration,
      NominalDuration: newMediaEpisode.Duration,
      Description: newMediaEpisode.Description,
      ChannelSID: selectedChannel.SID,
      mediaEpisode: newMediaEpisode,
      Title: newMediaEpisode.Title,
      StartDate: new Date(udpatedHeader.SlotDateTime),
      EndTime: new Date(udpatedHeader.SlotDateTime + newMediaEpisode.Duration),
    }


    socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_NEW_DROP, module: MODULE.PLANNING, data: planningObjectForUI })

  }

  const refreshScheduleSocket = (channelSID, date) => {

    if (channelSID == 0) return;

    let userData = utility.getValue(LOCALSTORAGE_KEY.userData);
    socket?.emit(SOCKET_EVENTS.onSocketData, {
      action: SOCKET_ACTION.SCHEDULE_REFRESH,
      module: MODULE.SCHEDULING,
      data: {
        selectedChannelSID: channelSID, selectedScheduleDate: date
      },
      user: { name: userData.name, _id: userData._id }
    });
  }

  const HasChildrenLocal = (selectedheader) => {
    console.log(selectedheader);
    return selectedheader.children.some(
      (x) =>
        x.Type != SCHEDULETYPE.Segment &&
        ((x.Booking_id && x.Booking_id.length > 0) ||
          (x.children &&
            x.children.length > 0 &&
            x.children.some((c) => c.Booking_id && c.Booking_id.length > 0)))
    );
  };

  const HasReconciledChildrenLocal = (selectedheader) => {
    console.log(selectedheader);
    return selectedheader.children.some(
      (x) =>
        x.IsReconciled ||
        (x.children &&
          x.children.length > 0 &&
          x.children.some((c) => c.IsReconciled))
    );
  };

  const selectAllHeaders = () => {
    let headers = schedulerDataRef.current.filter((x) => x.Type == SCHEDULETYPE.Header);
    selectedStateRefSetter(headers);
    setSelectedHeadersDataItems(headers);
  }

  const scheduleHeaderDelete = async () => {

    if (!utility.isValidActionForUser(MODULE.SCHEDULING, USER_RESTRICTED_ACTIONS.CANNOTDELETEHEADER.SID)) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${lang.no_permission_to_delete_header_info} ${lang.please_contact_admin_message}` });
      return;
    }
    // delete footer
    if (!selectedHeader.current) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_header_firsts_error_message });
      return;
    }
    if (selectedHeader.current.isLocked) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Header is locked' });
      return;
    }
    console.log(selectedHeader);

    if (HasChildrenLocal(selectedHeader.current)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_delete_selected_header_contains_booked_commercials_error_message });
      return;
    }

    if (HasReconciledChildrenLocal(selectedHeader.current)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_delete_selected_header_contains_reconciled_items_error_message });
      return;
    }

    ConfirmAlert(
      async () => {
        deleteScheduleItems([selectedHeader.current], false);

        // socket
        updateHeaderSocket(selectedHeader.current, true);

        var deleteResp = await API.deletePlanning(selectedHeader.current);
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: deleteResp.message });
        // refreshing if delete not success.
        if (!deleteResp.success) {
          loaddata();
        }

      }, // on Click yes
      () => { }, // on click no
      `${lang.confirm_delete_header_confirm_alert_msg}`, //title
      `${lang.are_you_sure_you_want_to_delete_confirm_alert_msg} ${selectedHeader.current.mediaEpisode.Title
      } ${lang.header_from_confirm_alert_msg} ${moment(selectedHeader.current.SlotDateTime)
        .utc()
        .format("hh:mmA")}?` // message
    );
  };

  const setSelectedPlaceHolderMedia = async () => {

    let lastSchedulerItem = schedulerDataRef.current[schedulerDataRef.current.length - 1];

    if (
      !selectedStateRef.current.some(data => SchedulingHelper.canModify(data, schedulerDataRef.current)) &&
      lastSchedulerItem.children[lastSchedulerItem.children.length - 1]._id != selectedStateRef.current[0]._id
    ) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Header is locked, You can only insert Break by clicking last item." });
      return;
    }

    if (Object.keys(breakdataItemForPopup.MediaCategory).length == 0 || breakdataItemForPopup.MediaCategory == undefined || breakdataItemForPopup.MediaCategory == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select Media Category" });
      return;
    }
    if (Object.keys(breakdataItemForPopup.MediaCategoryType).length == 0 || breakdataItemForPopup.MediaCategoryType == undefined || breakdataItemForPopup.MediaCategoryType == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select Media Category Type " });
      return;
    }
    if (breakdataItemForPopup.Duration == "00:00:00:00") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Duration cant be 0" });
      return;
    }

    let duration = utility.convertStringWithFramesToMilliseconds(breakdataItemForPopup.Duration)
    const breakRes = await API.getBreakItemForSchedule(breakdataItemForPopup.MediaCategory, breakdataItemForPopup.MediaCategoryType, duration);
    console.log(breakRes);
    if (breakRes.success) {
      let mediaEpisode = breakRes.data;
      var destinationDataItem = selectedStateRef.current[0];
      const isParent =
        destinationDataItem.ParentProgramSchedule_id == null ||
        destinationDataItem.ParentProgramSchedule_id == undefined;
      var dataItem = SchedulingHelper.getBreakItem(
        isParent,
        destinationDataItem,
        mediaEpisode,
        mediaEpisode.Duration,
        selectedChannel
      );
      addScheduleItems(destinationDataItem, [dataItem]);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: breakRes.message });
    }

    setBreakdataItemForPopup(blankDataItem);
    setShowInsertPlaceHolderFilter(false);

  };

  //programe replacement
  const programReplacement = async (replaceDataItem) => {

    if (selectedHeader.current == {}) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_header_firsts_error_message });
      return;
    }

    if (replaceDataItem.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_one_program_to_replace_with_error_message });
      return;
    }
    var mediaEpisode = replaceDataItem[0];

    // checking rights
    const dealRights = await PlanningHelper.getMediaEpisodeDealRights(mediaEpisode);

    if (!PlanningHelper.isMediaEpisodeValidForThisChannel({ ...mediaEpisode, MediaDealRights: dealRights }, selectedChannel)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.media_not_valid_for_selected_channel_error_message });
      return;
    }

    var validMediaDealRight = PlanningHelper.getMediaDealRight(
      { ...mediaEpisode, MediaDealRights: dealRights },
      selectedHeader.current.SlotDateTime,
      selectedChannel
    );

    // here if media rights is more then one then it will return false and the popup to choose the media right
    if (validMediaDealRight == false) {
      setProgramToReplace(mediaEpisode);
      setShowMediaDealRightsPopup(true);
    } else {
      replaceProgram(mediaEpisode);
    }

  };

  const replaceProgramWithSelectedDealRight = (dataItem) => {
    if (dataItem.length > 0) {
      const selectedMediaDealRight = dataItem[0];
      replaceProgram(programToReplaceRef.current, selectedMediaDealRight._id.toString());
      setProgramToReplace({});
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_atleast_one_mediadealright_planning_performance_error_message });
    }
  };

  const replaceProgram = async (newMediaEpisode, mediaDealRight_id = null) => {

    if (newMediaEpisode == undefined || newMediaEpisode._id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.replacement_media_lost_error_message });
    }

    const saveData = {
      SID: 0,
      Channel: selectedChannel,
      MediaEpisode_id: newMediaEpisode._id,
      ScheduleDate: selectedHeader.current.SlotDateTime,
      SlotDateTime: selectedHeader.current.SlotDateTime,
      Segment_id: null,
      ParentProgramSchedule_id: null,
      IsValid: true,
      MediaDealRight_id: mediaDealRight_id,
    };

    var response = await API.ReplaceProgram(saveData, selectedHeader.current); // true for loadchildren
    console.log(response);

    if (response.success) {

      //socket
      updateHeaderSocket(selectedHeader.current, true);
      console.log(response.data);
      addHeaderInPlanningSocket(response.data.header, newMediaEpisode);

      var parentIndex = schedulerDataRef.current.findIndex(
        (header) => header._id == selectedHeader.current._id
      );
      var schedlerDataCopy = [...schedulerDataRef.current];
      schedlerDataCopy.splice(parentIndex, 1, {
        ...response.data.header,
        mediaEpisode: newMediaEpisode,
        Duration: newMediaEpisode.Duration,
        children: response.data.children,
        expanded: selectedHeader.current.expanded ?? true,
        EndSlotDateTime: response.data.header.SlotDateTime + newMediaEpisode.Duration,
        TcIn: response.data.header.TcIn ?? 0,
        TcOut: response.data.header.TcOut ?? 0,
        Style: SchedulingHelper.getScheduleColorPreference(
          response.data.header
        ),
      });
      schedlerDataCopy[parentIndex].children = getRippleChildrens(
        schedlerDataCopy[parentIndex],
        response.data.children,
        schedlerDataCopy
      );
      schedulerDataRefSetter(schedlerDataCopy);
      scheduleLog([selectedHeader.current], LOGEVENT.PROGRAM_REPLACEMENT);

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }
  }

  const onCancelMediaDealRightPopup = () => {
    setProgramToReplace({});
    setShowMediaDealRightsPopup(false);
  };

  //global replacement
  const showGlobalReplacement = () => {
    console.log(lockStatus);
    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    if (selectedStateRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_schedule_item_error_message });
      return;
    }

    if (selectedStateRef.current.some(data => !SchedulingHelper.canModify(data, schedulerDataRef.current))) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Locked header found. Please unlock and try again." });
      return;
    }

    if (selectedStateRef.current.some((x) => (x.mediaEpisode?.MediaCategory?.SID ?? 0) != selectedStateRef.current[0].mediaEpisode.MediaCategory.SID)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_same_media_category_media_only_global_replacement_error });
      return;
    }

    if (
      selectedStateRef.current.some(
        (item) =>
          item.Type == SCHEDULETYPE.Segment ||
          item.Type == SCHEDULETYPE.UnderRun ||
          item.Type == SCHEDULETYPE.OverRun ||
          item[IS_BREAK]
      )
    ) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.not_allowed_on_this_postion_error_message });
      return;
    }
    setShowGlobalReplacementDialog(true);
  };

  const gloabalFindAndReplace = async (
    selectedItems,
    replaceWith,
    isBreakInclude,
    replaceMethod,
  ) => {
    var replaceArrayIndexes = [];
    var schedulerDataCopy = [...schedulerDataRef.current];

    if (REPLACEMENTMODE[replaceMethod] != REPLACEMENTMODE.Selected) {
      schedulerDataCopy.map((parent, pi) => {

        parent.children.map((children, ci) => {

          // if you choose include break from replacement window it will also replace child inside level 2 (0,1,2)
          if (children[IS_BREAK] && isBreakInclude) {
            children.children.map((breackChild, bi) => {
              if (
                breackChild?.mediaEpisode?._id ==
                selectedItems[0]?.mediaEpisode?._id
              ) {
                replaceArrayIndexes.push([pi, ci, bi]);
              }
            });
          }
          if (
            !children[IS_BREAK] &&
            children?.mediaEpisode?._id == selectedItems[0]?.mediaEpisode?._id
          ) {
            replaceArrayIndexes.push([pi, ci]);
          }
        });
      });
    }

    switch (REPLACEMENTMODE[replaceMethod]) {
      case REPLACEMENTMODE.ALL:
        await globalReplace(replaceWith, replaceArrayIndexes);
        break;
      case REPLACEMENTMODE.Alternate:
        await globalReplace(
          replaceWith,
          replaceArrayIndexes.filter((replaceArrayIndex, i) => i % 2 == 0)
        );
        break;
      case REPLACEMENTMODE.Random:
        await globalReplace(replaceWith, replaceArrayIndexes, true);
        break;
      case REPLACEMENTMODE.Selected:
        replaceArrayIndexes = selectedItems.map((item) => {
          let { level_0_index, level_1_index, level_2_index, isInsideBreak } =
            SchedulingHelper.getChildInfo(item, schedulerDataRef.current);
          if (isInsideBreak) {
            return [level_0_index, level_1_index, level_2_index];
          } else {
            return [level_0_index, level_1_index];
          }
        });
        await globalReplace(replaceWith, replaceArrayIndexes);

        break;

      default:
        await globalReplace(replaceWith, replaceArrayIndexes);
        break;
    }

    // sometimes search does not work but after refresh it works, so we are calling load data after global replacement.
    await loaddata(true);
  };

  const globalReplace = async (
    replaceWith,
    replaceArrayIndexes,
    random = false
  ) => {
    var replaceWithIndex = 0;
    var schedulerDataCopy = [...schedulerDataRef.current];
    var filterGridCopy = [...showFilterGridData];

    setShowProgressBar({ okButton: false, progressBarPopup: true });

    for (let index = 0; index < replaceArrayIndexes.length; index++) {
      const replaceIndex = replaceArrayIndexes[index];

      setProgressData({
        message: "Applying Global Replacement...",
        progress: Math.ceil((100 * (index + 1)) / replaceArrayIndexes.length)
      });

      if (random) {
        replaceWithIndex = Math.floor(Math.random() * replaceWith.length);
      }
      if (!random && replaceWith.length == replaceWithIndex) {
        replaceWithIndex = 0;
      }
      //CHILD
      if (replaceIndex.length == 2) {

        schedulerDataCopy[replaceIndex[0]].children.splice(replaceIndex[1], 1, {
          ...schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]],
          MediaEpisode_id: replaceWith[replaceWithIndex]._id,
          MediaId: replaceWith[replaceWithIndex]?.AssetId,
          Duration: replaceWith[replaceWithIndex]?.Duration,
          TcIn: replaceWith[replaceWithIndex]?.TcIn,
          TcOut: replaceWith[replaceWithIndex]?.TcOut,
          mediaEpisode: replaceWith[replaceWithIndex]
        });


        let filterIndex = filterGridCopy.findIndex(
          (filterData) =>
            filterData._id ==
            schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]]._id
        );
        if (filterIndex > -1) {
          filterGridCopy.splice(filterIndex, 1, {
            ...schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]],
            MediaEpisode_id: replaceWith[replaceWithIndex]._id,
            MediaId: replaceWith[replaceWithIndex]?.AssetId,
            Duration: replaceWith[replaceWithIndex]?.Duration,
            TcIn: replaceWith[replaceWithIndex]?.TcIn,
            TcOut: replaceWith[replaceWithIndex]?.TcOut,
            mediaEpisode: replaceWith[replaceWithIndex]
          });
        }
        replaceWithIndex++;

        //-----Saving------------
        await childrenSave(replaceIndex[0]);
        scheduleLog(replaceWith, LOGEVENT.GLOBAL_REPLACEMENT);
        //-----Saved-------------
      }

      //BREAK CHILD
      if (replaceIndex.length == 3) {

        schedulerDataCopy[replaceIndex[0]].children[
          replaceIndex[1]
        ].children.splice(replaceIndex[2], 1, {
          ...schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]]
            .children[replaceIndex[2]],
          MediaEpisode_id: replaceWith[replaceWithIndex]._id,
          MediaId: replaceWith[replaceWithIndex]?.AssetId,
          Duration: replaceWith[replaceWithIndex]?.Duration,
          TcIn: replaceWith[replaceWithIndex]?.TcIn,
          TcOut: replaceWith[replaceWithIndex]?.TcOut,
          mediaEpisode: replaceWith[replaceWithIndex]
        });

        let filterIndex = filterGridCopy.findIndex(
          (filterData) =>
            filterData._id ==
            schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]]
              .children[replaceIndex[2]]._id
        );
        if (filterIndex > -1) {
          filterGridCopy.splice(filterIndex, 1, {
            ...schedulerDataCopy[replaceIndex[0]].children[replaceIndex[1]]
              .children[replaceIndex[2]],
            MediaEpisode_id: replaceWith[replaceWithIndex]._id,
            MediaId: replaceWith[replaceWithIndex]?.AssetId,
            Duration: replaceWith[replaceWithIndex]?.Duration,
            TcIn: replaceWith[replaceWithIndex]?.TcIn,
            TcOut: replaceWith[replaceWithIndex]?.TcOut,
            mediaEpisode: replaceWith[replaceWithIndex]
          });
        }
        replaceWithIndex++;
        //-----Saving------------
        await breakChildrenSave(replaceIndex[0], replaceIndex[1]);
        //-----Saved-------------
      }
    }

    setProgressData({ message: "Completed", progress: 100 });
    setShowProgressBar({ progressBarPopup: true, okButton: true });

    setShowFilterGridData(filterGridCopy);
    schedulerDataRefSetter(schedulerDataCopy);
  };

  const childrenSave = async (parentIndex) => {
    let schedulerDataLocal = [...schedulerDataRef.current];
    schedulerDataLocal[parentIndex].children = getRippleChildrens(schedulerDataLocal[parentIndex], schedulerDataLocal[parentIndex].children, schedulerDataRef.current)

    let destinationIndexes = SchedulingHelper.getDestinationItemIndexes(parentIndex);

    await saveSchedule({
      destinationItemInfo: destinationIndexes,
      dataToSave: schedulerDataLocal[parentIndex].children,
    });
    schedulerDataRefSetter(schedulerDataLocal);

  };

  const breakChildrenSave = async (parentIndex, childIndex) => {
    let schedulerDataLocal = [...schedulerDataRef.current];

    schedulerDataLocal[parentIndex].children[childIndex].children = getRippleBreakChildrens(
      schedulerDataLocal[parentIndex].children[childIndex],
      schedulerDataLocal[parentIndex].children[childIndex].children
    )

    let destinationIndexes = SchedulingHelper.getDestinationItemIndexes(
      parentIndex,
      childIndex
    );
    await saveSchedule({
      destinationItemInfo: destinationIndexes,
      dataToSave: schedulerDataLocal[parentIndex].children[childIndex].children,
    });
    schedulerDataRefSetter(schedulerDataLocal);
  };

  //delete secondary events
  const deleteSelectedSecondaryEvent = async ({ selectedItem, selectedPrototype }) => {

    //check selectedItem is not empty
    if (
      selectedStateRef.current.length == 0
    ) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_one_item_error_message });
      return;
    }

    if (selectedStateRef.current[0]?.Prototypes.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_secondary_events_attached_to_delete_error_message });
      return;
    }

    let newPrototypes = [];
    if (selectedPrototype && selectedPrototype.length > 0) {
      newPrototypes = selectedStateRef.current[0].Prototypes.filter((item) => !selectedPrototype.includes(item))
    }

    let saveData = {
      ...selectedStateRef.current[0],
      Prototypes: newPrototypes,
    };

    //UI
    let schedulerDataRefLocal = schedulerDataRef.current;
    const { level_0_index, level_1_index } = SchedulingHelper.getChildInfo(
      selectedStateRef.current[0],
      schedulerDataRefLocal
    );
    schedulerDataRefLocal[level_0_index].children[level_1_index] = saveData;
    selectedStateRefSetter([saveData]);
    schedulerDataRefSetter(schedulerDataRefLocal);

    saveData = SchedulingHelper.prepareDataforbackend([saveData])[0];
    console.log(saveData);
    var res = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
    console.log(res);
    if (res.success) {
      setStatusMessage(lang.deleted_secondary_events_msg_scheduling);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.deleted_secondary_events_msg_scheduling });
    }
  };

  const deleteAllSecondaryEvent = async () => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    console.log("started");
    let schedulerDataRefLocal = [...schedulerDataRef.current];
    selectedStateRefSetter([]);

    //UI

    let dataToSave = [];
    schedulerDataRefLocal.map((item, index) => {

      // TO CAPTURE THE PARENTS FROM WHERE ALL SECONDARY EVENTS ARE DELETED
      var parent = item;

      item = item.children.map((child) => {
        //break
        if (child[IS_BREAK]) {
          child.children = child.children.map((grandChild) => {
            let finalChildData = { ...grandChild, Prototypes: [] };
            if (grandChild.Prototypes?.length > 0) dataToSave.push(finalChildData);
            return finalChildData;
          })

        }
        let finalData = { ...child, Prototypes: [] };
        if (child.Prototypes?.length > 0) dataToSave.push(finalData);
        return finalData;
      });


      let saveData = SchedulingHelper.prepareDataforbackend(dataToSave);
      console.log(saveData);
      API.saveData(ENTITYNAME.ProgramSchedule, saveData).then((res) => {
        console.log(res);
      });
      schedulerDataRefLocal[index].children = item;
      scheduleLog([parent], LOGEVENT.DELETE_ALL_SECONDARY_EVENT);

    });

    schedulerDataRefSetter(schedulerDataRefLocal);
    setStatusMessage(() => `${lang.all_secondary_events_deleted_successfully_msg_scheduling}`);
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.all_secondary_events_deleted_successfully_msg_scheduling });
  };

  const deleteSelectedAllSecondaryEvent = async ({ selectedItem, selectedPrototype }) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }

    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    let schedulerDataRefLocal = [...schedulerDataRef.current];
    selectedStateRefSetter([]);

    let dataToSave = [];

    schedulerDataRefLocal.forEach((item, index) => {

      let parent = item;

      let updatedChildren = item.children.map((child) => {

        // HANDLE BREAK CHILDREN (IMMUTABLE)
        let updatedChild = { ...child };

        if (child[IS_BREAK]) {
          updatedChild.children = (child.children || []).map((grandChild) => {

            let filteredPrototypes = (grandChild.Prototypes || []);

            if (selectedPrototype?.length) {
              filteredPrototypes = filteredPrototypes.filter((bp) => !selectedPrototype.includes(bp));
            }

            let finalChildData = {
              ...grandChild,
              Prototypes: filteredPrototypes
            };

            dataToSave.push(finalChildData);
            return finalChildData;
          });
        }

        // NORMAL CHILD
        let filteredPrototypes = (child.Prototypes || []);

        if (selectedPrototype?.length) {
          filteredPrototypes = filteredPrototypes.filter((p) => !selectedPrototype.includes(p));
        }

        let finalData = {
          ...updatedChild,
          Prototypes: filteredPrototypes
        };

        dataToSave.push(finalData);
        return finalData;
      });

      schedulerDataRefLocal[index] = {
        ...item,
        children: updatedChildren
      };

      scheduleLog([parent], LOGEVENT.DELETE_ALL_SECONDARY_EVENT);
    });

    try {
      let saveData = SchedulingHelper.prepareDataforbackend(dataToSave);
      console.log(saveData)

      const res = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
      console.log(res);

      // ✅ Update UI only after success
      schedulerDataRefSetter(schedulerDataRefLocal);

      setStatusMessage(() =>
        `${lang.all_secondary_events_deleted_successfully_msg_scheduling}`
      );
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.all_secondary_events_deleted_successfully_msg_scheduling });
    } catch (err) {
      console.error(err);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to delete secondary events. Please try again." });
    }
  };


  const handleDropPrototype = async (destinationDataItem, dataToSave) => {
    console.log("handleprototypeDrop");
    let schedulerDataRefLocal = schedulerDataRef.current;


    let destinationDataItems = [destinationDataItem, ...selectedStateRef.current.filter(item => item._id != destinationDataItem._id)];

    for (let index = 0; index < destinationDataItems.length; index++) {
      const { level_0_index, level_1_index, level_2_index, isInsideBreak, isBreak } = SchedulingHelper.getChildInfo(
        destinationDataItems[index],
        schedulerDataRefLocal
      );

      //not allowed for Break
      if (isBreak) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.prototype_drop_not_allowed_for_break_error_message });
        return;
      }

      //adding prototype in primary event as embedded array

      var isValidPrototype = SchedulingHelper.IsValidPrototype(
        dataToSave,
        destinationDataItems[index],
        schedulerDataRefLocal,
        setStatusMessage
      );

      let item = {};

      if (isValidPrototype) {
        // UpdateDynamicTextValue will insert Text1, text2 etc values if prototype is dynamic
        item = isInsideBreak ? schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] : schedulerDataRefLocal[level_0_index].children[level_1_index];

        let prototype = await UpdateDynamicTextValue(dataToSave, item);
        item.Prototypes.push(prototype);

        //UI
        if (isInsideBreak) {
          schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] = item;
        } else {
          schedulerDataRefLocal[level_0_index].children[level_1_index] = item;
        }
        schedulerDataRefSetter(schedulerDataRefLocal);
        //save
        await API.saveData(ENTITYNAME.ProgramSchedule, { _id: item._id, Prototypes: item.Prototypes })

        setStatusMessage(() => dataToSave.Name + " applied successfully")
      }

      //ui
      selectedStateRefSetter([]);
      schedulerDataRefSetter(schedulerDataRefLocal);

      scheduleLog([{ ...item, AppliedPrototype: dataToSave }], LOGEVENT.APPLY_SECONDARY_EVENT);

      //backend
      // let saveData = SchedulingHelper.prepareDataforbackend([item])[0];
      // var res = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
      // if (res.success) {
      // ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.added_secondary_events_success_message });
      // }

      console.log(schedulerDataRefLocal[level_0_index].children);
    }


  };

  const handleDropAnnouncement = async (destinationDataItem, dataToSave) => {
    console.log("handleDropAnnouncement");
    let schedulerDataRefLocal = schedulerDataRef.current;
    let destinationDataItems = [destinationDataItem];

    for (let index = 0; index < destinationDataItems.length; index++) {
      const { level_0_index, level_1_index, level_2_index, isInsideBreak, isBreak } = SchedulingHelper.getChildInfo(
        destinationDataItems[index],
        schedulerDataRefLocal
      );

      //not allowed for Break
      if (isBreak) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.prototype_drop_not_allowed_for_break_error_message });
        return;
      }

      let item = {};

      // UpdateDynamicTextValue will insert Text1, text2 etc values if prototype is dynamic
      item = isInsideBreak ? schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] : schedulerDataRefLocal[level_0_index].children[level_1_index];

      if (item.Announcements == undefined) item.Announcements = [];
      item.Announcements = [...item.Announcements, ...dataToSave];

      console.log(item);

      //UI
      if (isInsideBreak) {
        schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] = item;
      } else {
        schedulerDataRefLocal[level_0_index].children[level_1_index] = item;
      }

      schedulerDataRefSetter(schedulerDataRefLocal);
      //save
      await API.saveData(ENTITYNAME.ProgramSchedule, {
        _id: item?._id,
        Announcements: item?.Announcements?.map(x => {
          return { _id: x._id, BookingDate: x.BookingDate, Duration: x.Duration, AssetId: x.AssetId, Title: x.Title, Description: x.Description, TimeRangeFrom: x.TimeRangeFrom, TimeRangeTo: x.TimeRangeTo, SpotRate: x.SpotRate }
        })
      })

      setStatusMessage(() => "Announcement applied successfully")

      //ui
      selectedStateRefSetter([]);
      deleteUsedBooking(dataToSave);

      schedulerDataRefSetter(schedulerDataRefLocal);

      // scheduleLog([{ ...item, Announcement: dataToSave }], LOGEVENT.APPLY_SECONDARY_EVENT);

      console.log(schedulerDataRefLocal[level_0_index].children);
    }


  };

  const handleDeleteAnnouncement = async (announcement) => {
    console.log("handleDeleteAnnouncement");
    console.log(announcement);
    let schedulerDataRefLocal = schedulerDataRef.current;
    let destinationDataItems = selectedStateRef.current;

    console.log(destinationDataItems)

    for (let index = 0; index < destinationDataItems.length; index++) {
      const { level_0_index, level_1_index, level_2_index, isInsideBreak, isBreak } = SchedulingHelper.getChildInfo(
        destinationDataItems[index],
        schedulerDataRefLocal
      );

      //not allowed for Break
      if (isBreak) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.prototype_drop_not_allowed_for_break_error_message });
        return;
      }

      let item = {};

      // UpdateDynamicTextValue will insert Text1, text2 etc values if prototype is dynamic
      item = isInsideBreak ? schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] : schedulerDataRefLocal[level_0_index].children[level_1_index];

      if (item.Announcements == undefined) item.Announcements = [];
      item.Announcements = [...item.Announcements.filter((x) => x._id != announcement._id)];

      console.log(item);

      //UI
      if (isInsideBreak) {
        schedulerDataRefLocal[level_0_index].children[level_1_index].children[level_2_index] = item;
      } else {
        schedulerDataRefLocal[level_0_index].children[level_1_index] = item;
      }
      //save
      await saveSchedule({
        destinationItemInfo: { level_0_index, level_1_index, level_2_index },
        dataToSave: [item],
      });
      schedulerDataRefSetter(schedulerDataRefLocal);
      setStatusMessage(() => "Announcement delete successfully");

      //Update announcement nominal
      var res = await API.saveData(ENTITYNAME.Booking, { _id: announcement._id, NominalOnAir: 0, ParentHeaderMediaEpisode_id: '' });
      if (!res.success) {
        console.log(res)
      }

      //ui
      selectedStateRefSetter([item]);
      //refeshing booking
      props.loadBookingCommercialdata();

      schedulerDataRefSetter(schedulerDataRefLocal);

      // scheduleLog([{ ...item, Announcement: dataToSave }], LOGEVENT.APPLY_SECONDARY_EVENT);

      console.log(schedulerDataRefLocal[level_0_index].children);
    }


  };

  const onStyleSheetSelectionClose = (styleSheets) => {
    applyStyleSheet(styleSheets);
  };

  const onApplyFormatClick = async (list) => {

    console.log("IN APPLY FORMAT");

    if (selectedHeader.current == undefined || selectedHeader.current.mediaEpisode._id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Header not selected.' });
    }

    if (
      selectedHeader.current.children != undefined &&
      selectedHeader.current.children.length > 0 &&
      selectedHeader.current.children.some((x) => x.IsFromFormat)
    ) {

      ConfirmAlert(
        async () => {
          await onApplyFormat(list, true)
        }, // on Click yes
        async () => {
          await onApplyFormat(list)
        }, // on click no
        "Format already applied on this header.", //title
        "While applying new format, do you want to delete existing short forms of the old format ?" // message
      );

    } else {
      await onApplyFormat(list);
    }

  };

  const onApplyFormat = async (list, deleteChildren = false) => {

    const selectedFormat = list[0];

    // attaching format
    var media = {
      _id: selectedHeader.current.mediaEpisode._id,
      SID: selectedHeader.current.mediaEpisode.SID,
      AssetId: selectedHeader.current.mediaEpisode.AssetId,
      Duration: selectedHeader.current.mediaEpisode.Duration
    };

    var payload = {
      media: [media],
      formats: [selectedFormat]
    }
    await API.attachFormats(payload);

    // get valid segment for same count as of selected format.
    var validSegment = await SchedulingHelper.getMediaEpisodeValidSegment(selectedFormat, selectedHeader.current.mediaEpisode);

    if (validSegment == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "valid segment not found after attaching format" });
      return;
    }

    const saveData = {
      SID: 0,
      Channel: selectedChannel,
      MediaEpisode_id: selectedHeader.current.mediaEpisode._id,
      ScheduleDate: selectedHeader.current.SlotDateTime,
      SlotDateTime: selectedHeader.current.SlotDateTime,
      Segment_id: validSegment._id.toString(),
      ParentProgramSchedule_id: null,
      IsValid: true,
      MediaDealRight_id: selectedHeader.current.MediaDealRight_id,
    };

    var response = await API.ReplaceProgram(saveData, selectedHeader.current, deleteChildren); // true for loadchildren
    console.log(response);

    if (response.success) {
      var parentIndex = schedulerDataRef.current.findIndex(
        (header) => header._id == selectedHeader.current._id
      );
      var schedlerDataCopy = [...schedulerDataRef.current];
      schedlerDataCopy.splice(parentIndex, 1, {
        ...response.data.header,
        mediaEpisode: selectedHeader.current.mediaEpisode,
        Duration: selectedHeader.current.mediaEpisode.Duration,
        children: response.data.children,
        Style: SchedulingHelper.getScheduleColorPreference(
          response.data.header
        ),
      });
      schedlerDataCopy[parentIndex].children = getRippleChildrens(
        schedlerDataCopy[parentIndex],
        response.data.children,
        schedlerDataCopy
      );
      schedulerDataRefSetter(schedlerDataCopy);
      scheduleLog([selectedHeader.current], LOGEVENT.ATTACH_FORMAT_FROM_SCHEDULE);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Format Attached !!" });
      var event = { dataItem: schedlerDataCopy[parentIndex], dataIndex: parentIndex, value: true };
      expandChange(event);
      loadSavedSegments();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }
  };

  const applyStyleSheet = async (styleSheetList) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    console.log("applyStyleSheet");
    setShowProgressBar({ okButton: false, progressBarPopup: true });

    var parentData = selectedHeadersDataItemsRef.current;
    const payload = {
      styleSheetList,
      scheduleDate: parentData[0].ScheduleDate
    };

    // fill prototypes in stylesheet
    const styleSheetRes = await API.getSecondaryEventStyleSheetsWithPrototypes(payload)
    console.log(styleSheetRes);

    if (!styleSheetRes.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: styleSheetRes.message });
      return;
    }

    styleSheetList = styleSheetRes.data;

    // looping all parents of playlist for now
    for (var i = 0; i < parentData.length; i++) {
      let { level_0_index } = SchedulingHelper.getChildInfo(
        parentData[i],
        schedulerDataRef.current
      );
      setProgressData({ message: 'Applying Style Sheet', progress: Math.ceil((100 * (i + 1)) / parentData.length) });

      let schedlerDataCopy = [...schedulerDataRef.current];
      // looping style sheet list
      for (const styleSheet of styleSheetList) {

        for (const child of schedlerDataCopy[level_0_index].children) {
          child.Prototypes ??= [];

          if (child.Type === SCHEDULETYPE.UnderRun || child.Type === SCHEDULETYPE.OverRun) {
            continue;
          }

          for (const prototype of styleSheet.Prototypes) {
            const isValidPrototype = SchedulingHelper.IsValidPrototype(
              prototype,
              child,
              schedulerDataRef.current,
              setStatusMessage
            );

            if (isValidPrototype) {
              let proto = await UpdateDynamicTextValue(prototype, child);
              child.Prototypes.push(proto);
            }
          }
        }

        scheduleLog([{ ...parentData[i], AppliedStyleSheet: styleSheet }], LOGEVENT.APPLY_STYLE_SHEET);

      }

      schedulerDataRef.current = schedlerDataCopy;

      await API.saveSchedule({
        schedules: schedlerDataCopy[level_0_index].children,
        deletedschedules: [],
      });

      schedulerDataRefSetter(schedlerDataCopy);
    }

    setProgressData({ message: 'Process completed', progress: 100 });
    setShowProgressBar({ progressBarPopup: true, okButton: true });
    loaddata(true);

    setStatusMessage(() => `${lang.style_sheet_applied_successfully_msg_scheduling}`);
  };

  const UpdateDynamicTextValue = async (prototype, scheduleItem) => {
    if (
      prototype.SecondaryEventDynamicRules &&
      prototype.SecondaryEventDynamicRules.length > 0
    ) {
      for (
        let index = 0;
        index < prototype.SecondaryEventDynamicRules.length;
        index++
      ) {
        /// dynamically creating properties inside prototype object of type Text + TextNumber in prototype Rule
        console.log("payloadref.current", payloadref.current);
        let { dynamicValue, nextDayHeaders } = await SchedulingHelper.GetParsedText(
          scheduleItem,
          prototype.SecondaryEventDynamicRules[index],
          schedulerDataRef.current,
          nextDayHeaderRef.current,
        );
        prototype["Text" + prototype.SecondaryEventDynamicRules[index].TextNumber] = dynamicValue
        nextDayHeaderRef.current = nextDayHeaders

      }
    }
    return SchedulingHelper.PreparePrototypeData(prototype);
  };

  const onCheckList = () => {
    setShowCheckList(() => !showCheckList);
  };

  const onGoToSchedule = (dataItem, hideFilterGrid = false) => {
    console.log(dataItem)
    setShowFilterGrid(hideFilterGrid);
    setShowCheckList(false);

    selectedStateRefSetter([dataItem]);
    setShowGoToSchedulePopup(false);
    let { rowIndex, updatedSchedulerData } = SchedulingHelper.getScheduleRowIndex(dataItem, schedulerDataRef.current);

    if (treeListRef?.current?.element == null) {
      // TIMEOUT FOR UI TO RENDER
      setTimeout(() => {
        treeListRef.current.element.scrollTo({
          left: 0, top: rowIndex * ROW_HEIGHT, behavior: 'smooth'
        });
      }, 500)
    } else {
      treeListRef.current.element.scrollTo({
        left: 0, top: rowIndex * ROW_HEIGHT, behavior: 'smooth'
      });
    }

    schedulerDataRefSetter(updatedSchedulerData);

  }

  //ATTACH MAM
  const onAttachMAMAsset = () => {
    setShowMamAssetCollectionSelection(true);
  }

  const onInsertCueTones = async () => {

    //REMOVE DUPLICATE SELECTED ITEM
    let uniqueSelectedItems = [];
    selectedStateRef.current.forEach(item => {
      if (!uniqueSelectedItems.some(uniq => uniq._id === item._id)) {
        uniqueSelectedItems.push(item);
      }
    });

    //--VALIDATION--
    if (uniqueSelectedItems.some(item => item.SCTEType > 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.some_selected_items_already_have_cuetone_error_message });
      return;
    }

    //CHECK uniqueSelectedItems count will be 2
    if (uniqueSelectedItems.length != 2) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_only_2_items_to_insert_cuetone_error_message });
      return;
    }
    ////--VALIDATION--

    //SORT
    uniqueSelectedItems.sort((a, b) => a.SlotDateTime - b.SlotDateTime);

    const uniqScteRef = uuidv4();

    let saveData = uniqueSelectedItems.map((item, i) => {
      return {
        _id: item._id,
        SCTEType: i == 0 ? SCTE_TYPE.SCTE_START : SCTE_TYPE.SCTE_END,
        SCTERef: uniqScteRef
      }
    })

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
    if (updateRes.success) {

      uniqueSelectedItems.map((item, i) => {

        let schedulerDataCopy = [...schedulerDataRef.current];

        let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(item, schedulerDataRef.current);

        let scteType = i == 0 ? SCTE_TYPE.SCTE_START : SCTE_TYPE.SCTE_END;

        //LOCAL DATA SET
        const updatedObject = isInsideBreak ? {
          ...schedulerDataCopy[level_0_index].children[level_1_index].children[level_2_index],
          SCTEType: scteType,
          SCTERef: uniqScteRef,
        } : {
          ...schedulerDataCopy[level_0_index].children[level_1_index],
          SCTEType: scteType,
          SCTERef: uniqScteRef,
        };

        isInsideBreak ?
          schedulerDataCopy[level_0_index].children[level_1_index].children.splice(level_2_index, 1, updatedObject) :
          schedulerDataCopy[level_0_index].children.splice(level_1_index, 1, updatedObject);

        schedulerDataRefSetter(schedulerDataCopy);

        // logs
        let logData = { event: LOGEVENT.ADD_SCTE_MARKER, module: MODULE.SCHEDULING, data: { ...updatedObject }, message: LOGEVENT.ADD_SCTE_MARKER };
        API.SaveProgramScheduleHeaderLogs(logData);

      })

      selectedStateRefSetter([]);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: company?.Name?.toLowerCase() == "rock" ? lang.cuetone_inserted_successfully_message : lang.scte_inserted_successfully_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: updateRes.message });
    }
  }

  const onDeleteCueTones = async () => {

    if (selectedStateRef.current.length == 0 || selectedStateRef.current.length != 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item_error_message });
      return;
    }

    let scteChilds = schedulerDataRef.current
      .find((h) => h._id == selectedStateRef.current[0].ParentProgramSchedule_id)?.children
      .filter(c => c.SCTERef == selectedStateRef.current[0].SCTERef);

    let saveData = scteChilds.map((item, i) => {
      return {
        _id: item._id,
        SCTEType: SCTE_TYPE.NO_SCTE,
        SCTERef: null
      }
    })

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
    if (updateRes.success) {

      scteChilds.map((item, i) => {

        let schedulerDataCopy = [...schedulerDataRef.current];

        let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(item, schedulerDataRef.current);

        //LOCAL DATA SET
        const updatedObject = isInsideBreak ? {
          ...schedulerDataCopy[level_0_index].children[level_1_index].children[level_2_index],
          SCTEType: SCTE_TYPE.NO_SCTE,
          SCTERef: null,
        } : {
          ...schedulerDataCopy[level_0_index].children[level_1_index],
          SCTEType: SCTE_TYPE.NO_SCTE,
          SCTERef: null,
        };

        isInsideBreak ?
          schedulerDataCopy[level_0_index].children[level_1_index].children.splice(level_2_index, 1, updatedObject) :
          schedulerDataCopy[level_0_index].children.splice(level_1_index, 1, updatedObject);

        schedulerDataRefSetter(schedulerDataCopy);

        // logs
        let logData = { event: LOGEVENT.DELETE_SCTE_MARKER, module: MODULE.SCHEDULING, data: { ...updatedObject }, message: LOGEVENT.DELETE_SCTE_MARKER };
        API.SaveProgramScheduleHeaderLogs(logData);

      })

      selectedStateRefSetter([]);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: company?.Name?.toLowerCase() == "rock" ? lang.cuetone_deleted_successfully_message : lang.scte_deleted_successfully_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: updateRes.message });
    }
  }

  const onBrowseMamAsset = async (datalist) => {

    // CHECK REFRESH

    if (selectedStateRef.current[0].Type == SCHEDULETYPE.UnderRun || selectedStateRef.current[0].Type == SCHEDULETYPE.OverRun) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "UnderRun / OverRun cannot be attached to MAM" });
      return;
    }

    const entityName = selectedStateRef.current[0].Type == SCHEDULETYPE.Segment ? ENTITYNAME.MediaEpisodeSegment : ENTITYNAME.MediaEpisode;

    const _id = selectedStateRef.current[0].Type == SCHEDULETYPE.Segment
      ? selectedStateRef.current[0]?.segment?._id ? selectedStateRef.current[0].segment._id
        : selectedStateRef.current[0].segments[0]._id : selectedStateRef.current[0].mediaEpisode._id

    let attachMAM = await API.saveData(entityName, {
      _id: _id,
      Mam: { _id: datalist[0]?._id, CSID: datalist[0]?.CSID, AssetId: datalist[0]?.AssetId }
    })

    if (attachMAM.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "MAM attached successfully !!" });

      //schedulerDataLocal[level_0_index].children.splice(level_1_index, 0, ...dataItems);
      let schedulerDataLocal = [...schedulerDataRef.current];
      let headerIndex = schedulerDataRef.current.findIndex(h => h._id == selectedStateRef.current[0].ParentProgramSchedule_id);
      let index = schedulerDataRef.current[headerIndex].children.findIndex(c => c._id == selectedStateRef.current[0]._id);
      let dataItem = { ...schedulerDataLocal[headerIndex].children[index], Mam: { _id: datalist[0]?._id, CSID: datalist[0]?.CSID, AssetId: datalist[0]?.AssetId } };

      schedulerDataLocal[headerIndex].children.splice(index, 1, dataItem);

      schedulerDataRefSetter(schedulerDataLocal);
      setShowMamAssetCollectionSelection(false);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: attachMAM.message });
    }

  }

  //EXPORT SCHEDULE
  const exportSchedule = (automation, channel, checkList = [], doSftp = false, isPartial = false, isDeliver = false, withSCTE = false, isCommercial = false) => {
    let date_ttc_milisecond = selectedDateRef.current;

    console.log('here in main');
    console.log(checkList);
    console.log(schedulerDataRef.current)

    //MANDATORY MAM ID CHECK FOR SI MEDIA AUTOMATION DURING DELIVER
    if (enableMamIdChecklist && isDeliver && automation == AUTOMATION.SI_MDA) {

      let missingMamID = []

      //LOOP CHILDRENS
      schedulerDataRef.current.map((parent) => {

        if (parent.TXStatus != TX_STATUS.Live && parent.TXStatus != TX_STATUS.SDD && parent.mediaEpisode && (!parent.mediaEpisode.MamID || parent.mediaEpisode.MamID.length == 0)) {
          missingMamID.push(parent);
        }

        let sf = parent.children && parent.children.length > 0 ?
          parent.children.filter((x) => x.Type == SCHEDULETYPE.ShortForm && x.mediaEpisode && (!x.mediaEpisode.BroadcasterId || x.mediaEpisode.BroadcasterId.length == 0)) : [];
        if (sf.length > 0) {
          missingMamID = [...missingMamID, ...sf];
        }

      })

      if (missingMamID.length > 0) {
        const seenAssetIds = new Set();
        const uniqueMediaEpisodes = missingMamID.filter(item => {
          const id = item?.mediaEpisode?.AssetId;
          if (seenAssetIds.has(id)) return false;
          seenAssetIds.add(id);
          return true;
        });
        let missingAssets = uniqueMediaEpisodes.map((x) => {
          return {
            Title: x.mediaEpisode.Title,
            AssetId: x.mediaEpisode.AssetId,
            SlotDateTime: utility.convertMilisecondsToDateTimeString(x.SlotDateTime),
            ReferenceCode: x.mediaEpisode.ReferenceCode,
            Duration: utility.convertMilisecondsToStringWithFrames(x.Duration),
            MediaCategory: x.mediaEpisode.MediaCategory,
            MamAssetStatus: MAM_ASSET_REPORT_STATUS.MISSING
          }
        })

        setShowMissingMamIDPopup(true);
        setMissingMamIDReportData(missingAssets);
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Cannot push playlist — ${missingAssets.length} program(s) have no MamID attached.` });
        return;
      }
    }

    //MANDATORY MAM ID CHECK FOR ETISALAT
    if (enableMamIdChecklist && company && company.Name && company.Name.toLowerCase() == "etisalat") {

      let noAttachedMamData = getNoMamAttachedMedia(schedulerDataRef.current);

      if (noAttachedMamData && noAttachedMamData.length > 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${noAttachedMamData.length} program(s) have no MamID attached.` });
        return;
      }
    }

    var failure = checkList.filter((obj) => obj.Status == 'Failure')

    if (selectedStateRef.current.length > 0) {

      var parent = {};
      if (selectedStateRef.current[0]?.Type == SCHEDULETYPE.Header) {
        parent = selectedStateRef.current[0];
      }
      else {
        parent = SchedulingHelper.getParent(selectedStateRef.current[0].ParentProgramSchedule_id, schedulerDataRef.current);
      }

      if (isPartial) {
        ConfirmAlert(
          () => {
            //yes -- partial export
            let payload = SchedulingHelper.getPayload(date_ttc_milisecond, channel.SID, offsetTime);
            SchedulingHelper.downloadschedule(payload, automation, parent.SlotDateTime, doSftp, channel, isDeliver, withSCTE, isCommercial);

            let logData = { event: LOGEVENT.SCHEDULE_EXPORT, module: MODULE.SCHEDULING, data: user, message: 'Partial Playlist Export' };
            API.SaveLogs(logData);

          },
          () => {
            //no -- noraml export
            let payload = SchedulingHelper.getPayload(date_ttc_milisecond, channel.SID, offsetTime)
            SchedulingHelper.downloadschedule(payload, automation, 0, doSftp, channel, isDeliver, withSCTE, isCommercial);
            let logData = { event: LOGEVENT.SCHEDULE_EXPORT, module: MODULE.SCHEDULING, data: user, message: 'SCHEDULE_EXPORT' };
            API.SaveLogs(logData);

          },
          "Confirm Export",
          `Do you want to export playlist from ${utility.convertMilisecondsToStringWithFrames(parent.SlotDateTime)} onwards?`
        );
      } else {
        let payload = SchedulingHelper.getPayload(date_ttc_milisecond, channel.SID, offsetTime)
        SchedulingHelper.downloadschedule(payload, automation, 0, doSftp, channel, isDeliver, withSCTE, isCommercial);
        let logData = { event: LOGEVENT.SCHEDULE_EXPORT, module: MODULE.SCHEDULING, data: user, message: 'SCHEDULE_EXPORT' };
        API.SaveLogs(logData);
      }
      return;
    }

    if (props.statusInfo.overRunUnderRunCount > 0 || failure.length > 0) {
      ConfirmAlert(
        () => {
          let payload = SchedulingHelper.getPayload(date_ttc_milisecond, channel.SID, offsetTime)
          console.log(payload);
          SchedulingHelper.downloadschedule(payload, automation, 0, doSftp, channel, isDeliver, withSCTE, isCommercial);
          if (failure.length > 0) {
            let logData = { event: LOGEVENT.SCHEDULE_EXPORT, module: MODULE.SCHEDULING, data: failure, message: 'CheckList Failure' };
            API.SaveLogs(logData);
          }
        },
        () => { },
        "Confirm Export",
        failure.length > 0 ?
          `Current playlist have ${failure.length} checklist case fails, Click YES to export with failed checklist cases and NO to cancel and fix playlist` :
          "Current playlist contains " + props.statusInfo.overRunUnderRunCount + " under/over runs, Click YES to export with under/over runs and NO to cancel and fix the under/over runs."
      );
    } else {
      let payload = SchedulingHelper.getPayload(date_ttc_milisecond, channel.SID, offsetTime)
      console.log(payload);
      SchedulingHelper.downloadschedule(payload, automation, 0, doSftp, channel, isDeliver, withSCTE, isCommercial);

      let logData = { event: LOGEVENT.SCHEDULE_EXPORT, module: MODULE.SCHEDULING, data: user, message: 'SCHEDULE_EXPORT' };
      API.SaveLogs(logData);

    }

  }

  const exportScheduledAnnouncement = async () => {
    console.log('here in exportScheduledAnnouncement');
    var tempData = []
    if (schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_scheduling_found_auto_fill_commercial_error });
      return;
    }

    schedulerDataRef.current.map((x) => {
      var [date, time] = utility.convertMilisecondsToDateTimeString(x.SlotDateTime).split(" ");

      var item = {
        ProgramDate: date,
        ProgramTime: time,
        ProgramTitle: x.mediaEpisode.Title,
      }

      if (x.children.length > 0) {
        x.children.map((y) => {
          var [childDate, childTime] = utility.convertMilisecondsToDateTimeString(y.SlotDateTime).split(' ');
          item.Time = childTime;
          if (y.Announcements && y.Announcements.length > 0) {
            y.Announcements.map((z) => {
              item.Title = z.Title;
              item.Description = z.Description ? z.Description : '';
              item.Duration = utility.convertMilisecondsToStringWithFrames(z.Duration);
              item.BookedTimeRange = `${utility.convertMilisecondsToShortTimeString(z.TimeRangeFrom)}-${utility.convertMilisecondsToShortTimeString(z.TimeRangeTo)}`
              tempData.push(item);
            })
          }
        })
      }
    })
    if (tempData.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'No Announcement attached' });
      return;
    }

    var res = await API.exportCSV(tempData);
    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onReturnSlotDateTimeToPlannedNominalTime = async () => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }

    if (schedulerDataRef.current == undefined || schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_load_schedule_first_error_message });
      return;
    }



    var scheduleLocal = schedulerDataRef.current;

    for (let index = 0; index < scheduleLocal.length; index++) {

      const parent = scheduleLocal[index];
      var parentIndex = schedulerDataRef.current.indexOf(parent);

      let schedulerDataRefLocal = schedulerDataRef.current;
      schedulerDataRefLocal[parentIndex].SlotDateTime = schedulerDataRefLocal[parentIndex].ScheduleDate;

      // ripplig cureent item
      schedulerDataRefLocal[parentIndex].children = getRippleChildrens(
        schedulerDataRefLocal[parentIndex],
        schedulerDataRefLocal[parentIndex].children,
        schedulerDataRefLocal
      );
      saveSchedule({ dataToSave: [schedulerDataRefLocal[parentIndex], ...schedulerDataRefLocal[parentIndex].children] });

    }

    // refresh schedule
    await loaddata(true);

  }

  const autoFillBookedCommercial = async (bookingData, fillInsideBreaksOnly = true) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    if (schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_scheduling_found_auto_fill_commercial_error });
      return;
    }

    var breakElements = [];
    schedulerDataRef.current.map((x) => {
      var breakItem = x.children.filter((y) => y.IsBreak == true);
      if (breakItem.length > 0) {
        breakElements = [...breakElements, ...breakItem]
      }
    })

    if (fillInsideBreaksOnly && breakElements.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_break_item_found_auto_fill_commercial_error });
      return;
    }

    if (bookingData.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_booked_spot_found_auto_fill_commercial_error });
      return;
    }

    const bookingDataLenght = bookingData.length;

    var totalCommercialPlotted = 0;
    var tempPlottedCommercial = 1; // for starting while loop

    setShowProgressBar({ okButton: false, progressBarPopup: true });

    // SEttiung Schedule Constraints
    var enabledScheduleConstraint = await getEnabledScheduleConstraints();

    var timerangeData = await API.getDataLookup(ENTITYNAME.TimeRange, { sort: { SID: 1 } });

    console.log(enabledScheduleConstraint);

    while (tempPlottedCommercial > 0) {
      tempPlottedCommercial = 0;

      var commercialLeftForAutoPlotting = bookingData;

      for (let index = 0; index < commercialLeftForAutoPlotting.length; index++) {

        // updating progress bar
        setProgressData({ message: bookingData.length + ' commercials left', progress: Math.ceil((100 * totalCommercialPlotted) / bookingDataLenght) });

        const bookedspot = commercialLeftForAutoPlotting[index];

        // finding best destination commercial break based on rule.
        var destinationRes = await getValidCommercialBreakDestination(bookedspot, fillInsideBreaksOnly);
        var destination = destinationRes.destination;
        if (destination == undefined) continue;

        var isValid = await SchedulingHelper.isValidDestination(destination, enabledScheduleConstraint, bookedspot, schedulerDataRef, fillInsideBreaksOnly, timerangeData?.data ?? []);

        var validTryCount = 0;
        if (!isValid) {

          const childrenCommercials = schedulerDataRef.current.find(x => x._id.toString() == destination.ParentProgramSchedule_id.toString())?.children.filter(x => x.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Commercial);

          // fetch childrens commercials of this header, we will try on all positions
          console.log("childrenCommercials: " + childrenCommercials.length);

          while (!isValid && validTryCount < childrenCommercials.length) {

            destination = childrenCommercials[validTryCount];
            console.log("checking each commercial drop: " + validTryCount);
            console.log(destination);

            if (destination) isValid = await SchedulingHelper.isValidDestination(destination, enabledScheduleConstraint, bookedspot, schedulerDataRef, fillInsideBreaksOnly, timerangeData?.data ?? []);
            console.log("isValid: " + isValid);
            validTryCount = validTryCount + 1;
          }
        }

        console.log("checking each valid break drop");
        console.log(destinationRes.validBreaks);

        const validCommercialBreaks = destinationRes.validBreaks.filter(x => x.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Commercial);
        if (!isValid && validCommercialBreaks.length > 0) {
          // now we will try on each header commercial children where possible
          validTryCount = 0;

          while (!isValid && validTryCount <= validCommercialBreaks.length) {
            validTryCount = validTryCount + 1;

            const uniquwIndex = Math.floor(Math.random() * validCommercialBreaks.length);
            destination = validCommercialBreaks[uniquwIndex];
            console.log("checking each valid break drop drop: " + uniquwIndex);
            isValid = await SchedulingHelper.isValidDestination(destination, enabledScheduleConstraint, bookedspot, schedulerDataRef, fillInsideBreaksOnly, timerangeData?.data ?? []);
            console.log("isValid: " + isValid);
          }
        }

        const validNonCommercialBreaks = destinationRes.validBreaks.filter(x => x.mediaEpisode?.MediaCategory?.SID != MEDIACATEGORIES.Commercial);
        if (!isValid && validNonCommercialBreaks.length > 0) {
          // now we will try on each header commercial children where possible
          validTryCount = 0;

          while (!isValid && validTryCount <= validNonCommercialBreaks.length) {
            validTryCount = validTryCount + 1;

            const uniquwIndex = Math.floor(Math.random() * validNonCommercialBreaks.length);
            destination = validNonCommercialBreaks[uniquwIndex];
            console.log("checking each valid break drop drop: " + uniquwIndex);
            isValid = await SchedulingHelper.isValidDestination(destination, enabledScheduleConstraint, bookedspot, schedulerDataRef, fillInsideBreaksOnly, timerangeData?.data ?? []);
            console.log("isValid: " + isValid);
          }
        }


        if (isValid) {

          console.log("placing now...");

          tempPlottedCommercial = tempPlottedCommercial + 1;
          totalCommercialPlotted = totalCommercialPlotted + 1;

          // removing booked spot from booking side
          deleteUsedBooking([bookedspot]);

          const dataToSave = SchedulingHelper.prepareData(
            ENTITYNAME.Booking,
            getSelectedChannel(),
            [bookedspot],
            destination,
            schedulerDataRef.current
          );
          // adding in schedule
          await addScheduleItems(destination, dataToSave, fillInsideBreaksOnly);

          // removing from local booked spots
          bookingData = bookingData.filter(x => x._id != bookedspot._id);

        }
      }
    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: totalCommercialPlotted + "  Commercials Plotted." });
    if (!fillInsideBreaksOnly) await saveCompleteScheduleChildrenandRefresh();
    setProgressData({ message: bookingData.length + ' commercials left, Process Completed !!', progress: 100 });
    setShowProgressBar({ progressBarPopup: true, okButton: true })
  }

  const getEnabledScheduleConstraints = async () => {

    const scheduleConstraintsRes = await API.getData(ENTITYNAME.ScheduleConstraints, { query: [["Type.ID", "=", MEDIA_TYPE[1].ID], ["Archive", "=", false]] });
    if (scheduleConstraintsRes.success && scheduleConstraintsRes.data.length > 0) {
      const channelFiltered = scheduleConstraintsRes.data.filter(x => x.Channel.SID == payloadref.current.channelSID);

      return channelFiltered.length > 0 ? channelFiltered[0].EnabledConstraints : [];
    }

    return [];

  }

  const getNextItemInSchedule = (destination) => {

    var nextItem = {}

    const { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(destination, schedulerDataRef.current);

    if (isInsideBreak) {
      const childLength = schedulerDataRef.current[level_0_index].children[level_1_index].children?.length ?? 0;
      nextItem = childLength > level_2_index + 1 ? schedulerDataRef.current[level_0_index].children[level_1_index].children[level_2_index + 1] : {}
    }
    else {
      const childLength = schedulerDataRef.current[level_0_index].children?.length ?? 0;
      nextItem = childLength > level_1_index + 1 ? schedulerDataRef.current[level_0_index].children[level_1_index + 1] : {};
    }

    return nextItem;

  }

  const getValidCommercialBreakDestination = async (bookedspot, fillInsideBreaksOnly) => {

    var destination = undefined;

    if (fillInsideBreaksOnly) {
      var validBreaks = [];

      // headers loop
      for (let index = 0; index < schedulerDataRef.current.length; index++) {
        const parent = schedulerDataRef.current[index];

        // break items commer type
        var commercialBreaks = parent.children.filter(x => x[IS_BREAK] && (x.mediaEpisode?.MediaCategoryType?.SID ?? 0) == MEDIACATEGORYTYPES.Commercial);

        if (commercialBreaks && commercialBreaks.length > 0) {

          const startTime = bookedspot.BookingDate + bookedspot.TimeRangeFrom;
          const endTime = bookedspot.BookingDate + bookedspot.TimeRangeTo;

          var updatedBookingStartTime = startTime;
          var updatedBookingEndTime = endTime;

          //CASE FOR 06:00-06:00 SCHEDULE DAY BOOKING  23:00 - 04:00
          if (bookedspot.TimeRangeFrom > bookedspot.TimeRangeTo) {
            var date = new Date(endTime);
            updatedBookingEndTime = date.setDate(date.getDate() + 1);

          }
          //CASE FOR 06:00-06:00 SCHEDULE DAY BOOKING SAME DAY  01:00 - 04:00
          else if (offsetTime > bookedspot.TimeRangeFrom) {
            var startDate = new Date(startTime);
            var endDate = new Date(endTime)
            updatedBookingStartTime = startDate.setDate(startDate.getDate() + 1);
            updatedBookingEndTime = endDate.setDate(endDate.getDate() + 1);

          }

          // filtering commercial breaks by start and end time
          commercialBreaks = commercialBreaks.filter(c => utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) >= updatedBookingStartTime && utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) < updatedBookingEndTime);

          // avoid break over run
          // (commercial breakchilren duration sum + booking spot duration) <= com break duration
          commercialBreaks = commercialBreaks.filter(c => ((c.children.filter(cf => cf.Type != SCHEDULETYPE.OverRun && cf.Type != SCHEDULETYPE.UnderRun)
            .map(bc => bc.mediaEpisode.Duration)
            .reduce((accumulator, current) => accumulator + current, 0)) + bookedspot.Duration) <= c.mediaEpisode.Duration);

          if (commercialBreaks.length > 0) validBreaks = [...validBreaks, ...commercialBreaks];

        }
      }

      if (validBreaks.length > 0) {
        destination = validBreaks.sort((a, b) => a.children.length - b.children.length)[0];
      }

    }
    else {

      var validBreaks = [];

      // headers loop
      for (let index = 0; index < schedulerDataRef.current.length; index++) {

        const parent = schedulerDataRef.current[index];

        const footer = parent.children.find((c) => c.Type == SCHEDULETYPE.UnderRun || c.Type == SCHEDULETYPE.OverRun);
        const hasSpace = (footer == undefined) || (footer && footer.Type == SCHEDULETYPE.UnderRun && footer.Duration >= bookedspot.mediaEpisode.Duration);
        if (!hasSpace) {
          continue;
        }

        // valid episode breaks
        var validDropDestinations = parent.children.filter(x => !x[IS_BREAK] && x.Type == SCHEDULETYPE.Segment || x.Type == SCHEDULETYPE.ShortForm);

        if (validDropDestinations && validDropDestinations.length > 0) {

          const startTime = bookedspot.BookingDate + bookedspot.TimeRangeFrom;
          const endTime = bookedspot.BookingDate + bookedspot.TimeRangeTo;

          var updatedBookingStartTime = startTime;
          var updatedBookingEndTime = endTime;

          //CASE FOR NEXT DAY BOOKING  23:00 - 04:00
          if (bookedspot.TimeRangeFrom > bookedspot.TimeRangeTo) {
            var date = new Date(endTime);
            updatedBookingEndTime = date.setDate(date.getDate() + 1);

          }
          //CASE FOR NEXT DAY BOOKING SAME DAY  01:00 - 04:00
          else if (offsetTime > bookedspot.TimeRangeFrom) {
            var startDate = new Date(startTime);
            var endDate = new Date(endTime)
            updatedBookingStartTime = startDate.setDate(startDate.getDate() + 1);
            updatedBookingEndTime = endDate.setDate(endDate.getDate() + 1);
          }

          // filtering commercial breaks by start and end time
          validDropDestinations = validDropDestinations.filter(c => (utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) + c.Duration) >= updatedBookingStartTime && (utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) + c.Duration) < updatedBookingEndTime);

          validBreaks = [...validBreaks, ...validDropDestinations];
        }
      }

      if (validBreaks.length > 0) {
        destination = await SchedulingHelper.findBestSlotForBookedCommercial(validBreaks, schedulerDataRef); // validBreaks[Math.floor(Math.random() * validBreaks.length)];
      }

    }

    console.log("returning destinateion");
    console.log(destination);
    return { destination: destination, validBreaks: validBreaks };
  }

  const ResetAutoFillPlaylistChildren = async (deleteallexceptsegment = true) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    console.log(schedulerDataRef.current);

    var itemsToDelete = [];
    schedulerDataRef.current.map(parent => {
      parent.children.map(child => {
        const isAutoFilled = deleteallexceptsegment || (child?.isAutoFill ?? false);
        if (child?.Type != SCHEDULETYPE.UnderRun && child?.Type != SCHEDULETYPE.OverRun && child?.Type != SCHEDULETYPE.Segment && isAutoFilled) {

          itemsToDelete.push(child);
          if (child[IS_BREAK] && child.children && child.children.length > 0) {

            child.children.map(breakchild => {
              if (breakchild?.Type != SCHEDULETYPE.UnderRun && breakchild?.Type != SCHEDULETYPE.OverRun && (deleteallexceptsegment || (breakchild?.isAutoFill ?? false))) {
                itemsToDelete.push(breakchild);
              }
            })

          }
        }
      })
    });

    if (itemsToDelete.length > 0) {

      // By Vishal, Was Getting Request Entity Too Large On Prod While Resetting Complete Playlist In One GO

      var tempCounter = 0;
      const chunk = 50;
      while (tempCounter <= itemsToDelete.length) {

        const tempItemsToDelete = itemsToDelete.slice(tempCounter, tempCounter + chunk);
        if (tempItemsToDelete && tempItemsToDelete.length > 0) await API.saveSchedule({ schedules: [], deletedschedules: tempItemsToDelete, });

        tempCounter = tempCounter + chunk;
      }

      // refresh schedule
      await loaddata(true);

    }

  }

  const executePromoCampaign = async () => {

    if (schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_scheduling_found_auto_fill_commercial_error });
      return;
    }

    // Promo Campaigns
    var validPromoCampaign = await SchedulingHelper.getValidPromoCampaigns();

    if (validPromoCampaign.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Promo Campaigns Found" });
      return;
    }

    for (let index = 0; index < validPromoCampaign.length; index++) {

      const campaign = validPromoCampaign[index];

      for (let index = 0; index < campaign.Trailers.length; index++) {
        const trailer = campaign.Trailers[index];

        console.log(trailer);

        switch (trailer.FrequencyType.Description) {
          case "ROS":
            // means run of schedule, we can fill anywhere in schedule upto frequency value


            // finding best destination commercial break based on rule.
            var destination = await getValidCommercialBreakDestination(trailer, false);


            break;
          case "ROP":
            // means run of program, we can fill in specific program upto frequency value
            break;
          case "RODP":
            // means run of day part, we can fill in specific day part of schedule upto frequency value
            break;
          default:
            break;
        }

        //   // finding best destination commercial break based on rule.
        // var destination = await getValidCommercialBreakDestination(bookedspot, fillInsideBreaksOnly);

        // const isValid = await SchedulingHelper.isValidDestination(destination, enabledScheduleConstraint, bookedspot, schedulerDataRef);

        // const dataToSave = SchedulingHelper.prepareData(
        //   ENTITYNAME.Booking,
        //   selectedChannel,
        //   [bookedspot],
        //   destination,
        //   schedulerDataRef.current
        // );
        // // adding in schedule
        // await addScheduleItems(destination, dataToSave, fillInsideBreaksOnly);

      }

    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Completed" });
    //await saveCompleteScheduleChildrenandRefresh();
    // setProgressData({ message: bookingData.length + ' commercials left, Process Completed !!', progress: 100 });
    // setShowProgressBar({ progressBarPopup: true, okButton: true })
  }

  const onReSyncHeaderSegments = async () => {

    setStatusMessage("Re-syncing Header's Segments...");

    if (schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_scheduling_found_to_resync_segments_error_message });
      setStatusMessage(lang.no_scheduling_found_to_resync_segments_error_message);
      return;
    }

    var headersToSync = await SchedulingHelper.getHeadersWithNoSegOrSegCountMissMatch(schedulerDataRef.current);

    console.log(headersToSync)

    if (headersToSync.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "No Invalid Headers found to Re-sync" });
      setStatusMessage("No Invalid Headers found to Re-sync");
      return;
    }

    let response = await API.resyncHeadersWithNoSegments(headersToSync);
    if (!response.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_not_found_label });
      return;
    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Segments Re-sync Completed" });
    setStatusMessage("Segments Re-sync Completed. Refreshing Schedule...");
    await loaddata();
  }

  const getValidPromoCampaignTrailerDropDestination = async (bookedspot) => {

    var destination = undefined;
    var validBreaks = [];

    // headers loop
    for (let index = 0; index < schedulerDataRef.current.length; index++) {

      const parent = schedulerDataRef.current[index];

      const footer = parent.children.find((c) => c.Type == SCHEDULETYPE.UnderRun || c.Type == SCHEDULETYPE.OverRun);
      const hasSpace = (footer == undefined) || (footer && footer.Type == SCHEDULETYPE.UnderRun && footer.Duration >= bookedspot.mediaEpisode.Duration);
      if (!hasSpace) {
        continue;
      }

      // valid episode breaks
      var validDropDestinations = parent.children.filter(x => !x[IS_BREAK] && x.Type == SCHEDULETYPE.Segment || x.Type == SCHEDULETYPE.ShortForm);

      if (validDropDestinations && validDropDestinations.length > 0) {

        const startTime = bookedspot.BookingDate + bookedspot.TimeRangeFrom;
        const endTime = bookedspot.BookingDate + bookedspot.TimeRangeTo;

        var updatedBookingStartTime = startTime;
        var updatedBookingEndTime = endTime;

        //CASE FOR NEXT DAY BOOKING  23:00 - 04:00
        if (bookedspot.TimeRangeFrom > bookedspot.TimeRangeTo) {
          var date = new Date(endTime);
          updatedBookingEndTime = date.setDate(date.getDate() + 1);

        }
        //CASE FOR NEXT DAY BOOKING SAME DAY  01:00 - 04:00
        else if (offsetTime > bookedspot.TimeRangeFrom) {
          var startDate = new Date(startTime);
          var endDate = new Date(endTime)
          updatedBookingStartTime = startDate.setDate(startDate.getDate() + 1);
          updatedBookingEndTime = endDate.setDate(endDate.getDate() + 1);
        }

        // filtering commercial breaks by start and end time
        validDropDestinations = validDropDestinations.filter(c => (utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) + c.Duration) >= updatedBookingStartTime && (utility.getSlotDateTimeByChannelTimeZone(selectedChannel, c.SlotDateTime) + c.Duration) < updatedBookingEndTime);

        validBreaks = [...validBreaks, ...validDropDestinations];
      }
    }

    if (validBreaks.length > 0) {
      destination = await SchedulingHelper.findBestSlotForBookedCommercial(validBreaks, schedulerDataRef); // validBreaks[Math.floor(Math.random() * validBreaks.length)];
    }

    console.log("returning destinateion");
    console.log(destination);
    return { destination: destination, validBreaks: validBreaks };
  }

  const fillUnderOverRun = async (scheduleTimeInfo, isForMultipleDays = false, multipleDayPayload = undefined) => {

    let allfooters = [];
    if (isForMultipleDays && multipleDayPayload != undefined) {

      const startDate = new Date(multipleDayPayload.FromDate).getTime();
      const endDate = new Date(multipleDayPayload.ToDate).getTime();

      let tempDate = startDate;
      while (tempDate <= endDate) {

        props.setSelectedDateandChannel(tempDate, multipleDayPayload.Channel);

        await createPayload(tempDate, multipleDayPayload.Channel.SID);
        await loaddata();

        await ResetAutoFillPlaylistChildren(true);
        await onReturnSlotDateTimeToPlannedNominalTime();

        await fillUnderOverRunWithStiching();

        // capturing footers left
        for (let index = 0; index < schedulerDataRef.current.length; index++) {
          const parent = schedulerDataRef.current[index];
          const footer = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
          if (footer && footer.Duration > 0) allfooters.push(footer);
          props.setFastplaylistReportData(allfooters);
        }


        // aadding one day
        tempDate = tempDate + MILLISECONDSINADAY;

      }
    }

    else { // single current day processing only
      await fillUnderOverRunWithStiching();
    }

  }

  const MoveFirstSegmentBreakItemToLastSegment = async () => {

    // CUT CHILDRENS FROM 1st seg and paste in Last Segment
    let localSchedulerData = [...schedulerDataRef.current];

    for (let h = 0; h < localSchedulerData.length; h++) {

      const header = localSchedulerData[h];
      const segments = header.children.filter((c) => c.Type == SCHEDULETYPE.Segment);

      const firstSegment = segments[0];
      const lastSegment = segments[segments.length - 1];
      const firstSegmentBreaks = header.children.filter((c) => c.BreakNo == firstSegment?.BreakNo && c?.Type == SCHEDULETYPE.ShortForm);

      if (lastSegment && firstSegmentBreaks && firstSegmentBreaks.length > 0) {

        await addScheduleItems(lastSegment, firstSegmentBreaks, true);
        await deleteScheduleItems(firstSegmentBreaks, true);

      }
    }
  }

  const fillUnderOverRunWithStiching = async () => {

    // We will stitch Episodes Under 15 Mins
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isKartoonChannel = (company?.Name ?? "") == "Kartoon Studios";
    const isGodare = (company?.Name ?? "") == "Godare";
    const isSMG = (company?.Name ?? "") == "SMG";
    const isOutdoor = (company?.Name ?? "") == "Outdoor";
    const isEcity = ((company?.Name ?? "") == "encompass") && payloadref.current.channelSID == 16; // change later PENDING
    const isRock = ((company?.Name ?? "") == "Rock")
    const isStarhub = ((company?.Name ?? "") == "Starhub")

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    if (schedulerDataRef.current == undefined || schedulerDataRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_load_schedule_first_error_message });
      return;
    }

    const { isvalid, headerstarttime } = await SchedulingHelper.IsAllHeadersSegmented(schedulerDataRef.current);
    console.log({ isvalid, headerstarttime });

    // not blocking SMG
    if (!isvalid && !isSMG && !isEcity && !isRock && !isStarhub) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: 'Process Aborted. Some headers are not segmented, starting ' + headerstarttime });
      return;
    }

    setShowProgressBar({ okButton: false, progressBarPopup: true });

    var autoDeleteOffFooterOffset = 0;
    var maxDamageOffset = 0;
    var useBottomUpApproach = false;
    const appconfig = await API.getEntitiesWithSearch(ENTITYNAME.ApplicationConfiguration);

    if (appconfig.success && appconfig.data && appconfig.data.length > 0) {
      const offsetObj = appconfig.data.find(x => x.Key == "AutoDeleteFooterOffset");
      autoDeleteOffFooterOffset = parseInt(offsetObj?.Value ?? 0);

      const maxDamageOffsetObj = appconfig.data.find(x => x.Key == "MaxFooterDamageOffset");
      maxDamageOffset = parseInt(maxDamageOffsetObj?.Value ?? 60000); // 1 Min Max Damage if No Setting

      const useBottomUpApproachObj = appconfig.data.find(x => x.Key == "AutoFillPlaylistUsingBottomUpApproach");
      useBottomUpApproach = useBottomUpApproachObj?.Value ?? false;
    }

    // PULL VARUATIONS ENABLED FOR THIS CHANNEL
    setProgressData({ message: "Fetching Variations...", progress: 10 });
    setStatusMessage("Fetching Variations...");
    const variationRes = await SchedulingHelper.getVariationsData(payloadref.current);

    if (isGodare) {

      //Apply Billboards
      setProgressData({ message: "Applying Bill Boards...", progress: 35 });
      setStatusMessage("Applying Bill Boards...");
      await ApplyBillBoards(variationRes);


      //set break opener closer
      setProgressData({ message: "Applying Break Bumpers...", progress: 55 });
      setStatusMessage("Applying Break Bumpers...");
      await ApplyBreakBumpers(variationRes);

      //fill underoverrun in each header
      setProgressData({ message: "Applying Fillers...", progress: 70 });
      setStatusMessage("Applying Fillers...");
      const headerIds = schedulerDataRef.current.map(x => x._id.toString());
      await ManageUnderAndOverRuns(headerIds, true, false, variationRes, false);


    }
    else if (isSMG) {

      // pulling latest previous date end date time
      const previousEndTimeRes = await API.getPreviousDayEndTime(payloadref.current);
      const prevEndDateTimeString = previousEndTimeRes && previousEndTimeRes.success && previousEndTimeRes.data > 0 ? previousEndTimeRes.data : 0
      await onMatchPreviousDayEndTime({ PreviousScheduleEndDateTime: prevEndDateTimeString });

      setProgressData({ message: "Filling Schedule...", progress: 15 });
      setStatusMessage("Filling Schedule...");
      console.log(variationRes);
      await FillFormatSequenceInSchedule(variationRes, false, isSMG, true); // keepFillingIfNoSpace

      //adding last position items in schedule
      setProgressData({ message: "Placing Last Position Items...", progress: 20 });
      setStatusMessage("Placing Last Position Items...")
      await PlacingLastPositionItems(variationRes);

      // Saving Schedule In Bulk
      setProgressData({ message: "Saving Schedule...", progress: 35 });
      setStatusMessage("Saving Schedule...");
      await saveCompleteScheduleChildrenandRefresh();

      //fill underoverrun in each header
      setProgressData({ message: "Managing Under and Over Runs...", progress: 40 });
      setStatusMessage("Managing Under and Over Runs...");
      const headerIds = schedulerDataRef.current.map(x => x._id.toString());
      await ManageUnderAndOverRuns(headerIds, true, false, variationRes, false);

      setProgressData({ message: "Replacing Childrens...", progress: 45 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly(variationRes, autoDeleteOffFooterOffset, false, MEDIATYPEENUM.ANY);

      setProgressData({ message: "Replacing Childrens...", progress: 60 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRuns(variationRes, autoDeleteOffFooterOffset, false, MEDIATYPEENUM.ANY);

      setProgressData({ message: "Refilling Schedule...", progress: 75 });
      setStatusMessage("Refilling Schedule...");
      await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset, true, false);


    }
    else if (isOutdoor) {

      // pulling latest previous date end date time
      const previousEndTimeRes = await API.getPreviousDayEndTime(payloadref.current);
      const prevEndDateTimeString = previousEndTimeRes && previousEndTimeRes.success && previousEndTimeRes.data > 0 ? previousEndTimeRes.data : 0
      await onMatchPreviousDayEndTime({ PreviousScheduleEndDateTime: prevEndDateTimeString });

      setProgressData({ message: "Filling Schedule...", progress: 15 });
      setStatusMessage("Filling Schedule...");
      console.log(variationRes);
      if (useBottomUpApproach) await FillFormatSequenceInScheduleBottomUpApproach(variationRes, false, isSMG, true);
      else await FillFormatSequenceInSchedule(variationRes, false, isSMG, true); // keepFillingIfNoSpace

      //adding last position items in schedule
      setProgressData({ message: "Placing Last Position Items...", progress: 20 });
      setStatusMessage("Placing Last Position Items...")
      await PlacingLastPositionItems(variationRes);

      // Saving Schedule In Bulk
      setProgressData({ message: "Saving Schedule...", progress: 35 });
      setStatusMessage("Saving Schedule...");
      await saveCompleteScheduleChildrenandRefresh();

      //fill underoverrun in each header
      setProgressData({ message: "Managing Under and Over Runs...", progress: 40 });
      setStatusMessage("Managing Under and Over Runs...");
      const headerIds = schedulerDataRef.current.map(x => x._id.toString());
      await ManageUnderAndOverRuns(headerIds, true, false, variationRes, false, MEDIATYPEENUM.CLOSING);

      setProgressData({ message: "Replacing Childrens...", progress: 45 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly(variationRes, autoDeleteOffFooterOffset, false, MEDIATYPEENUM.CLOSING);

      setProgressData({ message: "Replacing Childrens...", progress: 60 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRuns(variationRes, autoDeleteOffFooterOffset, false, MEDIATYPEENUM.CLOSING);

      setProgressData({ message: "Refilling Schedule...", progress: 75 });
      setStatusMessage("Refilling Schedule...");
      await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset, true, false);


    }
    else if (isEcity) {

      // pulling latest previous date end date time
      const previousEndTimeRes = await API.getPreviousDayEndTime(payloadref.current);
      const prevEndDateTimeString = previousEndTimeRes && previousEndTimeRes.success && previousEndTimeRes.data > 0 ? previousEndTimeRes.data : 0
      await onMatchPreviousDayEndTime({ PreviousScheduleEndDateTime: prevEndDateTimeString });

      setProgressData({ message: "Filling Schedule...", progress: 15 });
      setStatusMessage("Filling Schedule...");
      console.log(variationRes);
      if (useBottomUpApproach) await FillFormatSequenceInScheduleBottomUpApproach(variationRes, false, isSMG, true);
      else await FillFormatSequenceInSchedule(variationRes, false, isSMG, true); // keepFillingIfNoSpace

      //Placing Rating Slide and Rating Bug
      setProgressData({ message: "Placing Rating Slide...", progress: 65 });
      setStatusMessage("Placing Last Position Items...")
      await PlaceRatingSlideAndRatingBug();

    }
    else if (isRock) {

      const chnl = getSelectedChannel();
      const isGT = chnl.FullChannelName.replaceAll(" ", "").toLowerCase() == "globaltrekker";

      // pulling latest previous date end date time
      const previousEndTimeRes = await API.getPreviousDayEndTime(payloadref.current);
      const prevEndDateTimeString = previousEndTimeRes && previousEndTimeRes.success && previousEndTimeRes.data > 0 ? previousEndTimeRes.data : 0
      await onMatchPreviousDayEndTime({ PreviousScheduleEndDateTime: prevEndDateTimeString });

      setProgressData({ message: "Filling Schedule...", progress: 25 });
      setStatusMessage("Filling Schedule...");
      console.log(variationRes);
      await FillFormatSequenceInSchedule(variationRes, false, isSMG, false); // keepFillingIfNoSpace


      if (isGT) {

        //Move 1st segment break item to last segment
        setProgressData({ message: "Moving First Segment Break Item...", progress: 65 });
        setStatusMessage("Moving First Segment Break Item...")
        await MoveFirstSegmentBreakItemToLastSegment();

      } else {

        setProgressData({ message: "Refilling Schedule...", progress: 55 });
        setStatusMessage("Refilling Schedule...");
        await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset, true, false);

      }

    }
    else if (isStarhub) {

      //Placing Rating Slide and Rating Bug
      setProgressData({ message: "Placing Parental Rating...", progress: 25 });
      setStatusMessage("Placing Parental Rating...")
      await PlaceParentalRatingsStarhub();

      const isVVD = getSelectedChannel().FullChannelName.replaceAll(" ", "").toLowerCase() == "hubvvdramahd";

      if (isVVD) {

        // Place Sign-off ID
        await PlaceSignOffIdOnLastSegment()

        // Place Channel ID in Last
        const variationRes = await SchedulingHelper.getVariationsData(payloadref.current);
        await PlacingLastPositionItems(variationRes);

      }

    }
    else {

      // pulling latest previous date end date time
      const previousEndTimeRes = await API.getPreviousDayEndTime(payloadref.current);
      const prevEndDateTimeString = previousEndTimeRes && previousEndTimeRes.success && previousEndTimeRes.data > 0 ? previousEndTimeRes.data : 0
      await onMatchPreviousDayEndTime({ PreviousScheduleEndDateTime: prevEndDateTimeString });

      setProgressData({ message: "Filling Schedule...", progress: 15 });
      setStatusMessage("Filling Schedule...");
      await FillFormatSequenceInSchedule(variationRes, isKartoonChannel, isSMG, false);

      //adding last position items in schedule
      setProgressData({ message: "Placing Last Position Items...", progress: 20 });
      setStatusMessage("Placing Last Position Items...")
      await PlacingLastPositionItems(variationRes);

      //adding Fixed Slot item in schedule
      setProgressData({ message: "Placing Fixed Position Items...", progress: 25 });
      setStatusMessage("Placing Fixed Position Items...")
      await PlacingFixedPositionItems(variationRes);

      //ONLY FOR KARTOON ADDING IDENT ON TOP OF PLAYLIST
      if ((company?.Name ?? "") == "Kartoon Studios") {
        await PlacingFirstPositionItem(variationRes);
      }

      // Saving Schedule In Bulk
      setProgressData({ message: "Saving Schedule...", progress: 35 });
      setStatusMessage("Saving Schedule...");
      await saveCompleteScheduleChildrenandRefresh();


      setProgressData({ message: "Replacing Childrens...", progress: 45 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly(variationRes, autoDeleteOffFooterOffset, false);


      setProgressData({ message: "Replacing Childrens...", progress: 60 });
      setStatusMessage("Replacing Childrens...");
      await ReplaceItemsToMatchUnderAndOverRuns(variationRes, autoDeleteOffFooterOffset, false);

      setProgressData({ message: "Refilling Schedule...", progress: 75 });
      setStatusMessage("Refilling Schedule...");
      await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset);

      setProgressData({ message: "Refilling Schedule...", progress: 80 });
      setStatusMessage("Refilling Schedule...");
      await MaximumDamageControl(maxDamageOffset);

      setProgressData({ message: "Packing Playlist for 24 Hours...", progress: 85 });
      setStatusMessage("Packing Playlist for 24 Hours...");
      await PackPlaylistFor24Hours(variationRes);


      // this function is currently for kartoon channel only.
      setProgressData({ message: "Sequencing Idents and Creatives...", progress: 90 });
      setStatusMessage("Sequencing Idents and Creatives...");

      if (isKartoonChannel) { // for KARTOON Only

        // if still under and over runs are left we will delete extra ad breaks from schedule
        if (payloadref.current.channelSID == 2) {
          await DeleteExtraAdBreaksKCVGH(variationRes, autoDeleteOffFooterOffset, maxDamageOffset);
        }

        if (payloadref.current.channelSID != 2) await SequenceVarianceInSchedule(variationRes, MEDIACATEGORYTYPES.Ident, false); // KC
        if (payloadref.current.channelSID != 2) await SequenceVarianceInSchedule(variationRes, MEDIACATEGORYTYPES.ChannelPromo, false); // KC
        if (payloadref.current.channelSID == 2) await SequenceAdBreaksInSchedule(variationRes, false); // KCVGH

      }



    }

    // Saving Schedule In Bulk finally
    setProgressData({ message: "Saving Schedule...", progress: 95 });
    setStatusMessage("Saving Schedule...");
    await saveCompleteScheduleChildrenandRefresh();


    setProgressData({ message: lang.process_completed_success_message, progress: 100 });
    setShowProgressBar({ progressBarPopup: true, okButton: true })

    setStatusMessage(lang.process_completed_success_message);

  }

  const FillFormatSequenceInSchedule = async (variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace) => {

    if (variationRes.success && variationRes.data && variationRes.data.length > 0) {

      // pull default format for this channel
      let defaultFormat = await SchedulingHelper.getDefaultFormat(payloadref.current.channelSID);
      console.log(defaultFormat);

      const formatSchedules = await SchedulingHelper.getFormatByDateAndChannel(payloadref.current.channelSID, payloadref.current.BookingDate);

      // we can pull media library here which can be used.
      let completemediaLibrary = [];
      const mediaLibraryRes = await API.loadSchedulingCompleteMediaLibrary(payloadref.current);
      if (mediaLibraryRes.success) {
        completemediaLibrary = mediaLibraryRes.data;
      }


      var allHeaders = schedulerDataRef.current;
      var stitchCurrentEpisode = false;
      var stitchedEpisodeindex = -1;


      for (let index = 0; index < allHeaders.length; index++) {
        const parent = allHeaders[index];
        const isLive = parent.TXStatus.SID == TX_STATUS.Live;


        // checking if slot specific format is configured
        const slotFormat = await SchedulingHelper.getValidSlotSpecificFormat(formatSchedules, parent.SlotDateTime);

        const formatToApply = slotFormat && slotFormat.FormatDetail ? slotFormat : defaultFormat;

        // finding segments and other children in header.
        const totalSegmentInParent = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);
        const childrenOtherThanSegment = parent.children.filter(x => x.Type != SCHEDULETYPE.Segment && x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun);

        // skipping if header is not segmented yet or children already exists.
        //if (totalSegmentInParent.length == 0 || childrenOtherThanSegment.length > 0) continue;
        if (childrenOtherThanSegment.length > 0) continue;


        // if (!stitchCurrentEpisode
        //   && (stitchedEpisodeindex == -1 || index != stitchedEpisodeindex)
        //   && parent.Duration <= 900000 && (allHeaders.length >= index + 1)
        //   && allHeaders[index + 1]?.Duration <= 900000
        //   && parent.mediaEpisode?.Season_id == allHeaders[index + 1]?.mediaEpisode?.Season_id) {
        //   stitchCurrentEpisode = true;
        // }

        if (formatToApply && formatToApply.FormatDetail && formatToApply.FormatDetail.length > 0) {

          var isSegmentFound = false;
          var formatElementBreakNo = 0;
          var skippedItems = 0;
          for (let fi = 0; fi < formatToApply.FormatDetail.length; fi++) {
            const formatElement = formatToApply.FormatDetail[fi];


            // skipping segments from format
            if (formatElement.Type == SCHEDULETYPE.Segment) {
              isSegmentFound = true;
              formatElementBreakNo = formatElementBreakNo + 1;
              if (stitchCurrentEpisode) {


                if (payloadref.current.channelSID == 2) {
                  await AddKRRAdAndIdentKCVGH(variationRes, parent); // KCVGH
                }

                // delete footer of this parent 
                const footer = await SchedulingHelper.findFooter(parent, schedulerDataRef.current);
                if (footer) await deleteFooter(footer);

                //break
                stitchCurrentEpisode = false;
                stitchedEpisodeindex = index + 1;
                break;

              }
              else continue;
            }

            if (index == stitchedEpisodeindex && !isSegmentFound) {
              continue;
            }

            // if format is for more break than episode we will break it. 
            if (formatElementBreakNo > totalSegmentInParent.length) break;

            const isLastHeader = (index == (allHeaders.length - 1));

            // if final header we will calculate space left by header duration
            var spaceLeft = await SchedulingHelper.findSpaceLeftInHeaderToPlace(parent, schedulerDataRef.current);
            if (!isLastHeader) {
              if (spaceLeft == 0 && !keepFillingIfNoSpace) {
                break;
              }
            }

            // if last header, we cannot go beyond 24 hours
            console.log("parent index:" + index);
            if (isLastHeader && SchedulingHelper.IsPlaylist24HourReached(payloadref.current, schedulerDataRef.current)) break;

            const hasFooter = schedulerDataRef.current[index].children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
            const lastChildIndex = schedulerDataRef.current[index].children.length - (hasFooter ? 2 : 1);


            console.log("fi:" + fi);
            console.log(skippedItems);

            const fiIndex = fi - skippedItems;
            const dst = fiIndex == 0
              ? parent
              : ((fiIndex - 1) > lastChildIndex ? schedulerDataRef.current[index].children[lastChildIndex] : schedulerDataRef.current[index].children[fiIndex - 1]);

            const finalMediaToPlace = fetchMediaOldStyle
              ? await SchedulingHelper.findBestElementToPlaceInSchedule(formatElement, variationRes.data, totalSegmentInParent.length, spaceLeft, formatElementBreakNo, parent, schedulerDataRef.current, isLastHeader, dst)
              : await SchedulingHelper.findBestElementToPlaceInScheduleNew(formatElement, variationRes.data, totalSegmentInParent.length, spaceLeft, formatElementBreakNo, parent, schedulerDataRef.current, isLastHeader, dst, completemediaLibrary);

            if (finalMediaToPlace == undefined) {
              console.log(finalMediaToPlace);
              console.log("breaking....no finalMediaToPlace found");
              break;
            }

            const varianceType = formatElement.VariationType ?? FORMATVARIATIONTYPE.Fixed;
            const varianceSID = (varianceType == FORMATVARIATIONTYPE.FixedFamily) ? formatElement.mediaEpisode.Variance?.SID ?? 0 : 0;

            // if isSMG && isLive && finalMediaToPlace.mediaEpisode?.AssetId starts with BMP- we will not place it.
            const isBMP = finalMediaToPlace.AssetId?.toString().startsWith("BMP-") ?? false;
            const isLastBreak = dst?.BreakNo && dst?.BreakNo > 0 && dst?.BreakNo == totalSegmentInParent.length;
            if (isSMG && isBMP && (isLive || isLastBreak)) {
              skippedItems = skippedItems + 1;
              continue;
            }


            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [finalMediaToPlace],
              dst, // destination
              schedulerDataRef.current,
              true, // isNew
              true, // isAutoFill
              varianceSID
            );
            await addScheduleItems(dst, dataToSave, false);

          }
        }
      }
    }

  }

  const FillFormatSequenceInScheduleBottomUpApproach = async (variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace) => {

    if (variationRes.success && variationRes.data && variationRes.data.length > 0) {

      // pull default format for this channel
      let defaultFormat = await SchedulingHelper.getDefaultFormat(payloadref.current.channelSID);
      console.log(defaultFormat);

      const formatSchedules = await SchedulingHelper.getFormatByDateAndChannel(payloadref.current.channelSID, payloadref.current.BookingDate);

      // we can pull media library here which can be used.
      let completemediaLibrary = [];
      const mediaLibraryRes = await API.loadSchedulingCompleteMediaLibrary(payloadref.current);
      if (mediaLibraryRes.success) {
        completemediaLibrary = mediaLibraryRes.data;
      }


      var allHeaders = schedulerDataRef.current;
      var stitchCurrentEpisode = false;
      var stitchedEpisodeindex = -1;


      for (let index = 0; index < allHeaders.length; index++) {
        const parent = allHeaders[index];
        const isLive = parent.TXStatus.SID == TX_STATUS.Live;


        // checking if slot specific format is configured
        const slotFormat = await SchedulingHelper.getValidSlotSpecificFormat(formatSchedules, parent.SlotDateTime);

        const formatToApply = slotFormat && slotFormat.FormatDetail ? slotFormat : defaultFormat;

        // finding segments and other children in header.
        const totalSegmentInParent = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);
        const childrenOtherThanSegment = parent.children.filter(x => x.Type != SCHEDULETYPE.Segment && x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun);

        // skipping if header is not segmented yet or children already exists.
        //if (totalSegmentInParent.length == 0 || childrenOtherThanSegment.length > 0) continue;
        if (childrenOtherThanSegment.length > 0) continue;


        if (!stitchCurrentEpisode
          && (stitchedEpisodeindex == -1 || index != stitchedEpisodeindex)
          && parent.Duration <= 900000 && (allHeaders.length >= index + 1)
          && allHeaders[index + 1]?.Duration <= 900000
          && parent.mediaEpisode?.Season_id == allHeaders[index + 1]?.mediaEpisode?.Season_id) {
          stitchCurrentEpisode = true;
        }

        if (formatToApply && formatToApply.FormatDetail && formatToApply.FormatDetail.length > 0) {



          // first we need to fill last segment 
          // find break in format for the last segment
          const segmentFromFormat = formatToApply.FormatDetail.find(x => x.Type == SCHEDULETYPE.Segment && x.BreakNo == totalSegmentInParent.length);

          if (segmentFromFormat && formatToApply.FormatDetail.indexOf(segmentFromFormat) >= 0) {

            const startingIndex = formatToApply.FormatDetail.indexOf(segmentFromFormat);

            // starting placement index from that element
            for (let fi = startingIndex + 1; fi < formatToApply.FormatDetail.length; fi++) {

              const formatElement = formatToApply.FormatDetail[fi];

              // stopping when next segment comes, end of break
              if (formatElement.Type == SCHEDULETYPE.Segment) {
                break;
              }

              const hasFooter = schedulerDataRef.current[index].children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
              const lastChildIndex = schedulerDataRef.current[index].children.length - (hasFooter ? 2 : 1);


              const fiIndex = fi;
              const dst = fiIndex == 0
                ? parent
                : ((fiIndex - 1) > lastChildIndex ? schedulerDataRef.current[index].children[lastChildIndex] : schedulerDataRef.current[index].children[fiIndex - 1]);

              const finalMediaToPlace = fetchMediaOldStyle
                ? await SchedulingHelper.findBestElementToPlaceInSchedule(formatElement, variationRes.data, totalSegmentInParent.length, MILLISECONDSINADAY, totalSegmentInParent.length, parent, schedulerDataRef.current, false, dst)
                : await SchedulingHelper.findBestElementToPlaceInScheduleNew(formatElement, variationRes.data, totalSegmentInParent.length, MILLISECONDSINADAY, totalSegmentInParent.length, parent, schedulerDataRef.current, false, dst, completemediaLibrary);

              if (finalMediaToPlace == undefined) {
                console.log(finalMediaToPlace);
                console.log("breaking....no finalMediaToPlace found");
                break;
              }

              const varianceType = formatElement.VariationType ?? FORMATVARIATIONTYPE.Fixed;
              const varianceSID = (varianceType == FORMATVARIATIONTYPE.FixedFamily) ? formatElement.mediaEpisode.Variance?.SID ?? 0 : 0;

              // if isSMG && isLive && finalMediaToPlace.mediaEpisode?.AssetId starts with BMP- we will not place it.
              const isBMP = finalMediaToPlace.AssetId?.toString().startsWith("BMP-") ?? false;
              const isLastBreak = dst?.BreakNo && dst?.BreakNo > 0 && dst?.BreakNo == totalSegmentInParent.length;
              if (isSMG && isBMP && (isLive || isLastBreak)) continue;

              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [finalMediaToPlace],
                dst, // destination
                schedulerDataRef.current,
                true, // isNew
                true, // isAutoFill
                varianceSID
              );
              await addScheduleItems(dst, dataToSave, false);

            }
          }




          // Now Fill The Rest Of Breaks

          var isSegmentFound = false;
          var formatElementBreakNo = 0;
          var skippedItems = 0;


          for (let fi = 0; fi < formatToApply.FormatDetail.length; fi++) {
            const formatElement = formatToApply.FormatDetail[fi];


            // if reaches last break we will stop because last break already filled.
            if (formatElement.Type == SCHEDULETYPE.Segment && formatElement.BreakNo == totalSegmentInParent.length) {
              break;
            }

            // skipping segments from format
            if (formatElement.Type == SCHEDULETYPE.Segment) {
              isSegmentFound = true;
              formatElementBreakNo = formatElementBreakNo + 1;
              if (stitchCurrentEpisode) {


                if (payloadref.current.channelSID == 2) {
                  await AddKRRAdAndIdentKCVGH(variationRes, parent); // KCVGH
                }

                // delete footer of this parent 
                const footer = await SchedulingHelper.findFooter(parent, schedulerDataRef.current);
                if (footer) await deleteFooter(footer);

                //break
                stitchCurrentEpisode = false;
                stitchedEpisodeindex = index + 1;
                break;

              }
              else continue;
            }

            if (index == stitchedEpisodeindex && !isSegmentFound) {
              continue;
            }

            // if format is for more break than episode we will break it. 
            if (formatElementBreakNo > totalSegmentInParent.length) break;

            const isLastHeader = (index == (allHeaders.length - 1));

            // if final header we will calculate space left by header duration
            var spaceLeft = await SchedulingHelper.findSpaceLeftInHeaderToPlace(parent, schedulerDataRef.current);
            if (!isLastHeader) {
              if (spaceLeft == 0 && !keepFillingIfNoSpace) {
                break;
              }
            }

            // if last header, we cannot go beyond 24 hours
            console.log("parent index:" + index);
            if (isLastHeader && SchedulingHelper.IsPlaylist24HourReached(payloadref.current, schedulerDataRef.current)) break;

            const hasFooter = schedulerDataRef.current[index].children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
            const lastChildIndex = schedulerDataRef.current[index].children.length - (hasFooter ? 2 : 1);


            console.log("fi:" + fi);
            console.log(skippedItems);

            const fiIndex = fi - skippedItems;
            const dst = fiIndex == 0
              ? parent
              : ((fiIndex - 1) > lastChildIndex ? schedulerDataRef.current[index].children[lastChildIndex] : schedulerDataRef.current[index].children[fiIndex - 1]);

            // this is juggad so that if break filling started then it should complete the break format style filling.
            if (dst != parent && dst.Type != SCHEDULETYPE.Segment) {
              spaceLeft = MILLISECONDSINADAY;
            }

            const finalMediaToPlace = fetchMediaOldStyle
              ? await SchedulingHelper.findBestElementToPlaceInSchedule(formatElement, variationRes.data, totalSegmentInParent.length, spaceLeft, formatElementBreakNo, parent, schedulerDataRef.current, isLastHeader, dst)
              : await SchedulingHelper.findBestElementToPlaceInScheduleNew(formatElement, variationRes.data, totalSegmentInParent.length, spaceLeft, formatElementBreakNo, parent, schedulerDataRef.current, isLastHeader, dst, completemediaLibrary);

            if (finalMediaToPlace == undefined) {
              console.log(finalMediaToPlace);
              console.log("breaking....no finalMediaToPlace found");
              break;
            }

            const varianceType = formatElement.VariationType ?? FORMATVARIATIONTYPE.Fixed;
            const varianceSID = (varianceType == FORMATVARIATIONTYPE.FixedFamily) ? formatElement.mediaEpisode.Variance?.SID ?? 0 : 0;

            // if isSMG && isLive && finalMediaToPlace.mediaEpisode?.AssetId starts with BMP- we will not place it.
            const isBMP = finalMediaToPlace.AssetId?.toString().startsWith("BMP-") ?? false;
            const isLastBreak = dst?.BreakNo && dst?.BreakNo > 0 && dst?.BreakNo == totalSegmentInParent.length;
            if (isSMG && isBMP && (isLive || isLastBreak)) {
              skippedItems = skippedItems + 1;
              continue;
            }


            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [finalMediaToPlace],
              dst, // destination
              schedulerDataRef.current,
              true, // isNew
              true, // isAutoFill
              varianceSID
            );
            await addScheduleItems(dst, dataToSave, false);

          }
        }
      }
    }

  }

  const ManageUnderAndOverRuns = async (header_ids, placeAllItemsInLast = false, pullVariations = true, variationData = undefined, checkBackToBackSameCategory = true, mediaTypeEnum = MEDIATYPEENUM.ANY) => {

    // Outdoor Wants To Have Fillers Above Last ID
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isOutdoor = (company?.Name ?? "") == "Outdoor";

    const variationRes = variationData;
    if (pullVariations) variationRes = await SchedulingHelper.getVariationsData(payloadref.current);

    if (!variationRes.success || variationRes.data.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Variations Found" });
      return;
    }

    var data = variationRes.data.find(x => x.MediaType.SID == mediaTypeEnum);

    if (!data || !data.MediaEpisodes || data.MediaEpisodes.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Variations Found For Managing Under/Over Runs" });
      return;
    }

    var availableVariations = data.MediaEpisodes;

    for (let index = 0; index < header_ids.length; index++) {
      const header_id = header_ids[index];
      console.log("header_id");
      console.log(header_id);

      let parent = schedulerDataRef.current.find(x => x._id.toString() == header_id.toString());
      if (!parent) {
        continue;
      }

      if (!parent.children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun)) {
        continue;
      }

      var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun);
      var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
      if (footerDuration == 0) continue;


      var segments = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);

      var lastChild = parent.children.length > 1 ? parent.children[parent.children.length - 2] : undefined;
      var groupedItems = await SchedulingHelper.getInterstitialsForSameDurationOfFooter(footerDuration, availableVariations, lastChild, checkBackToBackSameCategory);

      let placeOnSegIndex = 0;
      for (let gi = 0; gi < groupedItems.length; gi++) {
        const item = groupedItems[gi];

        let destination = placeAllItemsInLast ? footerChild : (segments.length > 0 ? segments[placeOnSegIndex] : footerChild);

        // if isOutdoor, and ident in last, then place above ident
        if (isOutdoor && placeAllItemsInLast && lastChild.mediaEpisode?.AssetId?.toString().startsWith("OCI")) {
          // giving item above last ident as destination
          destination = parent.children.length > 2 ? parent.children[parent.children.length - 3] : destination;
        }

        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [item],
          destination,
          schedulerDataRef.current,
          true, // isNew
          true // isAutoFill
        );
        await addScheduleItems(destination, dataToSave, pullVariations); // pull variations means it is not coming from playliust auto fill

        placeOnSegIndex = (placeOnSegIndex + 1);
        if (placeOnSegIndex >= segments.length) placeOnSegIndex = 0;
      }

    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Process Completed Successfully" });
  }

  const CopyHeaderBreakElements = async (header_id) => {

    if (header_id == null || header_id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a header" });
      return;
    }

    let parent = schedulerDataRef.current.find(x => x._id.toString() == header_id.toString());

    if (parent == null || parent == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Header not found in schedule" });
      return;
    }

    // means other than segments we should have some breaks
    if (parent.children == undefined || parent.children.some(x => x.Type != SCHEDULETYPE.Segment && x.Type == SCHEDULETYPE.UnderRun && x.Type == SCHEDULETYPE.OverRun)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Header doesn't have any break elements to copy" });
      return;
    }

    console.log(parent.children);
    console.log(parent.children.filter(x => x.Type == SCHEDULETYPE.ShortForm && (x.Booking_id == undefined || x.Booking_id == "")));

    // saving break in local storage
    utility.setValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS, parent.children.filter(x => x.Type == SCHEDULETYPE.ShortForm && (x.Booking_id == undefined || x.Booking_id == "")));
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Breaks copies successfully" });
  }

  const PasteHeaderBreakElements = async (header_id) => {

    if (header_id == null || header_id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "ERROR", message: "Please select a header" });
      return;
    }

    var copiedElements = utility.getValue(LOCALSTORAGE_KEY.COPYBREAKELEMENTS);
    if (copiedElements == null || copiedElements.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "ERROR", message: "No copied break elements found" });
      return;
    }

    let parent = schedulerDataRef.current.find(x => x._id.toString() == header_id.toString());

    if (parent == null || parent == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "ERROR", message: "Header not found in schedule" });
      return;
    }

    // start process of pasting these elements
    console.log(copiedElements);

    //FETCH COMMERCIALS FROM LOAD SCHEDULE MEDIA LIBRARY API
    let breaksAssetIds = [...new Set(copiedElements.map(item => item.mediaEpisode.AssetId))];
    console.log(breaksAssetIds)

    let validBreaksResponse = await API.loadSchedulingMediaLibrary(
      '',
      {},
      props.scheduleMediaLibraryPayload,
      true,
      { per_page: 200, current_page: 1, orderby: 'SID', direction: 'asc' },
      false,
      breaksAssetIds
    );


    let skippedShortForms = [];
    if (validBreaksResponse.success && validBreaksResponse.data) {

      // Starting Pasting Work

      for (let index = 0; index < copiedElements.length; index++) {
        const element = copiedElements[index];

        const mediaLibraryElement = validBreaksResponse.data.find((com) => com.AssetId == element.mediaEpisode.AssetId);
        console.log("mediaLibraryElement");
        console.log(mediaLibraryElement);
        let validDestinationItems = schedulerDataRef.current.find(x => x._id.toString() == header_id.toString())?.children.filter(x => x.BreakNo == element.BreakNo);
        console.log("validDestinationItems");
        console.log(validDestinationItems);

        if (validDestinationItems != undefined && validDestinationItems.length > 0) {

          const destination = validDestinationItems[validDestinationItems.length - 1];

          //CASE : TIME RESTRICTION
          const timeRestrictions = mediaLibraryElement.TimeRestriction ? (Array.isArray(mediaLibraryElement.TimeRestriction) ? mediaLibraryElement.TimeRestriction : [mediaLibraryElement.TimeRestriction]) : [];
          if (destination && timeRestrictions.length > 0) {
            console.log("timeRestrictions", timeRestrictions);

            let scheduleDate = utility.convertStringDatetoMilliseconds(utility.convertMilisecondsToDateString(destination.SlotDateTime));

            // check if baseStartTime falls within ANY restriction range
            const isWithinRestriction = timeRestrictions.some(restriction =>
              destination.SlotDateTime >= (scheduleDate + restriction.From) &&
              destination.SlotDateTime <= (scheduleDate + restriction.To)
            );

            if (isWithinRestriction) {
              // skip this element and move to next one in loop
              skippedShortForms.push(mediaLibraryElement);
              continue;
            }

          }

          const dataToSave = SchedulingHelper.prepareData(
            ENTITYNAME.MediaEpisode,
            getSelectedChannel(),
            [mediaLibraryElement],
            destination,
            schedulerDataRef.current,
            true,
          );
          await addScheduleItems(destination, dataToSave, true);

        }
      }
    }


    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Paste breaks completed successfully. ${skippedShortForms.length > 0 ? `Skipped ${skippedShortForms.length} elements, due to time restrictions` : ''}` });

  }

  const autoFillMusic = async (header, allHeader = false) => {

    let musicCategory = header.mediaEpisode.MusicCategory ?? null;
    if (musicCategory == null) {
      if (!allHeader)
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Music Category Not Found" });
      return;
    }

    const destination = header;
    const musicData = await SchedulingHelper.getMusicItems(header.mediaEpisode.MusicCategory, true);

    if (!musicData || musicData.length == 0) {
      if (!allHeader)
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Music Found" });
      return;
    }

    let remainingDurationToFill = destination.Duration - header.children.filter(x => x.Type != SCHEDULETYPE.OverRun && x.Type != SCHEDULETYPE.UnderRun).reduce((a, b) => a + b.Duration, 0);

    let fillDuration = 0

    //ADD MUSICS 
    let i = 0;
    let skipLoopCount = 0;
    while (fillDuration < remainingDurationToFill) {

      const item = musicData[i];

      const isValidMusic = await SchedulingHelper.checkMusicValidity(item, header, schedulerDataRef.current);
      if (!isValidMusic) {
        skipLoopCount++;
        if (skipLoopCount >= musicData.length) break;
        continue;
      }

      const dataToSave = SchedulingHelper.prepareData(
        ENTITYNAME.MediaEpisode,
        getSelectedChannel(),
        [item],
        destination,
        schedulerDataRef.current,
        true
      );
      await addScheduleItems(destination, dataToSave);
      skipLoopCount = 0;

      fillDuration += item.Duration;
      i++;
      if (i >= musicData.length) i = 0;

    }

    if (!allHeader)
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Process Completed Successfully" });
  }

  const autoFillPlaylistWithMusic = async (data) => {

    if (!data || data.length == 0) return;

    for (let i = 0; i < data.length; i++) {
      const header = data[i];
      await autoFillMusic(header, true);
    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Process Completed Successfully" });
  }

  // Simplified validMediaForSCTE function
  const validMediaForSCTE = (shortForm, isLive = false, index, channel) => {
    if (!shortForm?.mediaEpisode?.MediaCategoryType?.Description) {
      return false;
    }

    let ignoredCategories = channel.SCTEExcludeType && channel.SCTEExcludeType.length > 0 ? channel.SCTEExcludeType.map((x) => x.Description) : [];

    //HARDCODED Media Category Types IN PREV LOGIC.
    // [
    //   "Slate",
    //   "Lead In/Out",
    //   "Sponsored Promo",
    //   "Marketing Promo",
    //   "Bumper In/Out",
    //   "ID",
    //   "Channel ID",
    //   "Channel Idents",
    //   "Rating Slide",
    //   "Commercial",
    //   "CommercialSP"
    // ];

    if (isLive && (index == 0 || (index == 1 && shortForm.Duration == 5 * 1000))) {
      ignoredCategories.push("Ident")
    }

    const isIgnoredCategory = ignoredCategories.includes(
      shortForm.mediaEpisode.MediaCategoryType.Description
    );

    // Ignored categories should NEVER get SCTE markers
    if (isIgnoredCategory) {
      return false;
    }

    // Only non-ignored categories can have SCTE markers
    return true;
  };

  const onAutoSchedule = async (schedule) => {

    let localData = [...schedule]

    for (let i = 0; i < localData.length; i++) {
      const item = localData[i];

      let updatedData = {
        SID: item.SID,
        _id: item._id,
        Segment_id: item?.Segment_id ?? null,
      }


      let segments = item?.segments ?? [];

      //Edit in ProgramScheduleTable
      var res = await API.savePlanning(updatedData, segments, false, false, 0, null, true);

      console.log("RES")
      console.log(res)

    }

    loaddata();

  }

  // Simplified onApplySCTEMarkers function
  const onApplySCTEMarkers = async (data, channel) => {
    console.log('HERE onApplySCTEMarkers');

    const isRockEnt = channel?.FullChannelName.replaceAll(" ", "").toLowerCase() == "rockentertainment";
    const isRockXT = channel?.FullChannelName.replaceAll(" ", "").toLowerCase() == "rockxstream";
    const isRockAct = channel?.FullChannelName.replaceAll(" ", "").toLowerCase() == "rockaction";
    const isZma = channel?.FullChannelName.replace(" ", "").toLowerCase() == "zoomooasia";
    const isRockChannel = isRockEnt || isRockXT || isRockAct || isZma;

    if (!data?.length) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Data Found" });
      return;
    }

    // let rippledData = [...data]
    let rippledData = getRippleBreakNo(data);


    const scheduleDataWithSCTEMarkers = rippledData.map(header => {
      const newHeader = { ...header };

      if (!header.children?.length) {
        return newHeader;
      }

      const segments = header.children.filter(item => item.Type === SCHEDULETYPE.Segment);
      let newChildren = [];

      //CHILDREN WITHOUT SEGMENTS
      let breakNoZeroChild = header.children.filter((item) => item.Type !== SCHEDULETYPE.Segment && item.Type == SCHEDULETYPE.ShortForm && item.BreakNo == 0);
      if (breakNoZeroChild.length > 0) {
        const processedChildren = isRockChannel ?
          processRockSCTEMarkers(breakNoZeroChild, header.TXStatus.SID == TX_STATUS.Live, channel, header) :
          processSCTEMarkers(breakNoZeroChild, header.TXStatus.SID == TX_STATUS.Live, channel, header);
        newChildren.push(...processedChildren);
      }

      segments.forEach(segment => {
        newChildren.push(segment);

        const breakChildren = header.children.filter(
          item => item.Type === SCHEDULETYPE.ShortForm && item.BreakNo === segment.BreakNo
        );
        const processedChildren = isRockChannel ?
          processRockSCTEMarkers(breakChildren, header.TXStatus.SID == TX_STATUS.Live, channel, header) :
          processSCTEMarkers(breakChildren, header.TXStatus.SID == TX_STATUS.Live, channel, header);
        newChildren.push(...processedChildren);
      });

      newHeader.children = newChildren;
      return newHeader;
    });

    console.log('Original data:', rippledData.length, rippledData);
    console.log('Processed data:', scheduleDataWithSCTEMarkers.length, scheduleDataWithSCTEMarkers);

    schedulerDataRefSetter(scheduleDataWithSCTEMarkers);
    await saveCompleteScheduleChildrenandRefresh();
  };

  // Helper function to process SCTE markers for a break
  //V2
  const processSCTEMarkers = (breakChildren, isLive, channel, header) => {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isEcity = ((company?.Name ?? "") == "encompass") && channel?.SID == 16; // change later PENDING

    const isGTZMA = channel?.FullChannelName.replace(" ", "").toLowerCase() == "globaltrekker" ||
      channel?.FullChannelName.replace(" ", "").toLowerCase() == "zoomooasia"

    const isRockEnt = channel?.FullChannelName.replace(" ", "").toLowerCase() == "rockentertainment";


    const noSCTEBoth = !isGTZMA && !isEcity;

    let scteBreakDuration = channel && channel?.SCTEBreakDuration ? channel.SCTEBreakDuration : 4;

    const MAX_SCTE_DURATION = ((scteBreakDuration * 60) + 1) * 1000;
    let MIN_SCTE_BOTH_DURATION = 15 * 1000; // 15 seconds
    let totalScteDuration = 0; // Track total SCTE duration for this break
    let scteDuration = 0; // Track current sequence duration
    let scteStarted = false; // Track if we've started an SCTE sequence


    if (isGTZMA && breakChildren.reduce((acc, item) => acc + item.Duration, 0) < (2.5 * 60 * 1000)) {
      return breakChildren;
    }

    // HANDLE CASE IF breakChildren is of isBreak = true 
    let finalBreakChildren = [];

    breakChildren.map((x) => {
      if (x && x[IS_BREAK]) {
        finalBreakChildren.push(...x.children);
      } else {
        finalBreakChildren.push(x);
      }
    });

    const promoIndex = finalBreakChildren.findIndex(item => item.mediaEpisode?.MediaCategoryType?.SID == MEDIACATEGORYTYPES.Promo);

    const isValidSCTEItem = (item, idx) => {
      if (!validMediaForSCTE(item, isLive, idx, channel)) {
        return false;
      }
      if (isGTZMA && idx === promoIndex && item.mediaEpisode?.MediaCategoryType?.SID == MEDIACATEGORYTYPES.Promo) {
        return false;
      }
      return true;
    };

    return finalBreakChildren.map((shortForm, index) => {
      const isLast = index === finalBreakChildren.length - 1;
      const nextItem = finalBreakChildren[index + 1];
      const prevItem = finalBreakChildren[index - 1];

      // Default to NO_SCTE for all items to clean up any stale markers
      let scteType = SCTE_TYPE.NO_SCTE;
      shortForm.SCTEType = SCTE_TYPE.NO_SCTE;

      // Skip ignored/invalid categories completely
      if (!isValidSCTEItem(shortForm, index)) {
        // If we had an active SCTE sequence, end it before this ignored item
        if (scteStarted && index > 0) {
          const prevValidItem = finalBreakChildren[index - 1];
          if (isValidSCTEItem(prevValidItem, index - 1)) {
            if (prevValidItem.SCTEType === SCTE_TYPE.SCTE_START) {
              const qualifiesForBoth = noSCTEBoth && prevValidItem.Duration >= MIN_SCTE_BOTH_DURATION;
              prevValidItem.SCTEType = qualifiesForBoth ? SCTE_TYPE.SCTE_BOTH : SCTE_TYPE.NO_SCTE;
              if (qualifiesForBoth) {
                totalScteDuration += prevValidItem.Duration;
              }
            } else {
              prevValidItem.SCTEType = SCTE_TYPE.SCTE_END;
              totalScteDuration += scteDuration;
            }
          }
          scteStarted = false;
          scteDuration = 0;
        }
        shortForm.SCTEType = SCTE_TYPE.NO_SCTE;
        return shortForm;
      }

      // Check for SCTE_BOTH condition: valid item >= 15 seconds, between two invalid items or is last item
      const prevIsInvalid = !prevItem || !isValidSCTEItem(prevItem, index - 1);
      const nextIsInvalid = !nextItem || !isValidSCTEItem(nextItem, index + 1);
      let durationCondition = noSCTEBoth && shortForm.Duration >= MIN_SCTE_BOTH_DURATION;


      if (durationCondition && ((prevIsInvalid && nextIsInvalid) || (prevIsInvalid && isLast))) {
        // Check if applying SCTE_BOTH would exceed the duration limit
        if (totalScteDuration + shortForm.Duration <= MAX_SCTE_DURATION) {
          scteType = SCTE_TYPE.SCTE_BOTH;
          totalScteDuration += shortForm.Duration; // Add this item's duration to total
        } else {
          scteType = SCTE_TYPE.NO_SCTE;
        }

        shortForm.SCTEType = scteType;
        return shortForm;
      }

      // If we already started SCTE sequence, we must close it or continue with NO_SCTE
      if (scteStarted) {
        // Check if adding this item would exceed the duration limit
        if (totalScteDuration + scteDuration + shortForm.Duration > MAX_SCTE_DURATION) {
          // End the sequence at the PREVIOUS item to stay under limit
          const prevValidItem = finalBreakChildren[index - 1];
          if (prevValidItem && isValidSCTEItem(prevValidItem, index - 1)) {
            if (prevValidItem.SCTEType === SCTE_TYPE.SCTE_START) {
              const qualifiesForBoth = noSCTEBoth && prevValidItem.Duration >= MIN_SCTE_BOTH_DURATION;
              prevValidItem.SCTEType = qualifiesForBoth ? SCTE_TYPE.SCTE_BOTH : SCTE_TYPE.NO_SCTE;
              if (qualifiesForBoth) {
                totalScteDuration += prevValidItem.Duration;
              }
            } else {
              prevValidItem.SCTEType = SCTE_TYPE.SCTE_END;
              totalScteDuration += scteDuration;
            }
          }
          scteStarted = false;
          scteDuration = 0;
          scteType = SCTE_TYPE.NO_SCTE;
        }
        // Check if we should end the SCTE sequence for other reasons
        else if (isLast || // Last item
          !nextItem || // No next item
          !isValidSCTEItem(nextItem, index + 1)) { // Next item is invalid (ignored category)

          scteType = SCTE_TYPE.SCTE_END;
          scteStarted = false;
          totalScteDuration += scteDuration + shortForm.Duration; // Add to total including current item
          scteDuration = 0;
        } else {
          // Continue with NO_SCTE (valid media in sequence)
          scteType = SCTE_TYPE.NO_SCTE;
          scteDuration += shortForm.Duration;
        }
      } else {
        // No active SCTE sequence

        // Check if we should start a sequence (back-to-back valid items)
        if (nextItem && isValidSCTEItem(nextItem, index + 1)) {
          // Check if starting this sequence would fit within the remaining duration
          if (totalScteDuration + shortForm.Duration <= MAX_SCTE_DURATION) {
            scteType = SCTE_TYPE.SCTE_START;
            scteStarted = true;
            scteDuration = shortForm.Duration;
          } else {
            scteType = SCTE_TYPE.NO_SCTE;
          }
        }
        // Check if single valid item with duration > 15 sec should be SCTE_BOTH
        else if (durationCondition && (!nextItem || !isValidSCTEItem(nextItem, index + 1))) {
          // Check if applying SCTE_BOTH would exceed the duration limit
          if (totalScteDuration + shortForm.Duration <= MAX_SCTE_DURATION) {
            scteType = SCTE_TYPE.SCTE_BOTH;
            totalScteDuration += shortForm.Duration; // Add this item's duration to total
          } else {
            scteType = SCTE_TYPE.NO_SCTE;
          }
        } else {
          scteType = SCTE_TYPE.NO_SCTE;
        }
      }

      shortForm.SCTEType = scteType;
      return shortForm;
    });
  };


  //FOR ROCK
  const processRockSCTEMarkers = (breakChildren, isLive, channel, header) => {

    console.log('processRockSCTEMarkers')

    const isRockEnt = channel?.FullChannelName.replaceAll(" ", "").toLowerCase() == "rockentertainment";

    let scteBreakDuration = channel && channel?.SCTEBreakDuration ? channel.SCTEBreakDuration : 4;

    if (isRockEnt && header.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Program) {
      scteBreakDuration = parseFloat(scteBreakDuration) + 1;
    }

    const TARGET_SCTE_DURATION = (scteBreakDuration * 60) * 1000;

    // HANDLE CASE IF breakChildren is of isBreak = true 
    let finalBreakChildren = [];

    breakChildren.map((x) => {
      if (x && x[IS_BREAK]) {
        finalBreakChildren.push(...x.children);
      } else {
        finalBreakChildren.push(x);
      }
    });

    const isValidSCTEItem = (item, idx) => {
      if (!validMediaForSCTE(item, isLive, idx, channel)) {
        return false;
      }
      if (idx == 0) {
        return false;
      }
      return true;
    };

    // Reset all items to NO_SCTE initially
    finalBreakChildren.forEach((item) => {
      item.SCTEType = SCTE_TYPE.NO_SCTE;
    });

    const isIDCategory = (item) => {
      if (!item) return false;
      const desc = item?.mediaEpisode?.MediaCategoryType?.Description?.toLowerCase() || "";
      const catDesc = item?.mediaEpisode?.MediaCategory?.Description?.toLowerCase() || "";
      return desc.includes("id") || desc.includes("ident") || catDesc.includes("id") || catDesc.includes("ident");
    };

    const isPromoCategory = (item) => {
      if (!item) return false;
      const desc = item?.mediaEpisode?.MediaCategoryType?.Description?.toLowerCase() || "";
      const catDesc = item?.mediaEpisode?.MediaCategory?.Description?.toLowerCase() || "";
      return desc.includes("promo") || desc.includes("interstitial") || catDesc.includes("promo") || catDesc.includes("interstitial") || validMediaForSCTE(item, isLive, 1, channel);
    };

    const item0 = finalBreakChildren[0];
    const item1 = finalBreakChildren[1];

    const isIDOn0Index = isIDCategory(item0) || !validMediaForSCTE(item0, isLive, 0, channel);
    const isPromoAt1Index = isPromoCategory(item1);
    // Count ONLY actual promos (duration >= 15s) after index 0
    const promoCount = finalBreakChildren.filter((item, idx) => idx > 0 && validMediaForSCTE(item, isLive, idx, channel) && (item.Duration >= 15 * 1000)).length;

    let startIdx = 1;
    if (isIDOn0Index && isPromoAt1Index && promoCount > 4) {
      startIdx = 2;
    }

    let i = startIdx;
    while (i < finalBreakChildren.length) {
      if (!isValidSCTEItem(finalBreakChildren[i], i)) {
        i++;
        continue;
      }

      let currentSum = 0;
      let matchedEndIdx = -1;

      for (let j = i; j < finalBreakChildren.length; j++) {
        if (!isValidSCTEItem(finalBreakChildren[j], j)) {
          break;
        }
        currentSum += finalBreakChildren[j].Duration;

        if (Math.abs(currentSum - TARGET_SCTE_DURATION) <= 1000 && (j + 1 < finalBreakChildren.length)) {
          matchedEndIdx = j;
          break;
        }
      }

      if (matchedEndIdx !== -1) {
        // Valid combination found from index i to matchedEndIdx
        finalBreakChildren[i].SCTEType = SCTE_TYPE.SCTE_START;

        for (let k = i + 1; k <= matchedEndIdx; k++) {
          finalBreakChildren[k].SCTEType = SCTE_TYPE.NO_SCTE;
        }

        // Mark SCTE Out on the next item (matchedEndIdx + 1)
        finalBreakChildren[matchedEndIdx + 1].SCTEType = SCTE_TYPE.SCTE_END;
        i = matchedEndIdx + 2;
      } else {
        i++;
      }
    }

    return finalBreakChildren;
  };

  const onDeleteAllSCTEMarkers = async (data) => {
    console.log("HERE IN DELETE ALL SCTE MARKERS");

    if (!data || data.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Data Found" });
      return;
    };

    let scheduleWithoutSCTEMarkers = [];

    data.map((header) => {
      let newHeader = { ...header };
      if (header && header.children && header.children.length > 0) {
        newHeader.children = header.children.map((child) => {
          if (child && child[IS_BREAK] && child.children && child.children.length > 0) {
            child.children = child.children.map((breakchild) => {
              breakchild.SCTEType = SCTE_TYPE.NO_SCTE;
              return breakchild;
            })
          }
          child.SCTEType = SCTE_TYPE.NO_SCTE;
          return child;
        })
      }
      scheduleWithoutSCTEMarkers.push(newHeader);
    })

    schedulerDataRefSetter(scheduleWithoutSCTEMarkers);

    await saveCompleteScheduleChildrenandRefresh();

  }

  const onImportCommercials = async () => {
    console.log('HERE Import Commercials')
    setShowImportCommercialPopup(true);
    setImportCommercialProgress({ message: '', progress: 0 });
  }

  const onImportCommercialFile = async (fileData) => {

    let localGridData = [...fileData];

    const uniqueSlotTimes = [...new Set(localGridData.map(item => item.SlotTime))];

    setImportCommercialProgress({ message: 'Importing commercials..', progress: 0 });

    for (let i = 0; i < uniqueSlotTimes.length; i++) {

      const slotTime = uniqueSlotTimes[i];
      let isGroupSegments = false;

      let perc = Math.ceil((100 * i) / uniqueSlotTimes.length);
      console.log(perc)

      setImportCommercialProgress({
        message: 'Importing commercials..',
        progress: perc
      });

      // finding header as per time
      const scheduleHeader = schedulerData.find((item) =>
        utility.getTimeByTimeZone(item.SlotDateTime, mainTimeZone?.IsNegativeOffset, mainTimeZone?.Offset, null, true) == `${slotTime}:00:00`
      );
      if (scheduleHeader == null) continue;

      if (scheduleHeader.children.some((item) =>
        item.Type != SCHEDULETYPE.Segment &&
        item.mediaEpisode?.MediaCateogry?.SID != MEDIACATEGORIES.Commercial &&
        item.Type != SCHEDULETYPE.UnderRun && item.Type != SCHEDULETYPE.OverRun
      )) {
        isGroupSegments = true;
      };

      const indexOfScheduleHeader = schedulerData.indexOf(scheduleHeader);

      const uniqueBreakNo = [...new Set(localGridData.filter(item => item.SlotTime === slotTime).map(item => item.BreakNo))];

      for (let j = 0; j < uniqueBreakNo.length; j++) {
        const breakNo = uniqueBreakNo[j];

        const commercials = localGridData.filter(item => item.SlotTime === slotTime && item.BreakNo === breakNo);

        // finding drop location
        let dropLocation = getCommcialBreakDropDestination(scheduleHeader, breakNo, isGroupSegments);
        if (dropLocation == null) continue;

        const indexOfSegment = scheduleHeader.children.findIndex(l => l._id == dropLocation._id);

        for (let k = 0; k < commercials.length; k++) {

          let commercial = commercials[k];

          if (commercial.CommercialEntity) {

            if (indexOfSegment + k >= scheduleHeader.children.length) {
              console.log('BREAKING HERE')
              continue;
            }

            const destination = breakNo == 0 && indexOfSegment == -1 ?
              scheduleHeader :
              scheduleHeader.children[indexOfSegment + k];

            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [commercial.CommercialEntity],
              destination,
              schedulerDataRef.current,
              false
            );

            addScheduleItems(destination, dataToSave, false);

          }
        }
      }
    }

    setImportCommercialProgress({ message: lang.process_completed_success_message, progress: 100 });

    await saveCompleteScheduleChildrenandRefresh();

    setShowImportCommercialPopup(false);

  }

  const getCommcialBreakDropDestination = (scheduleHeader, breakNo, isGroupedSegments) => {

    // normal case where there is no format applied (No children apart from segemnt, and commercials)
    if (!isGroupedSegments) {
      let indexOfFirstSegment = scheduleHeader.children.findIndex((item) => item.Type == SCHEDULETYPE.Segment);
      if (breakNo == 0 && indexOfFirstSegment > 0) {
        return scheduleHeader.children[indexOfFirstSegment - 1];
      }

      let seg = scheduleHeader.children.find(item => item.Type == SCHEDULETYPE.Segment && item.BreakNo == breakNo);

      return breakNo == 0 && scheduleHeader.Type != SCHEDULETYPE.UnderRun && scheduleHeader.Type != SCHEDULETYPE.OverRun ?
        scheduleHeader : seg;
    }

    // grouping case
    let destination = null;
    let assignBreakNumber = 1;
    const updatedChildrenWithBreakNumber = []
    let seg = null;

    for (let i = 0; i < scheduleHeader.children.length; i++) {

      const child = scheduleHeader.children[i];
      const nextChild = i < scheduleHeader.children.length - 1 ? scheduleHeader.children[i + 1] : null;

      if (child.Type == SCHEDULETYPE.Segment && (nextChild != null && nextChild.Type == SCHEDULETYPE.Segment)) {
        updatedChildrenWithBreakNumber.push({ ...child, BreakNo: -1 });
      }
      else if (child.Type == SCHEDULETYPE.Segment) {
        updatedChildrenWithBreakNumber.push({ ...child, BreakNo: assignBreakNumber });
        assignBreakNumber++;
      }
      else {
        updatedChildrenWithBreakNumber.push({ ...child, BreakNo: -1 });
      }

    }

    seg = updatedChildrenWithBreakNumber.find(item => item.Type == SCHEDULETYPE.Segment && item.BreakNo == breakNo);

    let segIndex = scheduleHeader.children.findIndex(item => item._id == (seg ? seg._id : null));

    if (segIndex && segIndex != -1 &&
      scheduleHeader.children[segIndex + 1] &&
      scheduleHeader.children[segIndex + 1].mediaEpisode &&
      scheduleHeader.children[segIndex + 1].mediaEpisode.MediaCategoryType &&
      scheduleHeader.children[segIndex + 1].mediaEpisode.MediaCategoryType.SID == 54) {
      seg = scheduleHeader.children[segIndex + 1];
    }

    let indexOfFirstSegment = scheduleHeader.children.findIndex((item) => item.Type == SCHEDULETYPE.Segment);
    if (breakNo == 0 && indexOfFirstSegment > 0) {
      destination = scheduleHeader.children[indexOfFirstSegment - 1];
    } else {
      destination = breakNo == 0 ?
        scheduleHeader :
        seg;
    }

    return destination && destination._id ? destination : null;

  }

  const AutoDeleteFooterUnderOffsetValue = async () => {

    const appconfig = await API.getEntitiesWithSearch(ENTITYNAME.ApplicationConfiguration);
    console.log(appconfig);

    if (appconfig.success && appconfig.data && appconfig.data.length > 0) {

      const offsetObj = appconfig.data.find(x => x.Key == "AutoDeleteFooterOffset");
      if ((offsetObj?.Value ?? 0) == 0) return;

      console.log("has offeset:" + offsetObj?.Value);

      var hasFooter = true;
      let loopCount = 0;
      while (hasFooter && loopCount <= schedulerDataRef.current.length) {

        loopCount++;
        var parent = schedulerDataRef.current.find(x => x.children.some(s => (s.Type == SCHEDULETYPE.UnderRun || s.Type == SCHEDULETYPE.OverRun) && s.Duration <= parseInt(offsetObj.Value)));

        if (parent && parent._id) {

          var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
          if (footerChild) {
            await deleteFooter(footerChild);
          }

        }
        else {
          hasFooter = false;
        }
      }
    }
  }

  const PackPlaylistFor24Hours = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;

    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.ANY);
    const expectedEndTime = (payloadref.current.ScheduleEndDate + 1);
    const lastheaderChildren = schedulerDataRef.current[schedulerDataRef.current.length - 1].children;

    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      var availableVariations = data.MediaEpisodes;


      const currentEndTime = lastheaderChildren && lastheaderChildren.length > 0
        ? lastheaderChildren[lastheaderChildren.length - 1].SlotDateTime
        : schedulerDataRef.current[schedulerDataRef.current.length - 1].SlotDateTime;

      var difference = expectedEndTime > currentEndTime ? expectedEndTime - currentEndTime : 0;
      var lastChild = lastheaderChildren.length > 1 ? lastheaderChildren[lastheaderChildren.length - 2] : undefined;
      var groupedItems = await SchedulingHelper.getInterstitialsForSameDurationOfFooter(difference + 4, availableVariations, lastChild);

      console.log("difference" + difference);

      var dst = lastheaderChildren && lastheaderChildren.length > 0
        ? lastheaderChildren[lastheaderChildren.length - 1]
        : schedulerDataRef.current[schedulerDataRef.current.length - 1];

      for (let gi = 0; gi < groupedItems.length; gi++) {
        const item = groupedItems[gi];

        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [item],
          dst,
          schedulerDataRef.current,
          true, // isNew
          true // isAutoFill
        );
        await addScheduleItems(dst, dataToSave, true);
      }
    }

    // checking if any item over day
    var extraItems = schedulerDataRef.current[schedulerDataRef.current.length - 1].children.filter(x => x.SlotDateTime >= expectedEndTime);
    if (extraItems.length > 0) await deleteScheduleItems(extraItems, true);
  }

  const saveCompleteScheduleChildrenandRefresh = async () => {

    var finaldatatosave = [];
    schedulerDataRef.current.map(parent => {
      parent.children.map(child => {
        if (child?.Type != SCHEDULETYPE.UnderRun && child?.Type != SCHEDULETYPE.OverRun) {
          finaldatatosave.push(child);

          if (child[IS_BREAK] && child.children && child.children.length > 0) {

            child.children.map(breakchild => {
              if (breakchild?.Type != SCHEDULETYPE.UnderRun && breakchild?.Type != SCHEDULETYPE.OverRun) {
                finaldatatosave.push(breakchild);
              }
            })

          }
        }
      })
    });

    const saveRes = await API.saveSchedule({
      schedules: SchedulingHelper.prepareDataforbackend(finaldatatosave),
      deletedschedules: [],
    });

    // refresh schedule
    await loaddata(true);

    if (saveRes.success == false) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: saveRes.message });
    }
  }

  const RefillAndDeleteUnderAndOverRun = async (variationRes, autoDeleteOffFooterOffset, fillInLastOnly = false, deleteFooter = true) => {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isSMG = (company?.Name ?? "") == "SMG";

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.ANY);

    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      // under and over run both
      var allParents = schedulerDataRef.current;
      for (let index = 0; index < allParents.length; index++) {

        const parent = schedulerDataRef.current[index];

        // if no footer found, we will skip this header
        var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
        if (footerDuration == 0) continue;


        if (footerChild.Type == SCHEDULETYPE.UnderRun) {
          var groupedvariationstoPlot = await SchedulingHelper.getVariation(footerDuration, data.MediaEpisodes, autoDeleteOffFooterOffset);

          for (let childindex = 0; childindex < groupedvariationstoPlot.length; childindex++) {
            const element = groupedvariationstoPlot[childindex];

            var bestChildPosition = await SchedulingHelper.getBestChildPositionToDrop(schedulerDataRef.current[index].children, element);
            if (fillInLastOnly && schedulerDataRef.current[index].children.length > 0) {
              bestChildPosition = schedulerDataRef.current[index].children[schedulerDataRef.current[index].children.length - 1];
            }
            if (bestChildPosition == undefined) continue;

            // pushing now in schedule
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [element],
              bestChildPosition,
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(bestChildPosition, dataToSave, true);

          }

        }
        else { // over run

          // fixed variation media episodes
          var fixedVariation = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.FIXED);
          var lastVariation = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.LAST);


          // if found over run we can see what all we can delete to remove these and make it under offset range
          var tempFooterDuration = footerDuration;
          const killDuration = tempFooterDuration + autoDeleteOffFooterOffset;
          var tempLoop = 0;
          while (tempFooterDuration > autoDeleteOffFooterOffset && tempLoop <= parent.children.length) {

            tempLoop = tempLoop + 1;

            var itemWeCanDelete = schedulerDataRef.current[index].children.filter(x =>
              x.Type != SCHEDULETYPE.Segment &&
              x.Type != SCHEDULETYPE.UnderRun &&
              x.Type != SCHEDULETYPE.OverRun &&
              (isSMG && !(x.mediaEpisode?.AssetId?.toString().startsWith("BMP-") ?? false)) &&
              x.Duration < killDuration);


            var lastandfixedItems = []
            // removing items from fixed and last type
            if (itemWeCanDelete && itemWeCanDelete.length > 0) {

              for (let itd = 0; itd < itemWeCanDelete.length; itd++) {
                const element = itemWeCanDelete[itd];

                // if item is one of the fixed variation, we cannot change it
                if (fixedVariation && fixedVariation.MediaEpisodes && fixedVariation.MediaEpisodes.some(x => x._id.toString() == element.mediaEpisode._id.toString())) {
                  // remove item from itemWeCanDelete
                  lastandfixedItems.push(element);
                  continue;
                }

                // remove item from itemWeCanDelete
                if (lastVariation && lastVariation.MediaEpisodes && lastVariation.MediaEpisodes.some(x => x._id.toString() == element.mediaEpisode._id.toString())) {
                  lastandfixedItems.push(element);
                  continue;
                }
              }

              // now if lastandfixedItems are greater than 0, remove them from itemWeCanDelete
              if (lastandfixedItems && lastandfixedItems.length > 0) {
                itemWeCanDelete = itemWeCanDelete.filter(x => !lastandfixedItems.some(y => y._id.toString() == x._id.toString()));
              }
            }

            if (itemWeCanDelete && itemWeCanDelete.length > 0) {

              // maximum duraition we will delete
              var sorted = itemWeCanDelete.sort((a, b) => a.Duration - b.Duration);
              await deleteScheduleItems([sorted[sorted.length - 1]], true);

              var footr = schedulerDataRef.current[index].children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
              if (footr) {
                tempFooterDuration = footr.Duration;
              }
            }
          }
        }


        // checking if the footer comes under duration offset range we weill delete it right away
        var pendingFooter = schedulerDataRef.current[index].children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        if (deleteFooter && pendingFooter && pendingFooter.Duration <= autoDeleteOffFooterOffset) {

          await deleteFooter(pendingFooter);
        }
      }
    }

  }

  const MaximumDamageControl = async (maxDamageOffset) => {

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const parent = schedulerDataRef.current[index];

      // if no footer found, we will skip this header
      var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
      var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
      if (footerDuration == 0) continue;

      if (footerDuration <= maxDamageOffset) {

        await deleteFooter(footerChild);
      }
    }
  }

  const PlacingLastPositionItems = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.LAST);

    const fixedElements = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.FIXED);
    const hasFixedElements = fixedElements && fixedElements.MediaEpisodes != undefined && fixedElements.MediaEpisodes.length > 0;

    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      // under and over run both
      var allParents = schedulerDataRef.current;
      for (let index = 0; index < allParents.length; index++) {

        const hasFooter = schedulerDataRef.current[index].children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        const lastChildIndex = schedulerDataRef.current[index].children.length - (hasFooter ? 2 : 1);

        const lastChild = schedulerDataRef.current[index].children.length > 0 ? schedulerDataRef.current[index].children[lastChildIndex] : undefined;
        if (lastChild == undefined) continue;

        // if only segments than also skip
        const childrenOtherThanSegment = schedulerDataRef.current[index].children.filter(x => x.Type != SCHEDULETYPE.Segment && x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun);
        if (childrenOtherThanSegment.length == 0) continue;

        // if last child is already one of the LAST items, we do not need to do anything.
        if (data.MediaEpisodes.some(x => x._id.toString() == lastChild.mediaEpisode._id.toString())) continue;

        // if Fixed Position Items Are Scheduled In Last It Should Not Place Again
        if (hasFixedElements && fixedElements.MediaEpisodes.some(x => x._id.toString() == lastChild.mediaEpisode._id.toString())) continue;

        // filtering items because we do no want back to back.
        const options = data.MediaEpisodes.filter(x => childrenOtherThanSegment.filter(child => child.mediaEpisode._id.toString() == x._id.toString()).length == 0);

        // otherwise find a random last item and place
        var itemToPlace = options[Math.floor(Math.random() * options.length)];

        // pushing now in schedule
        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [itemToPlace],
          lastChild,
          schedulerDataRef.current,
          true, // isNew
          true // isAutoFill
        );
        await addScheduleItems(lastChild, dataToSave, false);
      }
    }

  }

  const PlaceSignOffIdOnLastSegment = async () => {

    // Pull Sign-off IDs
    const signOffIdsRes = await API.getData(ENTITYNAME.MediaEpisode, {
      query: [
        ["MediaCategory.isLong", "=", false], ["MediaCategoryType.Description", "=", "Ident"], ['Title', 'like', "Sign-off ID"]
      ]
    });

    if (signOffIdsRes.success && signOffIdsRes.data.length > 0) {

      let signOffIds = [...signOffIdsRes.data];

      let prevSignOffId = signOffIds.find((x) => x.Title == "Sign-off ID 1") ?? signOffIds[0];

      for (let index = 0; index < schedulerDataRef.current.length; index++) {

        const parent = schedulerDataRef.current[index];
        const nextParent = schedulerDataRef.current[index + 1];

        //Check Next Header same season or not (only skip if they are actually the same season of the same series/show)
        const isSameSeason = nextParent && parent.mediaEpisode?.Season_id && nextParent.mediaEpisode?.Season_id && (parent.mediaEpisode.Season_id == nextParent.mediaEpisode.Season_id)

        if (isSameSeason) continue;

        let segments = parent.children.filter((x) => x.Type == SCHEDULETYPE.Segment)
        segments.sort((a, b) => a.BreakNo - b.BreakNo);

        const lastChild = segments[segments.length - 1];

        if (lastChild) {
          const dataToSave = SchedulingHelper.prepareData(
            ENTITYNAME.MediaEpisode,
            getSelectedChannel(),
            [prevSignOffId],
            lastChild, // destination
            schedulerDataRef.current,
            true, // isNew
            true // isAutoFill
          );

          await addScheduleItems(lastChild, dataToSave, false);

          //ONLY 2 EXISTS (alternate safely to prevent undefined if only 1 exists)
          const nextSignOffId = signOffIds.find((x) => x._id.toString() != prevSignOffId._id.toString());
          if (nextSignOffId) {
            prevSignOffId = nextSignOffId;
          }
        }

      }

    }

  }

  const PlaceRatingSlideAndRatingBug = async () => {


    // Pull All Rating Slides and Rating Bugs
    const ratingSlides = await API.getData(ENTITYNAME.MediaEpisode, { query: ['MediaCategoryType.Description', '=', "Rating Slide"] });
    const ratingBugs = await API.getData(ENTITYNAME.Prototype, { query: ['ProtoTypeSource.Name', '=', "Rating Bug"] });

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const mediaEpisode = schedulerDataRef.current[index].mediaEpisode;
      const mediaEpisodeMetaData = await API.getData(ENTITYNAME.MediaEpisodeMetaData, { query: ['MediaEpisodeSID', '=', mediaEpisode.SID] });

      if (mediaEpisodeMetaData.success && mediaEpisodeMetaData.data.length > 0) {
        const metadata = mediaEpisodeMetaData.data[0];

        // if PGRating is available, Filter Rating Slides and Rating Bugs
        if (metadata.PGRating && metadata.PGRating.Description) {
          const validRatingSlide = ratingSlides?.data?.find(x => x?.Title?.toLowerCase().trim() == metadata.PGRating?.Description?.toLowerCase().trim());
          const validRatingBug = ratingBugs?.data?.find(x => x?.Name?.toLowerCase().trim() == metadata.PGRating?.Description?.toLowerCase().trim());

          // Apply Rating Slides On Top
          if (validRatingSlide) {

            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [validRatingSlide],
              schedulerDataRef.current[index], // destination
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(schedulerDataRef.current[index], dataToSave, false);

          }

          // Apply Rating Bug On Each Segment
          console.log("validRatingBug");
          console.log(validRatingBug);
          if (validRatingBug) {

            const segments = schedulerDataRef.current[index].children.filter(x => x.Type == SCHEDULETYPE.Segment);
            console.log(segments);

            for (let si = 0; si < segments.length; si++) {

              const seg = schedulerDataRef.current[index].children.find(x => x.Type == SCHEDULETYPE.Segment && x.BreakNo == si + 1);

              // index of this segment in schedulerDataRef.current[index].children
              const segmentIndex = schedulerDataRef.current[index].children.indexOf(seg);
              console.log(segmentIndex);

              if (segmentIndex == -1) continue;

              schedulerDataRef.current[index].children[segmentIndex].Prototypes = schedulerDataRef.current[index].children[segmentIndex].Prototypes ?? [];

              // if this segment already has rating bug, skip placement to avoid duplicate
              if (schedulerDataRef.current[index].children[segmentIndex].Prototypes.some(x => x.ID == validRatingBug.ID)) continue;
              schedulerDataRef.current[index].children[segmentIndex].Prototypes.push({
                ...validRatingBug,
                src: "prototype",
                Text1: "",
                Text2: "",
              })

              console.log("Prototypes");
              console.log(schedulerDataRef.current[index].children[segmentIndex].Prototypes);

            }
          }
        }
      }
    }
  }

  const PlaceParentalRatingsStarhub = async () => {

    // Pull All Rating Slides and Rating Bugs
    const ratingSlides = await API.getData(ENTITYNAME.MediaEpisode, { query: ['MediaCategoryType.Description', '=', "Parental ratings"] });

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const mediaEpisode = schedulerDataRef.current[index].mediaEpisode;

      if (mediaEpisode.PGRating) {

        // if PGRating is available, Filter Rating Slides
        if (mediaEpisode.PGRating && mediaEpisode.PGRating.Description) {

          // removing (chinese) from interstitials title
          const validRatingSlide = ratingSlides?.data?.find(x =>
            x?.Title?.replace(/\s*\([^)]*\)\s*$/, '')?.toLowerCase()?.trim() === mediaEpisode.PGRating?.Description?.toLowerCase()?.trim()
          );

          // Apply Rating Slides On Top
          if (validRatingSlide) {

            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [validRatingSlide],
              schedulerDataRef.current[index], // destination
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(schedulerDataRef.current[index], dataToSave, false);

          }
        }
      }
    }
  }

  const ApplyBreakBumpers = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;
    var bumperIns = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.OPENING);
    var bumperOuts = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.CLOSING);

    var allParents = schedulerDataRef.current;

    if (bumperIns && bumperIns.MediaEpisodes && bumperIns.MediaEpisodes.length > 0) {

      for (let index = 0; index < allParents.length; index++) {

        const parent = schedulerDataRef.current[index];

        for (let childIndex = 0; childIndex < parent.children.length; childIndex++) {
          const child = parent.children[childIndex];

          // if commercial
          if (child.mediaEpisode?.MediaCategoryType?.SID == MEDIACATEGORYTYPES.Commercial) {

            // if first child means we need to inder break bumper in
            if (childIndex == 0) {

              var itemToPlace = bumperIns.MediaEpisodes[Math.floor(Math.random() * bumperIns.MediaEpisodes.length)];

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [itemToPlace],
                parent,
                schedulerDataRef.current,
                true, // isNew
                true // isAutoFill
              );
              await addScheduleItems(parent, dataToSave, false);

            }
            else {

              // if previous item is not commercial and not one of the break bumber we will apply break bumper out
              if (parent.children[childIndex - 1].mediaEpisode.MediaCategoryType.SID != MEDIACATEGORYTYPES.Commercial && !bumperIns.MediaEpisodes.some(x => x._id.toString() == parent.children[childIndex - 1].mediaEpisode._id.toString())) {

                var itemToPlace = bumperIns.MediaEpisodes[Math.floor(Math.random() * bumperIns.MediaEpisodes.length)];

                // pushing now in schedule
                const dataToSave = SchedulingHelper.prepareData(
                  ENTITYNAME.MediaEpisode,
                  getSelectedChannel(),
                  [itemToPlace],
                  parent.children[childIndex - 1],
                  schedulerDataRef.current,
                  true, // isNew
                  true // isAutoFill
                );
                await addScheduleItems(parent.children[childIndex - 1], dataToSave, false);

              }
            }
          }
        }
      }
    }



    if (bumperOuts && bumperOuts.MediaEpisodes && bumperOuts.MediaEpisodes.length > 0) {

      for (let index = 0; index < allParents.length; index++) {

        const parent = schedulerDataRef.current[index];

        for (let childIndex = 0; childIndex < parent.children.length; childIndex++) {
          const child = parent.children[childIndex];

          // if commercial
          if (child.mediaEpisode?.MediaCategoryType?.SID != MEDIACATEGORYTYPES.Commercial) {

            // if previous item is commercial and current item is not one of the break bumber out
            if (childIndex > 0 && parent.children[childIndex - 1].mediaEpisode.MediaCategoryType.SID == MEDIACATEGORYTYPES.Commercial && !bumperOuts.MediaEpisodes.some(x => x._id.toString() == child.mediaEpisode?._id?.toString())) {

              var itemToPlace = bumperOuts.MediaEpisodes[Math.floor(Math.random() * bumperOuts.MediaEpisodes.length)];

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [itemToPlace],
                parent.children[childIndex - 1],
                schedulerDataRef.current,
                true, // isNew
                true // isAutoFill
              );
              await addScheduleItems(parent.children[childIndex - 1], dataToSave, false);

            }

          }
          else if (childIndex == parent.children.length - 1 && child.mediaEpisode?.MediaCategoryType?.SID == MEDIACATEGORYTYPES.Commercial) {


            var itemToPlace = bumperOuts.MediaEpisodes[Math.floor(Math.random() * bumperOuts.MediaEpisodes.length)];

            // pushing now in schedule
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [itemToPlace],
              child,
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(child, dataToSave, false);

          }
        }
      }
    }

  }

  const ApplyBillBoards = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;
    var billboards = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.BILLBOARD);

    console.log(billboards);

    if (billboards == undefined || billboards.MediaEpisodes == undefined || billboards.MediaEpisodes.length == 0) {
      return;
    }


    // Program Specific Bill Board
    const specifcBB = billboards.BillBoardDetail.filter(x => x.Type == BILLBOARD_TYPES.Fixed);
    if (specifcBB && specifcBB.length > 0) {

      console.log("Program Specific Bill Board");

      for (let index = 0; index < specifcBB.length; index++) {
        const element = specifcBB[index];

        console.log("Loop:" + index);
        console.log(schedulerDataRef.current);
        console.log(element);

        const parents = schedulerDataRef.current.filter(x => x.MediaEpisode_id == element.ParentMediaEpisode?._id);

        for (let index = 0; index < parents.length; index++) {
          const parent = parents[index];


          if (parent && parent._id && parent.children.some(x => x.Type == SCHEDULETYPE.Segment)) {

            console.log("parent Found");

            const segments = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);

            const firstSegmentIndex = parent.children.indexOf(segments[0]);
            const topLevelDst = firstSegmentIndex == 0 ? parent : parent.children[firstSegmentIndex - 1];

            var itemToPlace = billboards.MediaEpisodes.find(x => x._id.toString() == element.MediaEpisode_id);

            console.log("itemToPlace");
            console.log(itemToPlace);

            if (itemToPlace) {

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [itemToPlace],
                topLevelDst,
                schedulerDataRef.current,
                true, // isNew
                true // isAutoFill
              );
              await addScheduleItems(topLevelDst, dataToSave, false);


              const bottomLevelDst = parent.children[parent.children.indexOf(segments[segments.length - 1])];

              // pushing now in schedule
              const bottomDataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [itemToPlace],
                bottomLevelDst,
                schedulerDataRef.current,
                true, // isNew
                true // isAutoFill
              );
              await addScheduleItems(bottomLevelDst, bottomDataToSave, false);

            }

          }

        }


      }
    }




    // // Generic RBS Bill Board
    var allParents = schedulerDataRef.current;
    // const genericBB = billboards.BillBoardDetail.find(x => x.Type == BILLBOARD_TYPES.Generic);
    const genericBB = billboards.BillBoardDetail.filter(x => x.Type == BILLBOARD_TYPES.Generic);

    //REMOVE ARCHIVED ONE's
    const validGenericBBRes = await API.getData(ENTITYNAME.MediaEpisode, {
      query: [
        ["MediaCategory.isLong", "=", false],
        ["Archive", "=", false],
        ['_id', 'in', genericBB.map((item) => item.MediaEpisode_id)]
      ],
    });

    if (validGenericBBRes.success && validGenericBBRes.data.length > 0) {

      let genericBBIndex = 0;
      const validGenericBB = validGenericBBRes.data;

      for (let index = 0; index < allParents.length; index++) {
        const parent = allParents[index];

        if (genericBBIndex >= validGenericBB.length) {
          genericBBIndex = 0;
        }

        const genericBBItem = validGenericBB[genericBBIndex];

        if (billboards && billboards.Exceptions && billboards.Exceptions.some(x => x == parent.MediaEpisode_id)) continue;
        if (parent.children && parent.children.some(x => x.mediaEpisode?.MediaCategoryType?.Description == "Billboards")) continue;


        if (parent && parent._id && parent.children.some(x => x.Type == SCHEDULETYPE.Segment)) {

          console.log("parent Found");

          const segments = parent.children.filter(x => x.Type == SCHEDULETYPE.Segment);

          const firstSegmentIndex = parent.children.indexOf(segments[0]);
          const topLevelDst = firstSegmentIndex == 0 ? parent : parent.children[firstSegmentIndex - 1];
          var itemToPlace = billboards.MediaEpisodes.find(x => x._id.toString() == genericBBItem._id);

          console.log("itemToPlace");
          console.log(itemToPlace);

          if (itemToPlace) {

            // pushing now in schedule
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [itemToPlace],
              topLevelDst,
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(topLevelDst, dataToSave, false);


            const bottomLevelDst = parent.children[parent.children.indexOf(segments[segments.length - 1])];

            // pushing now in schedule
            const bottomDataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [itemToPlace],
              bottomLevelDst,
              schedulerDataRef.current,
              true, // isNew
              true // isAutoFill
            );
            await addScheduleItems(bottomLevelDst, bottomDataToSave, false);

            genericBBIndex++;

          }
        }
      }
    }
  }

  const PlacingFirstPositionItem = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.OPENING);

    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      const firstChild = schedulerDataRef.current[0]?.children?.length > 0 ? schedulerDataRef.current[0]?.children[0] : undefined;
      if (firstChild == undefined) return;

      // if last child is already one of the LAST items, we do not need to do anything.
      if (data.MediaEpisodes.some(x => x._id.toString() == firstChild.mediaEpisode._id.toString())) return;

      // otherwise find a random last item and place
      var itemToPlace = data.MediaEpisodes[Math.floor(Math.random() * data.MediaEpisodes.length)];

      // pushing now in schedule
      const dataToSave = SchedulingHelper.prepareData(
        ENTITYNAME.MediaEpisode,
        getSelectedChannel(),
        [itemToPlace],
        schedulerDataRef.current[0],
        schedulerDataRef.current,
        true, // isNew
        true // isAutoFill
      );
      console.log(dataToSave);
      await addScheduleItems(schedulerDataRef.current[0], dataToSave, true);
    }

  }

  const PlacingFixedPositionItems = async (variationRes) => {

    // separet code for karton channel VGH on request
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    if (((company?.Name ?? "") == "Kartoon Studios") && payloadref.current.channelSID == 2) {
      await PlacingFixedPositionItemsKCVGH(variationRes);
      return;
    }

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.FIXED);

    if (data == undefined || data.SlotDetail == undefined || data.SlotDetail.length == 0 || data.MediaEpisodes == undefined || data.MediaEpisodes.length == 0) return;

    // under and over run both
    for (let index = 0; index < data.MediaEpisodes.length; index++) {

      var itemToPlace = data.MediaEpisodes[index];

      // find slot time from slot details
      const slotDetail = data.SlotDetail.find(x => x.MediaEpisode_id.toString() == itemToPlace._id.toString());
      // slot not found
      if ((slotDetail?.Slot ?? 0) == 0) continue;

      // creating range as per offset
      const headerOffsetStart = (payloadref.current.BookingDate + slotDetail?.Slot) - (1000 * 60 * 10); // 10 min offset -
      const headerOffsetEnd = (payloadref.current.BookingDate + slotDetail?.Slot) + (1000 * 60 * 10); // 10 min offset +

      // finding header
      var headerAsPerSlot = schedulerDataRef.current.find(h => h.SlotDateTime >= headerOffsetStart && h.SlotDateTime <= headerOffsetEnd);

      // if header not found
      if (headerAsPerSlot == undefined || headerAsPerSlot._id == undefined) continue;

      const headerIndex = schedulerDataRef.current.indexOf(headerAsPerSlot);

      // as we need to apply on last of previous header
      if (headerIndex < 1) continue;

      const hasFooter = schedulerDataRef.current[headerIndex - 1].children.some(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
      const lastChildIndex = schedulerDataRef.current[headerIndex - 1].children.length - (hasFooter ? 2 : 1);

      const lastChild = schedulerDataRef.current[headerIndex - 1].children.length > 0 ? schedulerDataRef.current[headerIndex - 1].children[lastChildIndex] : undefined;
      if (lastChild == undefined) continue;

      // if last child is already one of the FIXED items, we do not need to do anything.
      if (itemToPlace._id.toString() == lastChild.mediaEpisode._id.toString()) continue;

      // pushing now in schedule
      const dataToSave = SchedulingHelper.prepareData(
        ENTITYNAME.MediaEpisode,
        getSelectedChannel(),
        [itemToPlace],
        lastChild,
        schedulerDataRef.current,
        true, // isNew
        true // isAutoFill
      );
      await addScheduleItems(lastChild, dataToSave, false);
    }

  }


  const AddKRRAdAndIdentKCVGH = async (variationRes, parent) => {

    console.log("AddKRRAdAndIdentKCVGH");

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.OPENING);
    if (data == undefined || data.MediaEpisodes == undefined || data.MediaEpisodes.length == 0) {
      return;
    }

    var header = schedulerDataRef.current.find(h => h._id.toString() == parent._id.toString());;
    const destination = header && header._id ? header.children.find(x => x.Type == SCHEDULETYPE.Segment) : undefined;
    if (destination == undefined) {
      console.log("AddKRRAdAndIdentKCVGH -- Header Not Found," + parent._id);
      return;
    }

    console.log("AddKRRAdAndIdentKCVGH -- adding krr ad and ident");

    // ident first placement
    var itemToPlace = data.MediaEpisodes.length > 0
      ? data.MediaEpisodes[Math.floor(Math.random() * data.MediaEpisodes.length)]
      : undefined;
    if (itemToPlace && itemToPlace._id) {
      // pushing now in schedule
      const dataToSave = SchedulingHelper.prepareData(
        ENTITYNAME.MediaEpisode,
        getSelectedChannel(),
        [itemToPlace],
        destination,
        schedulerDataRef.current,
        true, // isNew
        true // isAutoFill
      );
      await addScheduleItems(destination, dataToSave, false);
    }


    // the place ad break
    var adbreaksdata = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.CLOSING);
    if (adbreaksdata == undefined || adbreaksdata.MediaEpisodes == undefined || adbreaksdata.MediaEpisodes.length == 0) return;
    var validVariance = adbreaksdata.MediaEpisodes.filter(x => x.MediaCategoryType?.Description == "Ad Breaks");

    itemToPlace = validVariance.length > 0
      ? validVariance[Math.floor(Math.random() * validVariance.length)]
      : undefined;

    if (itemToPlace && itemToPlace._id) {
      // pushing now in schedule
      const dataToSave = SchedulingHelper.prepareData(
        ENTITYNAME.MediaEpisode,
        getSelectedChannel(),
        [itemToPlace],
        destination,
        schedulerDataRef.current,
        true, // isNew
        true // isAutoFill
      );
      await addScheduleItems(destination, dataToSave, false);

    }

  }

  const DeleteExtraAdBreaksKCVGH = async (variationRes, autoDeleteOffFooterOffset, maxDamageOffset) => {

    //reserving items to delete
    var itemsToDelete = [];

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const parent = schedulerDataRef.current[index];

      // if no footer found, we will skip this header
      var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
      var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
      if (footerDuration == 0) continue;

      // has more than 1 ad breaks 
      const adBreaks = parent.children.filter(x => x.mediaEpisode?.MediaCategoryType?.Description == "Ad Breaks");

      if (adBreaks && adBreaks.length > 1) {
        // delete 2nd ad break
        itemsToDelete.push(adBreaks[1]);
        await deleteScheduleItems([adBreaks[1]], false);
      }
    }

    // if not realtime save and itemsto delete
    if (itemsToDelete.length > 0) {
      await saveSchedule({ deletedSchedules: itemsToDelete });
      await saveCompleteScheduleChildrenandRefresh();
    }

    await ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly(variationRes, autoDeleteOffFooterOffset, false);
    await ReplaceItemsToMatchUnderAndOverRuns(variationRes, autoDeleteOffFooterOffset, false);
    await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset);
    await MaximumDamageControl(maxDamageOffset);

    await ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly(variationRes, autoDeleteOffFooterOffset, false);
    await ReplaceItemsToMatchUnderAndOverRuns(variationRes, autoDeleteOffFooterOffset, false);
    await RefillAndDeleteUnderAndOverRun(variationRes, autoDeleteOffFooterOffset);
    await MaximumDamageControl(60000);

  }


  const PlacingFixedPositionItemsKCVGH = async (variationRes) => {

    if (!variationRes.success || variationRes.data.length == 0) return;
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.FIXED);

    if (data == undefined || data.SlotDetail == undefined || data.SlotDetail.length == 0 || data.MediaEpisodes == undefined || data.MediaEpisodes.length == 0) return;

    // under and over run both
    for (let index = 0; index < schedulerDataRef.current.length; index++) {

      var header = schedulerDataRef.current[index];

      let NNLAssetId = "";
      if (header.mediaEpisode.AssetId.includes("PG_SONIC")) {
        NNLAssetId = "PR_NNL_SONKRRDK";
      }
      else if (header.mediaEpisode.AssetId.includes("PG_KRR") && header.children.length <= 3) {
        NNLAssetId = "PR_NNL_KRRDKSON";
      }
      else if (header.mediaEpisode.AssetId.includes("PG_DKC")) {
        NNLAssetId = "PR_NNL_DKSONKRR";
      }

      const itemToPlace = data.MediaEpisodes.find(x => x.AssetId == NNLAssetId);

      if (itemToPlace && itemToPlace._id) {

        // pushing now in schedule
        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [itemToPlace],
          header,
          schedulerDataRef.current,
          true, // isNew
          true // isAutoFill
        );
        await addScheduleItems(header, dataToSave, false);

      }


    }

  }

  const ReplaceItemsToMatchUnderAndOverRuns = async (variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING) => {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isKartoonChannel = (company?.Name ?? "") == "Kartoon Studios";
    const isGodare = (company?.Name ?? "") == "Godare";
    const isSMG = (company?.Name ?? "") == "SMG";


    //reserving items to delete
    var itemsToDelete = [];

    if (!variationRes.success || variationRes.data.length == 0) return;
    // later on this will be merged by opening and closing both...
    var data = variationRes.data.find(x => x.MediaType.SID == mediaTypeEnum);

    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      // under and over run both
      var allParents = schedulerDataRef.current;
      for (let index = 0; index < allParents.length; index++) {

        const parent = schedulerDataRef.current[index];
        console.log("PARENT INDEX:" + index);

        // if no footer found, we will skip this header
        var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
        if (footerDuration == 0) continue;

        var tempFooterDuration = footerDuration;

        if (footerChild.Type == SCHEDULETYPE.UnderRun) {
          console.log("REFILL PLACE..UNDER RUN");

          // we will check first if exact match found
          var bestFitForAnyChild = await SchedulingHelper.getReplaceOptionForAnyChildren(tempFooterDuration, data.MediaEpisodes, true, schedulerDataRef.current[index].children, variationRes);
          if (bestFitForAnyChild && bestFitForAnyChild.destination && bestFitForAnyChild.replacement) {

            const varianceSID = bestFitForAnyChild.destination.varianceSID ?? 0;

            // pushing now in schedule
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [bestFitForAnyChild.replacement],
              bestFitForAnyChild.destination,
              schedulerDataRef.current,
              true, // isNew
              true, // isAutoFill
              varianceSID
            );
            await addScheduleItems(bestFitForAnyChild.destination, dataToSave, realTimeSave);
            itemsToDelete.push(bestFitForAnyChild.destination)
            await deleteScheduleItems([bestFitForAnyChild.destination], realTimeSave);

          }
          else {

            // here we are going child by child
            for (let childindex = 0; childindex < parent.children.length; childindex++) {

              if (tempFooterDuration <= 0) break;

              const child = schedulerDataRef.current[index].children[childindex];
              if (child.Type == SCHEDULETYPE.Segment || child.Type == SCHEDULETYPE.UnderRun || child.Type == SCHEDULETYPE.OverRun) continue;

              // if under run we need to find bigger item than current item
              var bestFit = await SchedulingHelper.getReplaceOption(child, tempFooterDuration, data.MediaEpisodes, true, autoDeleteOffFooterOffset, variationRes);
              if (bestFit == undefined) continue;

              console.log("REFILL PLACE UNDER RUN..FOUND POSITION");

              const varianceSID = child.varianceSID ?? 0;

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [bestFit],
                child,
                schedulerDataRef.current,
                true, // isNew
                true, // isAutoFill
                varianceSID
              );
              await addScheduleItems(child, dataToSave, realTimeSave);
              itemsToDelete.push(child);
              await deleteScheduleItems([child], realTimeSave);

              tempFooterDuration = tempFooterDuration - bestFit.Duration;

            }

          }

        }
        else { // over run

          console.log("REFILL PLACE..OVER RUN");

          // we will check first if exact match found
          var bestFitForAnyChild = await SchedulingHelper.getReplaceOptionForAnyChildren(tempFooterDuration, data.MediaEpisodes, false, schedulerDataRef.current[index].children, variationRes);
          if (bestFitForAnyChild && bestFitForAnyChild.destination && bestFitForAnyChild.replacement) {

            // if isSMG && isLive && finalMediaToPlace.mediaEpisode?.AssetId starts with BMP- we will not place it.
            const isBMP = bestFitForAnyChild?.destination?.mediaEpisode?.AssetId?.toString().startsWith("BMP-") ?? false;
            if ((isSMG && isBMP)) {
              console.log("NO ACTION");
            }
            else {
              const varianceSID = bestFitForAnyChild.destination.varianceSID ?? 0;

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [bestFitForAnyChild.replacement],
                bestFitForAnyChild.destination,
                schedulerDataRef.current,
                true, // isNew
                true, // isAutoFill
                varianceSID
              );
              await addScheduleItems(bestFitForAnyChild.destination, dataToSave, realTimeSave);
              itemsToDelete.push(bestFitForAnyChild.destination)
              await deleteScheduleItems([bestFitForAnyChild.destination], realTimeSave);
            }
          }
          else {

            // here we are going child by child
            for (let childindex = 0; childindex < parent.children.length; childindex++) {

              if (tempFooterDuration <= 0) break;

              const child = schedulerDataRef.current[index].children[childindex];
              if (child.Type == SCHEDULETYPE.Segment || child.Type == SCHEDULETYPE.UnderRun || child.Type == SCHEDULETYPE.OverRun) continue;

              // if under run we need to find bigger item than current item
              var bestFit = await SchedulingHelper.getReplaceOption(child, tempFooterDuration, data.MediaEpisodes, false, autoDeleteOffFooterOffset, variationRes);
              if (bestFit == undefined) continue;

              console.log("REFILL PLACE OVER RUN..FOUND POSITION");

              const varianceSID = child.varianceSID ?? 0;

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [bestFit],
                child,
                schedulerDataRef.current,
                true, // isNew
                true, // isAutoFill
                varianceSID
              );

              await addScheduleItems(child, dataToSave, realTimeSave);
              itemsToDelete.push(child)
              await deleteScheduleItems([child], realTimeSave);

              tempFooterDuration = tempFooterDuration - bestFit.Duration;

            }
          }
        }


        console.log("RE PLACE SCHEDULE..CHECKING PENDING FOOTER");
        //checking if the footer comes under duration offset range we weill delete it right away
        var pendingFooter = schedulerDataRef.current[index].children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        if (pendingFooter && pendingFooter.Duration <= autoDeleteOffFooterOffset) {
          console.log({ "RE PLACE SCHEDULE..PENDING FOOTER": pendingFooter });
          await deleteFooter(pendingFooter);
        }

      }

      if (!realTimeSave && itemsToDelete.length > 0) {
        await saveSchedule({ deletedSchedules: itemsToDelete });
        await saveCompleteScheduleChildrenandRefresh();
      }
    }
  }

  const ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly = async (variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING) => {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isKartoonChannel = (company?.Name ?? "") == "Kartoon Studios";
    const isGodare = (company?.Name ?? "") == "Godare";
    const isSMG = (company?.Name ?? "") == "SMG";


    //reserving items to delete
    var itemsToDelete = [];

    if (!variationRes.success || variationRes.data.length == 0) return;

    // later on this will be merged by opening and closing both...
    var data = variationRes.data.find(x => x.MediaType.SID == mediaTypeEnum);


    if (data && data.MediaEpisodes && data.MediaEpisodes.length > 0) {

      // under and over run both
      var allParents = schedulerDataRef.current;
      for (let index = 0; index < allParents.length; index++) {

        const parent = schedulerDataRef.current[index];
        console.log("PARENT INDEX:" + index);

        // if no footer found, we will skip this header
        var footerChild = parent.children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        var footerDuration = footerChild && footerChild.Duration > 0 ? footerChild.Duration : 0;
        if (footerDuration == 0) continue;

        var tempFooterDuration = footerDuration;

        if (footerChild.Type == SCHEDULETYPE.UnderRun) {
          console.log("REFILL PLACE..UNDER RUN");


          // we will check first if exact match found
          var bestFitForAnyChild = await SchedulingHelper.getReplaceOptionForAnyChildren(tempFooterDuration, data.MediaEpisodes, true, schedulerDataRef.current[index].children, variationRes);
          if (bestFitForAnyChild && bestFitForAnyChild.destination && bestFitForAnyChild.replacement) {

            const varianceSID = bestFitForAnyChild.destination.varianceSID ?? 0;

            // pushing now in schedule
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [bestFitForAnyChild.replacement],
              bestFitForAnyChild.destination,
              schedulerDataRef.current,
              true, // isNew
              true, // isAutoFill
              varianceSID
            );

            await addScheduleItems(bestFitForAnyChild.destination, dataToSave, realTimeSave);
            itemsToDelete.push(bestFitForAnyChild.destination);
            await deleteScheduleItems([bestFitForAnyChild.destination], realTimeSave);

          }

        }
        else { // over run

          console.log("REFILL PLACE..OVER RUN");

          // we will check first if exact match found
          var bestFitForAnyChild = await SchedulingHelper.getReplaceOptionForAnyChildren(tempFooterDuration, data.MediaEpisodes, false, schedulerDataRef.current[index].children, variationRes);
          if (bestFitForAnyChild && bestFitForAnyChild.destination && bestFitForAnyChild.replacement) {

            // if isSMG && isLive && finalMediaToPlace.mediaEpisode?.AssetId starts with BMP- we will not place it.
            const isBMP = bestFitForAnyChild?.destination?.mediaEpisode?.AssetId?.toString().startsWith("BMP-") ?? false;
            if ((isSMG && isBMP)) {
              console.log("NO ACTION");
            }
            else {

              const varianceSID = bestFitForAnyChild.destination.varianceSID ?? 0;

              // pushing now in schedule
              const dataToSave = SchedulingHelper.prepareData(
                ENTITYNAME.MediaEpisode,
                getSelectedChannel(),
                [bestFitForAnyChild.replacement],
                bestFitForAnyChild.destination,
                schedulerDataRef.current,
                true, // isNew
                true, // isAutoFill
                varianceSID
              );

              await addScheduleItems(bestFitForAnyChild.destination, dataToSave, realTimeSave);
              itemsToDelete.push(bestFitForAnyChild.destination);
              await deleteScheduleItems([bestFitForAnyChild.destination], realTimeSave);
            }
          }
        }


        console.log("RE PLACE SCHEDULE..CHECKING PENDING FOOTER");
        //checking if the footer comes under duration offset range we weill delete it right away
        var pendingFooter = schedulerDataRef.current[index].children.find(x => x.Type == SCHEDULETYPE.UnderRun || x.Type == SCHEDULETYPE.OverRun);
        if (pendingFooter && pendingFooter.Duration <= autoDeleteOffFooterOffset) {
          console.log({ "RE PLACE SCHEDULE..PENDING FOOTER": pendingFooter });
          await deleteFooter(pendingFooter);
        }

      }

      // if not realtime save and itemsto delete
      if (!realTimeSave && itemsToDelete.length > 0) {
        await saveSchedule({ deletedSchedules: itemsToDelete });
        await saveCompleteScheduleChildrenandRefresh();
      }
    }
  }

  const SequenceVarianceInSchedule = async (variationRes, mediaCategoryTypeToSequence, realTimeSave = true) => {

    //reserving items to delete
    var itemsToDelete = [];

    if (!variationRes.success || variationRes.data.length == 0) return;
    // later on this will be merged by opening and closing both...
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.CLOSING);

    if (data == undefined || data.MediaEpisodes == undefined || data.MediaEpisodes.length == 0) return;

    var validVariance = data.MediaEpisodes.filter(x => (x.Variance?.SID ?? 0) > 0 && x.MediaCategoryType?.SID == mediaCategoryTypeToSequence);
    var uniQueVariance = [...new Set(validVariance.map(item => item.Variance.SID))];
    uniQueVariance.sort(function (a, b) {
      return a - b;
    });

    var nextPlacementVarianceIndex = 0;

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const parent = schedulerDataRef.current[index];

      for (let childindex = 0; childindex < parent.children.length; childindex++) {
        const child = parent.children[childindex];

        if (child.mediaEpisode?.MediaCategoryType?.SID != mediaCategoryTypeToSequence) continue;


        const bestFit = validVariance.find(x => x.Variance.SID == uniQueVariance[nextPlacementVarianceIndex] && x.Duration == child.mediaEpisode?.Duration);
        if (bestFit == undefined) continue;

        const varianceSID = uniQueVariance[nextPlacementVarianceIndex];

        // pushing now in schedule
        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [bestFit],
          child,
          schedulerDataRef.current,
          true, // isNew
          true, // isAutoFill
          varianceSID
        );

        await addScheduleItems(child, dataToSave, realTimeSave);
        itemsToDelete.push(child);
        await deleteScheduleItems([child], realTimeSave);

        // resetting index
        nextPlacementVarianceIndex = nextPlacementVarianceIndex + 1;
        if (nextPlacementVarianceIndex >= uniQueVariance.length) nextPlacementVarianceIndex = 0;

      }
    }

    // if not realtime save and itemsto delete
    if (!realTimeSave && itemsToDelete.length > 0) {
      await saveSchedule({ deletedSchedules: itemsToDelete });
      await saveCompleteScheduleChildrenandRefresh();
    }
  }

  const SequenceAdBreaksInSchedule = async (variationRes, realTimeSave = true) => {

    //reserving items to delete
    var itemsToDelete = [];

    if (!variationRes.success || variationRes.data.length == 0) return;
    // later on this will be merged by opening and closing both...
    var data = variationRes.data.find(x => x.MediaType.SID == MEDIATYPEENUM.CLOSING);

    if (data == undefined || data.MediaEpisodes == undefined || data.MediaEpisodes.length == 0) return;

    var validVariance = data.MediaEpisodes.filter(x => (x.Variance?.SID ?? 0) > 0 && x.MediaCategoryType?.Description == "Ad Breaks");
    console.log(validVariance);

    var orderedSequence = await SchedulingHelper.getRecursiveListSequencedByVarianceSID(validVariance);
    console.log(orderedSequence);

    var nextPlacementVarianceIndex = 0;

    // under and over run both
    var allParents = schedulerDataRef.current;
    for (let index = 0; index < allParents.length; index++) {

      const parent = schedulerDataRef.current[index];

      for (let childindex = 0; childindex < parent.children.length; childindex++) {
        const child = parent.children[childindex];
        if (child.mediaEpisode?.MediaCategoryType?.Description != "Ad Breaks") continue;


        const bestFit = orderedSequence[nextPlacementVarianceIndex];
        if (bestFit == undefined) continue;

        // pushing now in schedule
        const dataToSave = SchedulingHelper.prepareData(
          ENTITYNAME.MediaEpisode,
          getSelectedChannel(),
          [bestFit],
          child,
          schedulerDataRef.current,
          true, // isNew
          true, // isAutoFill
          0
        );

        await addScheduleItems(child, dataToSave, realTimeSave);
        itemsToDelete.push(child);
        await deleteScheduleItems([child], realTimeSave);

        // resetting index
        nextPlacementVarianceIndex = nextPlacementVarianceIndex + 1;
        if (nextPlacementVarianceIndex >= orderedSequence.length) nextPlacementVarianceIndex = 0;

      }
    }

    // if not realtime save and itemsto delete
    if (!realTimeSave && itemsToDelete.length > 0) {
      await saveSchedule({ deletedSchedules: itemsToDelete });
      await saveCompleteScheduleChildrenandRefresh();
    }
  }

  const onSchedulerChildrenFilter = () => {
    var newSchedulerData = [];
    var breakItems = [];
    var dataItem = schedulerChildrenFilterRef.current.dataItem;
    var field = schedulerChildrenFilterRef.current.field;
    var field2 = schedulerChildrenFilterRef.current.field;
    var field3 = schedulerChildrenFilterRef.current.field;
    console.log(schedulerChildrenFilterRef.current);
    var dotIndex = field.indexOf(".");
    if (dotIndex != -1) {
      field = field.slice(null, dotIndex);
      field2 = field2.slice(dotIndex + 1);
      dotIndex = field2.indexOf(".");
      if (dotIndex != -1) {
        field2 = field2.slice(null, dotIndex);
        dotIndex = field3.lastIndexOf(".");
        field3 = field3.slice(dotIndex + 1);
        dataItem = dataItem?.[field]?.[field2]?.[field3];
        schedulerDataRef.current.map((parent) => {
          var newData = parent.children.filter(
            (child) => {
              if (child[IS_BREAK]) {
                breakItems = child.children.filter((child) => child?.[field]?.[field2]?.[field3] == dataItem);
              }
              return child?.[field]?.[field2]?.[field3] == dataItem;
            }
          );
          newSchedulerData.push(...newData);
        });
      } else {
        dataItem = dataItem?.[field]?.[field2];
        schedulerDataRef.current.map((parent) => {
          var newData = parent.children.filter(
            (child) => {
              if (child[IS_BREAK]) {
                breakItems = child.children.filter((child) => child?.[field]?.[field2] == dataItem);
              }
              return child?.[field]?.[field2] == dataItem;
            }
          );
          newSchedulerData.push(...newData);
        });
      }
    } else {
      dataItem = dataItem?.[field];
      schedulerDataRef.current.map((parent) => {
        var newData = parent.children.filter(
          (child) => {
            if (child[IS_BREAK]) {
              breakItems = child.children.filter((child) => child[field] == dataItem);
            }
            return child[field] == dataItem;
          }
        );
        newSchedulerData.push(...newData);
      });
    }
    setShowFilterGridData([...newSchedulerData, ...breakItems]);
    setShowFilterGrid(true);
  };

  const onStyleSheetSelection = () => {

    console.log(selectedHeadersDataItemsRef.current);
    if (selectedHeadersDataItemsRef.current.length != 0) {
      styleSheetSelectionOpen
        ? setStyleSheetSelectionOpen(false)
        : setStyleSheetSelectionOpen(true);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_atleast_one_header_error_message });
      setStyleSheetSelectionOpen(false)
    }
  };

  const onSearchLocal = (e) => {
    const searchWord = e.target.value.toLowerCase();
    filterSearchWordRef.current = searchWord;
    if (searchWord.length == 0) {
      setShowFilterGrid(false);
      setShowFilterGridData([]);
    } else {
      setShowFilterGrid(true);
      var newFilterGridData = [];
      schedulerDataRef.current.map(parent => {
        parent.children.map(child => {
          if (child?.mediaEpisode?.Title?.toLowerCase().includes(searchWord) ||
            child?.MediaId?.toLowerCase().includes(searchWord) ||
            child?.mediaEpisode?.AssetId?.toLowerCase().includes(searchWord) ||
            child?.mediaEpisode?.MediaCategory?.Description?.toLowerCase().includes(searchWord) ||
            child?.mediaEpisode?.MediaCategoryType?.Description?.toLowerCase().includes(searchWord) ||
            Object.keys(SCHEDULETYPE).some(key => key.toLowerCase().includes(searchWord) && SCHEDULETYPE[key] == child?.Type)) {
            newFilterGridData.push(child);

          }
        })
      });
      if (newFilterGridData.length > 0) {
        setShowFilterGridData(newFilterGridData);
      } else {
        setShowFilterGridData([]);
      }

      // sometimes search results were not visible and on scroll it works
      // so by default did scroll to top if user search something By Vishal 11 May 24
      if (gridRef.current) {
        gridRef.current.scrollIntoView({
          rowIndex: 0,
        });
      }

    }
  }

  const saveSecondaryChangedData = async (prototypeOverviewData, scheduleItem) => {

    const { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(scheduleItem, schedulerDataRef.current);
    let schedulerDataLocal = schedulerDataRef.current;
    let saveData = {};

    if (isInsideBreak) {
      schedulerDataLocal[level_0_index].children[level_1_index].children[level_2_index].Prototypes = prototypeOverviewData
      saveData = schedulerDataLocal[level_0_index].children[level_1_index].children[level_2_index]
    }
    else {
      schedulerDataLocal[level_0_index].children[level_1_index].Prototypes = prototypeOverviewData
      saveData = schedulerDataLocal[level_0_index].children[level_1_index];
    }

    selectedStateRefSetter([saveData]);
    schedulerDataRefSetter(schedulerDataLocal);

    saveData = SchedulingHelper.prepareDataforbackend([saveData])[0];
    console.log(saveData);
    var res = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);

    console.log(res);
    if (res.success) {
      setStatusMessage(lang.secondary_event_updated_msg_scheduling);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.secondary_event_updated_msg_scheduling });
    }
    setShowSecondaryEventOverviewDialog(false);
  }

  const showSecondaryEventOverviewDialogProp = () => {

    try {

      if (selectedStateRef.current.length > 0 && selectedStateRef.current[0].Type == SCHEDULETYPE.Header) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_secondary_events_error_message });
        return;
      }

      if (selectedStateRef.current.length > 0 && selectedStateRef.current[0].Prototypes.length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_secondary_events_error_message });
        return;
      }

      setShowSecondaryEventOverviewDialog(true)
    } catch (e) {
      console.log(e);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_secondary_events_error_message });
    }
  }

  // auto save toggle changes
  const onHeaderExpandChange = (e) => {
    // testing expand all and collapse all header
    var parentData = schedulerDataRef.current.filter(data => {
      if (!data.ParentProgramSchedule_id) {
        return data;
      }
    });

    for (var i = 0; i < parentData.length; i++) {
      //dataitem, vakue, dataIndex
      var event = { dataItem: parentData[i], dataIndex: i, value: e.target.value };
      expandChange(event);
    }

    props.setExpandToggle(e.target.value);

  }

  const handleSaveScheduleDraftPopup = () => {
    setShowSaveScheduleDraftPopup(!showSaveScheduleDraftPopup)
  }

  //
  const onAutoPlotPromoInSchedule = (selectedPromos, fillSelected) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    if (fillSelected && selectedPromos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please select atleast one short form media` });
      return;
    }

    //-----CHECK-----

    // if (fillSelected && selectedPromos.some((x) => x.MediaCategory.SID != MEDIACATEGORIES.Interstitial)) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please select interstitials only` });
    //   return;
    // }

    executeAutoPlotPromos(selectedPromos, fillSelected);


  }

  const executeAutoPlotPromos = async (selectedPromos, fillSelected) => {

    let finalPromos = [...selectedPromos];

    if (!fillSelected) {
      const res = await API.loadSchedulingCompleteMediaLibrary(payloadref.current);

      if (res.success && res.data && res.data.length > 0) {
        finalPromos = res.data.filter((x) =>
          // x.MediaCategory.SID == MEDIACATEGORIES.Interstitial
          !x.MediaCategory.isLong &&
          x.Targets && x.Targets.length > 0 &&
          x.Targets.filter((xt) => xt.FromDate <= payloadref.current?.ScheduleDate && xt.ToDate >= payloadref.current?.ScheduleDate &&
            (xt.DayPart.IsAllChannel == true || xt.DayPart.Channels.filter(c => c._id == selectedChannel?._id?.toString()).length > 0)).length > 0);
      }
    }


    setShowAutoPlotPromo(true);
    var promoData = finalPromos.map((x) => {
      return getSelectedPromoWithTargetPreFilled(x);
    })
    setSelectedPromo(promoData);

  }

  const getSelectedPromoWithTargetPreFilled = (selectedPromo) => {

    console.log(selectedPromo.Targets);
    console.log(selectedChannel);
    console.log(payloadref.current?.ScheduleDate);

    const validTarget = selectedPromo.Targets.find(x =>
      x.FromDate <= payloadref.current?.ScheduleDate
      && x.ToDate >= payloadref.current?.ScheduleDate
      && (x.DayPart.IsAllChannel == true || x.DayPart.Channels.filter(x => x._id == selectedChannel?._id?.toString()).length > 0)
    );

    console.log(validTarget);

    return {
      ...selectedPromo,
      Name: selectedPromo.Title,
      From: validTarget ? utility.convertMilisecondsToShortTimeString(validTarget.DayPart.FromTime) : '00:00',
      To: validTarget ? utility.convertMilisecondsToShortTimeString(validTarget.DayPart.ToTime) : '23:59',
      Weightage: validTarget ? validTarget.Weightage : 100,
      PlayCount: validTarget ? validTarget.PlayCount : 0,
      PlayViaPlayCount: validTarget ? validTarget.PlayViaPlayCount : false,
      DayPart: validTarget ? validTarget.DayPart : {}
    }
  }

  const autoPlotPromoSchedule = async () => {
    setShowAutoPlotPromo(false);
    var totalSegments = await SchedulingHelper.getValidAutoPlotPromoBreaks(schedulerDataRef.current);
    if (totalSegments == undefined || totalSegments.length == 0) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "No Breaks Found.. Process Aborted." });
      return;
    }

    console.log(totalSegments.length);

    setShowProgressBar({ okButton: false, progressBarPopup: true });
    // Setting Schedule Constraints
    var enabledScheduleConstraint = [];
    const scheduleConstraintsRes = await API.getData(ENTITYNAME.ScheduleConstraints, {
      query: [["Channel._id", "", selectedChannel._id.toString()], ["Type.ID", "=", MEDIA_TYPE[0].ID], ["Archive", "=", false]]
    });
    if (scheduleConstraintsRes.success && scheduleConstraintsRes.data.length > 0) {
      enabledScheduleConstraint = scheduleConstraintsRes.data[0].EnabledConstraints;
    }
    console.log(enabledScheduleConstraint);
    var totalPromoPlotted = 0;
    for (let j = 0; j < selectedPromoRef.current.length; j++) {
      const promo = selectedPromoRef.current[j];

      const promoValidFrom = payloadref.current?.ScheduleDate + utility.convertShortTimeStringToMilliSeconds(promo.From);
      const promoValidTo = payloadref.current?.ScheduleDate + utility.convertShortTimeStringToMilliSeconds(promo.To);

      var segmentChildrens = totalSegments.filter(x => x.SlotDateTime >= promoValidFrom && x.SlotDateTime <= promoValidTo);

      if (segmentChildrens.length == 0) {
        continue;
      }

      setProgressData({
        message: selectedPromoRef.current.length - totalPromoPlotted + ' interstitial left',
        progress: Math.ceil((100 * totalPromoPlotted) / selectedPromoRef.current.length)
      });


      const isPlayViaPlayCount = promo.PlayViaPlayCount;
      var count = promo.PlayCount;
      var tempCount = 0;
      var weightage = promo.Weightage;
      if (isPlayViaPlayCount && count == 0) continue;
      if (!isPlayViaPlayCount && weightage == 0) continue;
      var newWeightage = isPlayViaPlayCount ? (count / segmentChildrens.length) * 100 : weightage;
      totalPromoPlotted = totalPromoPlotted + 1;
      for (let i = 0; i < segmentChildrens.length; i++) {

        if (isPlayViaPlayCount && count == tempCount) {
          break;
        }

        let { level_0_index, level_1_index } = SchedulingHelper.getChildInfo(segmentChildrens[i], schedulerDataRef.current)

        // for non last headers
        const isLastHeader = (level_0_index == (schedulerDataRef.current.length - 1));

        var canFill = await SchedulingHelper.isSpaceLeftAsPerCompanyRulesInAutoFill(isLastHeader, schedulerDataRef.current, level_0_index, promo, payloadref.current);
        if (!canFill) continue;

        var destinationDataItem = await SchedulingHelper.getDestinationForAutoPlotPromo(schedulerDataRef.current, level_0_index, segmentChildrens[i]);
        if (destinationDataItem == undefined) continue;

        const isValid = await SchedulingHelper.isValidDestinationForInterstitial(destinationDataItem, enabledScheduleConstraint, promo, schedulerDataRef);

        if (!isValid && i == segmentChildrens.length - 1 && isPlayViaPlayCount && count != tempCount) {
          i = 0;
        }

        if (isValid) {
          if (SchedulingHelper.IsPromoBreakValidAccWeightage(i + 1, newWeightage)) {
            //IMPLEMENT WEIGHTAGE AND PLAY COUNT
            const dataToSave = SchedulingHelper.prepareData(
              ENTITYNAME.MediaEpisode,
              getSelectedChannel(),
              [promo],
              destinationDataItem,
              schedulerDataRef.current
            );
            // adding in schedule            
            await addScheduleItems(destinationDataItem, dataToSave, false);
            tempCount = tempCount + 1;
          }
        }
      }
    }
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: totalPromoPlotted + " Interstitial Plotted." });
    await saveCompleteScheduleChildrenandRefresh();
    setProgressData({ message: 'Process Completed !!', progress: 100 });
    setShowProgressBar({ progressBarPopup: true, okButton: true })
  }

  const expandMinimizeAllBreaks = (expand = true) => {
    var newSchedulerData = schedulerDataRef.current;
    newSchedulerData.map(parent => {
      if (selectedHeader.current._id == parent._id) {
        return parent.children.map(child => {
          if (child[IS_BREAK]) {
            child.expanded = expand;
          }
        })
      }
      else {
        return parent;
      }
    });
    schedulerDataRefSetter(newSchedulerData);
  }

  const onChangeBreakDataItemPopup = async (e) => {
    if (e.target.name == 'MediaCategory') {
      var mediaCategoryTypeTemp = mediaCategoryType.filter((x) => x.MediaCategorySID == e.target.value.SID);
      setFilterMediaCategoryType(mediaCategoryTypeTemp);
      setBreakdataItemForPopup({ ...breakdataItemForPopup, [e.target.name]: e.target.value, MediaCategoryType: {} });
    } else if (e.target.name == 'MediaCategoryType') {
      setBreakdataItemForPopup({ ...breakdataItemForPopup, Content: {}, [e.target.name]: e.target.value });
    } else {
      setBreakdataItemForPopup({ ...breakdataItemForPopup, [e.target.name]: e.target.value });
    }
  };

  const onCancelVirtualSegmentationPopup = () => {
    setShowVirtualSegmentation(false);
    setVirtualSegmentationData({
      duration: "00:00:00:00",
      noOfSeg: 2,
      diffDur: "00:00:00:00",
      totalDur: "00:00:00:00",
      gridData: []
    });
  }

  const onUpdateTxStatus = async () => {

    // this validation is applied in planning and scheduling, please make sure you change at both places for any code change
    if (txStatusRef.current.SID == TX_STATUS.Live || txStatusRef.current.SID == TX_STATUS.SDD) {
      var response = await API.canChangeTxStatusToLiveOrDalayed(selectedState[0].SlotDateTime, selectedState[0].MediaEpisode_id);
      console.log(response);

      if (!response.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
        return;
      }
    }

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: selectedState[0]._id,
      TXStatus: { SID: txStatusRef.current.SID, Description: txStatusRef.current.Description }
    });

    setUpdateTxStatusPopupOpen(false)


    if (updateRes.success) {

      //LOCAL DATA SET
      let dataLocal = [...schedulerDataRef.current];
      let index = dataLocal.findIndex((x) => x._id == selectedState[0]._id);
      dataLocal.splice(index, 1, { ...selectedState[0], TXStatus: { SID: txStatusRef.current.SID, Description: txStatusRef.current.Description } })
      schedulerDataRefSetter(dataLocal)

      var updatedData = { ...selectedState[0], OldTxStatus: selectedState[0].TXStatus, UpdatedTxStatus: { SID: txStatusRef.current.SID, Description: txStatusRef.current.Description } };
      let logData = { event: LOGEVENT.UPDATE_PLANNING_TX_STATUS, module: MODULE.SCHEDULING, data: updatedData, message: LOGEVENT.UPDATE_PLANNING_TX_STATUS };
      API.SaveProgramScheduleHeaderLogs(logData);
    }

  }

  const onUpdateProgramScheduleComment = async () => {

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: selectedState[0]._id,
      Comment: commentRef.current
    });

    setUpdateCommentPopupOpen(false)

    if (updateRes.success) {

      //LOCAL DATA SET
      let dataLocal = [...schedulerDataRef.current];
      let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(selectedStateRef.current[0], schedulerDataRef.current);

      // header
      if (level_1_index == null) {
        dataLocal.splice(level_0_index, 1, { ...selectedState[0], Comment: comment });
      } else if (isInsideBreak) {
        dataLocal[level_0_index].children[level_1_index].children.splice(level_2_index, 1, { ...selectedState[0], Comment: comment });
      } else {
        dataLocal[level_0_index].children.splice(level_1_index, 1, { ...selectedState[0], Comment: comment });
      }

      schedulerDataRefSetter(dataLocal)


      var updatedData = { ...selectedState[0], OldComment: selectedState[0].Comment ?? "", UpdatedComment: commentRef.current };
      let logData = { event: LOGEVENT.UPDATE_PLANNING_TX_STATUS, module: MODULE.SCHEDULING, data: updatedData, message: LOGEVENT.UPDATE_PLANNING_TX_STATUS };
      API.SaveProgramScheduleHeaderLogs(logData);
    }

  }

  const onUpdateProgramScheduleRouterCommand = async () => {

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: selectedState[0]._id,
      RouterCommand: routerCommandRef.current
    });

    setUpdateRouterCommandPopupOpen(false)

    if (updateRes.success) {

      //LOCAL DATA SET
      let dataLocal = [...schedulerDataRef.current];
      let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(selectedStateRef.current[0], schedulerDataRef.current);

      // header
      if (level_1_index == null) {
        dataLocal.splice(level_0_index, 1, { ...selectedState[0], RouterCommand: routerCommand });
      } else if (isInsideBreak) {
        dataLocal[level_0_index].children[level_1_index].children.splice(level_2_index, 1, { ...selectedState[0], RouterCommand: routerCommand });
      } else {
        dataLocal[level_0_index].children.splice(level_1_index, 1, { ...selectedState[0], RouterCommand: routerCommand });
      }

      schedulerDataRefSetter(dataLocal)


      var updatedData = { ...selectedState[0], OldComment: selectedState[0].Comment ?? "", UpdatedComment: routerCommandRef.current };
      let logData = { event: LOGEVENT.PLANNING_ADD_ROUTER_COMMAND, module: MODULE.SCHEDULING, data: updatedData, message: LOGEVENT.PLANNING_UPDATE_ROUTER_COMMAND };
      API.SaveProgramScheduleHeaderLogs(logData);
    }

  }


  const onRemoveStartAndEndCredits = async (creditTypeToRemove) => {

    if (!selectedState[0]?._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please first select schedule header item' });
      return;
    }

    const msg = creditTypeToRemove == SEGMENT_DETAILS_CREDIT_TYPE.Both ? "Start and End Credits" : (creditTypeToRemove == SEGMENT_DETAILS_CREDIT_TYPE.EndCredit ? "End Credits" : "Start Credits")


    ConfirmAlert(
      async () => {
        var updateRes = await API.RemoveStartAndEndCredits({
          ProgramSchedule_ids: [selectedState[0]._id],
          ExcludeCreditsType: creditTypeToRemove
        });

        if (updateRes?.success) {
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: updateRes.message });
          loaddata(true);
        }
        else
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: updateRes.message });
      }, // on Click yes
      async () => {
        // on click no
      },
      `Remove ${msg} ?`, //title
      `This will delete ${msg} segments from schedule. Do you want to proceed ?` // message
    );

  }


  const onUpdateSCTEMarker = async (scteType) => {

    let newData = [...scteHeaderData];

    if (selectedStateRef.current[0].Type == SCHEDULETYPE.Segment) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_apply_SCTE_marker_error_message });
      return;
    }

    let index = newData.findIndex((x) => x._id == selectedStateRef.current[0]._id);

    newData.splice(index, 1, { ...selectedStateRef.current[0], SCTEType: scteType });

    setSCTEHeaderData(newData)

  }

  const onSaveUpdateProgramScheduleSCTE = async () => {

    console.log(scteHeaderData);

    //IMPLEMENT VALIDATION
    let scteOnChild = scteHeaderData.filter((x) => x.SCTEType == SCTE_TYPE.SCTE_START);
    let scteOffChild = scteHeaderData.filter((x) => x.SCTEType == SCTE_TYPE.SCTE_END);

    //CHECKING COUNT OF ON AND OFF
    if (scteOnChild.length != scteOffChild.length) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.scte_start_and_end_error_message });
      return;
    }

    let invalidSeq = false;
    let tempSCTEData = scteHeaderData.filter(x => x.SCTEType !== SCTE_TYPE.NO_SCTE && x.SCTEType !== SCTE_TYPE.SCTE_BOTH && x.Type != SCHEDULETYPE.UnderRun && x.Type != SCHEDULETYPE.OverRun);


    // Sequence must start with SCTE_START
    if (tempSCTEData.length > 0) {
      if (tempSCTEData[0]?.SCTEType !== SCTE_TYPE.SCTE_START) { //CHECK ERROR HERE
        invalidSeq = true;
      } else {
        for (let i = 0; i < tempSCTEData.length; i++) {
          const expectedType = i % 2 === 0 ? SCTE_TYPE.SCTE_START : SCTE_TYPE.SCTE_END;
          if (tempSCTEData[i].SCTEType !== expectedType) {
            invalidSeq = true;
            break;
          }
        }

        // Sequence must end with SCTE_END (even count)
        if (tempSCTEData.length % 2 !== 0) {
          invalidSeq = true;
        }
      }
    }

    if (invalidSeq) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.wrong_scte_marker_sequence_error_message });
      return;
    }

    //SET NEW DATA OF GRID DATA
    let tempSchedulerData = [...schedulerDataRef.current];

    let child = scteHeaderData[0];

    let parent = tempSchedulerData.find((x) => x._id == child.ParentProgramSchedule_id);
    let parentIndex = tempSchedulerData.findIndex((x) => x._id == parent._id);
    console.log(parentIndex);

    tempSchedulerData[parentIndex].children = [...scteHeaderData];

    schedulerDataRefSetter(tempSchedulerData);

    setUpdateSCTEPopupOpen(false);

    //SAVING
    await saveCompleteScheduleChildrenandRefresh();

  }

  const loadSavedSegments = () => {
    console.log('here test');
    loaddata(true);
  }
  // new code for tree  START
  const onHeaderDrop = (e, props) => {

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    //HERE we need to prepare the data
    const dataTransfer = JSON.parse(e.dataTransfer.getData("text"));
    const draggedData = dataTransfer.propsData;
    const src = dataTransfer.src;
    const destinationDataItem = props.dataItem;
    const isInternal =
      src == ENTITYNAME.ProgramSchedule || src == ENTITYNAME.BREAK_CHILDREN;
    if (isInternal && draggedData.some(d => d._id == destinationDataItem._id)) {
      return;
    }

    if (draggedData.some(item => item.Type == SCHEDULETYPE.Segment)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Cannot move Segments` });
      return;
    }

    if ((destinationDataItem.Type == SCHEDULETYPE.OverRun ||
      destinationDataItem.Type == SCHEDULETYPE.UnderRun) && isInternal) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Cannot drop on OverRun or UnderRun` });
      return;
    }
    if (src == ENTITYNAME.Booking) {

      console.log("offsetTimeWithoutTimeZone");
      console.log(offsetTimeWithoutTimeZone);

      if (!SchedulingHelper.IsValidBookingDrop(destinationDataItem, draggedData, offsetTimeWithoutTimeZone, selectedChannel)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Some Dragged Booked Spots Are Not In Valid Time Range ` });
        return;
      }

      if (!SchedulingHelper.IsValidBookingDropPosition(destinationDataItem, draggedData, schedulerDataRef.current)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some Dragged Booked Spots Are Not Valid For This Destination Position" });
        return;
      }

      //CHECK CLIENT SPOT SEPERATION
      var invalidClientSpotSeparationData = SchedulingHelper.IsValidBookingDropClientSpot(destinationDataItem, draggedData, schedulerDataRef.current);
      if (!invalidClientSpotSeparationData.IsValid) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: invalidClientSpotSeparationData.Message });
        return;
      }
      if (destinationDataItem.Type == SCHEDULETYPE.OverRun ||
        destinationDataItem.Type == SCHEDULETYPE.UnderRun) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Cannot drop on OverRun or UnderRun" });
        return;
      }

      SalesHelper.saveBookingLogFromSchedule(draggedData, destinationDataItem);

      deleteUsedBooking(draggedData);
    }

    if (src == ENTITYNAME.Prototype) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Cannot drop Prototypes on Header` });
      return;
    }

    if (src == ENTITYNAME.MediaEpisode && draggedData.some(x => x[IS_BREAK])) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.break_type_item_is_not_allowed_error_message });
      return;
    }

    if (!SchedulingHelper.IsValidDropDestinationSlot(destinationDataItem, draggedData, offsetTime, selectedDateRef.current, isInternal, selectedChannel)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Some dragged items are not in valid Publishing Time Range ` });
      return;
    }

    //CHECK CLIENT SPOT SEPERATION
    // if (isInternal && !SchedulingHelper.IsValidBookingDropClientSpot(destinationDataItem, draggedData, schedulerDataRef.current,isInternal)) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message:"Some Dragged Booked Spots Are Not under Valid Client Spot Seperation" });
    //   return;
    // }

    if (isInternal) deleteScheduleItems(draggedData, false, true); //then it need to be delete first
    const dataToSave = SchedulingHelper.prepareData(
      src,
      getSelectedChannel(),
      draggedData,
      destinationDataItem,
      schedulerDataRef.current
    );
    addScheduleItems(destinationDataItem, dataToSave);
  }

  const onChildrenDrop = (e, props) => {

    if (isBreakOnly && !props.dataItem[IS_BREAK]) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Can only be dropped on Break Item" });
      return;
    }

    if (!lockStatus.canModify) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule Locked by " + lockStatus.lockedBy.name });
      return;
    }
    if (isDraftMode) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Schedule is in draft mode" });
      return;
    }
    //HERE we need to prepare the data
    const dataTransfer = JSON.parse(e.dataTransfer.getData("text"));
    const draggedData = dataTransfer.propsData;
    if (draggedData.some(item => item.Type == SCHEDULETYPE.Segment)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Cannot move Segments` });
      return;
    }
    const src = dataTransfer.src;
    const isFooter =
      props.dataItem.Type == SCHEDULETYPE.UnderRun ||
      props.dataItem.Type == SCHEDULETYPE.OverRun;
    const destinationDataItem = props.dataItem;

    const isInternal = src == ENTITYNAME.ProgramSchedule || src == ENTITYNAME.BREAK_CHILDREN;

    const itemInfo = SchedulingHelper.getChildInfo(destinationDataItem, schedulerDataRef.current);

    if (isInternal && (itemInfo.isBreak || itemInfo.isInsideBreak)) {

      let breakHeader = schedulerDataRef.current[itemInfo.level_0_index].children[itemInfo.level_1_index];

      if (!breakHeader.mediaEpisode.AllowAllCateogries && draggedData.some(item => item.mediaEpisode.MediaCategory.SID != breakHeader.mediaEpisode.MediaCategory.SID)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_choose_right_media_categor_error_message });
        if (draggedData.some(item => item.Source == "Booking")) {
          props.loadBookingCommercialdata();
        }
        return;
      }
    }
    //not allowed for segments
    if (src == ENTITYNAME.Prototype && isFooter) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.prototype_drop_not_allowed_for_headers_and_footers_error_message });
      return;
    }
    if (src == ENTITYNAME.MediaEpisode && draggedData.some(x => x[IS_BREAK])) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.break_type_item_is_not_allowed_error_message });
      return;
    }

    if (isInternal && draggedData.some(d => d._id == destinationDataItem._id)) {
      return;
    }

    if (src == ENTITYNAME.Prototype) {
      handleDropPrototype(destinationDataItem, draggedData[0]);
      return;
    }

    if (src == ENTITYNAME.Booking) {

      if (!SchedulingHelper.IsValidBookingDrop(destinationDataItem, draggedData, offsetTimeWithoutTimeZone, selectedChannel)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Some Dragged Booked Spots Are Not In Valid Time Range ` });
        return;
      }

      if (!SchedulingHelper.IsValidBookingDropPosition(destinationDataItem, draggedData, schedulerDataRef.current)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Some Dragged Booked Spots Are Not Valid For This Destination Position" });
        return;
      }

      //IF ANNNOUNCEMENT, WE JUST NEED TO DROP AND RETURN FROM HERE...
      if (draggedData[0].mediaEpisode.MediaCategoryType.SID == MEDIACATEGORYTYPES.Announcement) {
        console.log(destinationDataItem);
        console.log(draggedData[0]);
        handleDropAnnouncement(destinationDataItem, draggedData);
        deleteUsedBooking(draggedData);
        return;
      }

      //CHECK CLIENT SPOT SEPERATION
      var invalidClientSpotSeparationData = SchedulingHelper.IsValidBookingDropClientSpot(destinationDataItem, draggedData, schedulerDataRef.current);
      if (!invalidClientSpotSeparationData.IsValid) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: invalidClientSpotSeparationData.Message });
        return;
      }

      //Added Booking Log 


      SalesHelper.saveBookingLogFromSchedule(draggedData, destinationDataItem);



      deleteUsedBooking(draggedData);
    }

    if (isInternal && draggedData.some((item) => item.Type == SCHEDULETYPE.Segment)) {
      console.log(destinationDataItem)
      if (!draggedData.some((item) => item.ParentProgramSchedule_id == destinationDataItem.ParentProgramSchedule_id)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_move_segment_to_different_program_schedule_error_message });
        return;
      }
    }

    // CHECK CLIENT SPOT SEPERATION
    var invalidClientSpotSeparationData = SchedulingHelper.IsValidBookingDropClientSpot(destinationDataItem, draggedData, schedulerDataRef.current);
    if (isInternal && !invalidClientSpotSeparationData.IsValid) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: invalidClientSpotSeparationData.Message });
      return;
    }

    if (!SchedulingHelper.IsValidDropDestinationSlot(destinationDataItem, draggedData, offsetTime, selectedDateRef.current, isInternal, selectedChannel)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Some dragged items are not in valid Time Range` });
      return;
    }

    if (isInternal) deleteScheduleItems(draggedData, false, true); //then it need to be delete first
    const dataToSave = SchedulingHelper.prepareData(
      src,
      getSelectedChannel(),
      draggedData,
      destinationDataItem,
      schedulerDataRef.current,
    );
    addScheduleItems(destinationDataItem, dataToSave);
  }

  const onRowDrop = (e, destinationDataItem) => {
    console.log(e);
    if (!SchedulingHelper.canModify(destinationDataItem, schedulerDataRef.current)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot drop here because header is locked" });
      return;
    }
    const dataTransfer = JSON.parse(e.dataTransfer.getData("text"));
    const src = dataTransfer.src;
    const draggedData = dataTransfer.propsData;
    const isInternal = src == ENTITYNAME.ProgramSchedule;
    const isSrcIsParent = isInternal && draggedData.length > 0 && (draggedData[0].ParentProgramSchedule_id == null || draggedData[0].ParentProgramSchedule_id == undefined)
    // TODO: make varialbe for datItem isInternal or EXTERNAL

    // FOR DESTINATION
    const isParent = destinationDataItem.ParentProgramSchedule_id == null || destinationDataItem.ParentProgramSchedule_id == undefined;
    console.log(isParent);

    console.log(src);
    console.log(draggedData);
    console.log(destinationDataItem);

    if (isSrcIsParent) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Cannot move header" });
      return;
    }

    if (isParent) {
      onHeaderDrop(e, { dataItem: destinationDataItem });
    }
    else { //CALL CHILDREN ON DROP
      onChildrenDrop(e, { dataItem: destinationDataItem })
    }
  };

  const onTreeExpandChange = (event) => {
    const expanded = !event.value;
    const tree = [...schedulerDataRef.current];
    const itemId = event.dataItem._id;

    const updatedTree = tree.map((item) => {
      if (item._id === itemId) {
        return {
          ...item,
          [EXPAND_FIELD]: expanded,
        };
      } else {
        if (item.children) {
          item.children = item.children.map((child) => {
            if (child._id === itemId) {
              return {
                ...child,
                [EXPAND_FIELD]: expanded,
              };
            }
            return child;
          });
        }
      }
      return item;
    });

    schedulerDataRefSetter(updatedTree);
  };

  const gridPreferenceTreeColumn = (col, isHyperLink = false) => {
    let column = {
      key: col._id + Math.random(),
      width: col.width,
      field: col.name,
      title: col.label,
      cell: col.label == "Subtitle"
        ? MySubtitleCell :
        col.label == "TX Mode"
          ? TXModeCell :
          col.label == "TX Status"
            ? TXStatusCell
            : col.label == "Info"
              ? MyInfoCell
              : col.label == "Comment" || col.label == "Segment Remarks"
                ? (props) => <MyInfoCell {...props} cellBackgroundColor="yellow" cellTextColor="black" />
                : col.label == "SCTE Marker" || col.label == "Cue Tones"
                  ? (props) => <MySCTEMarkerCell {...props} titleColor="black" tileBackColor="white" col={col.label} />
                  : col.label == "Router Command"
                    ? (props) => <MyRouterCommandCell {...props} titleColor="black" tileBackColor="white" />
                    : col.label == "MAM"
                      ? (props) => <MyMamAssetIconCell {...props} titleColor="black" tileBackColor="white" />
                      : null
    }
    switch (col.type) {
      case COLUMNSTYPE.time:
        if (col.label == "Time" && isHyperLink) {
          return {
            ...column,
            cell: (props) => TimeHyperLinkCell({ ...props, onClick: onGoToSchedule })
          };
        } else {
          return {
            ...column,
            // cell: TimeCell
            cell: (props) => <TimeCell {...props} label={col.label} entityName={col.entityName} channel={selectedChannel} />
          };
        }
      case COLUMNSTYPE.date:
        return {
          ...column,
          // cell: DateOnlyCell
          cell: (props) => <DateOnlyCell {...props} label={col.label} entityName={col.entityName} channel={selectedChannel} />
        };
      case COLUMNSTYPE.MyScheduleTypeCell:
        return {
          ...column,
          cell: ScheduleTypeCell
        };
      case COLUMNSTYPE.mySecondaryEventCountCell:
        return {
          ...column,
          cell: MySecondaryEventCountCell
        };
      case COLUMNSTYPE.myTXReadyCell:
        return {
          ...column,
          cell: MyTXReadyImageCell
        };
      case COLUMNSTYPE.myAnnouncementCountCell:
        return {
          ...column,
          cell: MyAnnouncementCountCell
        };
      case COLUMNSTYPE.archive:
        return {
          ...column,
          cell: ArchiveIconCell
        }
      case COLUMNSTYPE.segmentCountCell:
        return {
          ...column,
          cell: SegmentCountCell
        }

      case COLUMNSTYPE.mamAssetStatusCell:
        return {
          ...column,
          cell: MAMAssetStatusCell
        }
      default:
        return column;
    }
  }

  const GridRowRenderTreeList = (props) => {
    // for row styling
    let newProps = {
      ...props, children: props.children.map((d, i) => {
        return React.cloneElement(d, {
          ...d.props,
          style: !props.dataItem[SELECTED_FIELD] ? { ...d.props.dataItem.Style, ...d.props.style } : {},
        }, d.props.children)
      })
    }
    return <TreeListDraggableRow  {...newProps} />
  }

  let timeOut;
  const handleColumnResize = (event) => {
    try {
      if (event.index == 0) return;
      if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
      let column = dataColumns[event.index - 1];
      let payload = {
        entityName: column?.entityName,
        name: column?.name,
        width: event.newWidth
      };

      console.log("payload")
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        API.updateUserPreferenceColumnWidth(payload);
      }, 700);
    } catch (error) {
      console.error("Error handling column resize:", error);
    }
  };

  const onColumnResize = (event) => {
    if (treeListRef) {
      treeListRef.current.element.style.width = `100%`;
      handleColumnResize(event);
    }
  };

  const showInsertBreakPopup = (e) => {
    hideContextMenus(e);
    if (selectedStateRef.current.length == 0 || selectedStateRef.current.length > 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_target_item_from_schedule_error_message });
      return;
    } else {
      setShowInsertPlaceHolderFilter(true);
    }
  }

  const pageChange = (event) => {
    setSkip(event.page.skip);
  };

  const onRevertVirtualSegmentation = () => {
    SchedulingHelper.revertVirtualSegment(selectedStateRef.current, schedulerDataRef.current, loaddata);
  }
  // new code for tree  END

  const onMatchPreviousDayEndTime = async (scheduleTimeInfo) => {

    if (schedulerDataRef.current && schedulerDataRef.current.length < 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `No Scheduling found on current date` });
      return;
    }

    if (schedulerDataRef.current[0].isLocked) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Locked header at top. Please unlock and try again.' });
      return;
    }

    if (scheduleTimeInfo?.PreviousScheduleEndDateTime == undefined || scheduleTimeInfo.PreviousScheduleEndDateTime == 0 || scheduleTimeInfo.PreviousScheduleEndDateTime == "NA") {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Invalid previous day end time.` });
      return;
    }

    const firstHeader = schedulerDataRef.current[0];
    var newSlotDateTime = scheduleTimeInfo.PreviousScheduleEndDateTime;

    if (newSlotDateTime < payloadref.current.ScheduleDate || newSlotDateTime > payloadref.current.ScheduleEndDate) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Cannot match previous day end time as it is not within schedule range` });
      return;
    }

    let updatedData = {
      SID: firstHeader.SID,
      _id: firstHeader._id,
      ScheduleDate: firstHeader.ScheduleDate,
      SlotDateTime: newSlotDateTime,
      EndSlotDateTime: newSlotDateTime + firstHeader.Duration,
      Segment_id: firstHeader.Segment_id
    }

    //to edit in ProgramScheduleTable
    var res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: updatedData._id,
      SlotDateTime: newSlotDateTime
    });
    if (res.success) {

      onUpdateFromPlanningEditForm(updatedData);
      props.setScheduleTimeInfo({
        StartDateTime: newSlotDateTime,
        EndDateTime: scheduleTimeInfo.EndDateTime,
        PreviousScheduleEndDateTime: scheduleTimeInfo.PreviousScheduleEndDateTime,
      })

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  };


  const onEditCustomDuration = async () => {

    const updatedDuration = utility.convertStringWithFramesToMilliseconds(customSlotDurationRef.current);

    if (updatedDuration <= 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Invalid Custom Duration ` });
      return;
    }

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: selectedStateRef.current[0]._id,
      customDuration: updatedDuration,
      TcOut: (selectedStateRef.current[0]?.TcIn ?? 0) + updatedDuration
    });

    setEditDurationPopupOpen(false);

    if (updateRes.success) {

      let schedulerDataCopy = [...schedulerDataRef.current];
      let { level_0_index, level_1_index, level_2_index, isInsideBreak } = SchedulingHelper.getChildInfo(selectedStateRef.current[0], schedulerDataRef.current);

      //LOCAL DATA SET
      const updatedObject = isInsideBreak ? {
        ...schedulerDataCopy[level_0_index].children[level_1_index].children[level_2_index],
        Duration: updatedDuration,
        TcOut: (schedulerDataCopy[level_0_index].children[level_1_index].children[level_2_index]?.TcIn ?? 0) + updatedDuration,
      } : {
        ...schedulerDataCopy[level_0_index].children[level_1_index],
        Duration: updatedDuration,
        TcOut: (schedulerDataCopy[level_0_index].children[level_1_index]?.TcIn ?? 0) + updatedDuration,
      };

      isInsideBreak ?
        schedulerDataCopy[level_0_index].children[level_1_index].children.splice(level_2_index, 1, updatedObject) :
        schedulerDataCopy[level_0_index].children.splice(level_1_index, 1, updatedObject);

      await childrenSave(level_0_index);
      schedulerDataRefSetter(schedulerDataCopy);

      // logs
      let logData = { event: LOGEVENT.UPDATE_SCHEDULE_ITEM_DURATION, module: MODULE.SCHEDULING, data: { ...updatedObject, customDuration: updatedDuration }, message: LOGEVENT.UPDATE_SCHEDULE_ITEM_DURATION };
      API.SaveProgramScheduleHeaderLogs(logData);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Updated successfully ` });
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `error:` + updateRes.message });
    }


  }

  const onSplitSegment = async () => {
    const splitDuration = utility.convertStringWithFramesToMilliseconds(splitSegmentDurationRef.current);
    let res = await API.splitSegments(selectedStateRef.current[0]._id, splitDuration);
    ToastNotification({ type: res.success ? TOAST_TYPES.SUCCESS : TOAST_TYPES.ERROR, title: res.success ? lang.success_message_title : lang.invalid_error_message_title, message: res.message });
    if (res.success) {
      loaddata(true);
    }
    setSplitSegmentPopupOpen(false);
  }

  let childrenContextMenuModel = [
    //filter
    showFilterGrid
      ? {
        label: `${lang.remove_filter_actionbutton_menutext}`,
        icon: "fa fa-filter fa-lg",
        command: (e) => {
          hideContextMenus(e);
          setShowFilterGrid(false);
        },
        template: contextMenuItem
      }
      : {
        label: `${lang.filter_actionbutton_menutext}`,
        icon: "fa fa-filter fa-lg",
        command: (e) => {
          hideContextMenus(e);
          onSchedulerChildrenFilter();
        },
        template: contextMenuItem
      },

    //Virtual Segmentation 
    {
      label: lang.virtual_segmentation_actionbutton_menutext,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-fw pi-box",
      command: (e) => {
        hideContextMenus(e);
        if (selectedStateRef.current.length > 1) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select only one Item" });
        } else if (selectedStateRef.current[0][IS_BREAK]) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Virtual Segmentation not allowed on breaks" });
        } else if (selectedStateRef.current[0].VirtualSegmentKey != null) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "This is already a part of Virtual Segmentation" });
        } else if (selectedStateRef.current[0].Type != SCHEDULETYPE.Segment) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Selected item is not a segment" });
        } else {
          setVirtualSegmentationData({
            ...virtualSegmentationData,
            duration: utility.convertMilisecondsToStringWithFrames(selectedStateRef.current[0].Duration),
            totalDur: utility.convertMilisecondsToStringWithFrames(selectedStateRef.current[0].Duration)
          });
          setShowVirtualSegmentation(true);
        }
      },
      template: contextMenuItem
    },
    //Revert Virtual Segmentation 
    {
      label: lang.revert_virtual_segmentation_actionbutton_menutext,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-fw pi-box",
      command: (e) => {
        hideContextMenus(e);
        onRevertVirtualSegmentation();
      },
      template: contextMenuItem
    },
    //Insert Place Holder
    {
      label: `${lang.insert_break_actionbutton_menutext}`,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-fw pi-envelope",
      command: (e) => {
        showInsertBreakPopup(e);
      },
      template: contextMenuItem
    },

    //copy
    {
      label: `${lang.copy_actionbutton_menutext}`,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify,
      icon: "fa fa-copy fa-lg",
      shortcut: "Ctrl + C",
      command: (e) => {
        hideContextMenus(e);
        onCopy();
      },
      template: contextMenuItem
    },

    //cut
    {
      label: `${lang.cut_actionbutton_menutext}`,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "fa fa-cut fa-lg",
      shortcut: "Ctrl + X",
      command: (e) => {
        hideContextMenus(e);
        onDelete(true);
      },
      template: contextMenuItem
    },


    //paste
    {
      label: `${lang.paste_actionbutton_menutext}`,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "fa fa-paste fa-lg",
      shortcut: "Ctrl + V",
      command: (e) => {
        hideContextMenus(e);
        onPaste();
      },
      template: contextMenuItem
    },

    //delete
    {
      label: `${lang.delete_actionbutton_menutext}`,
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-trash",
      shortcut: "del",
      command: (e) => {
        hideContextMenus(e);
        onDelete();
      },
      template: contextMenuItem
    },

    //create loop
    {
      label: lang.create_loop_actionbutton_menutext,
      icon: "pi pi-circle",
      command: (e) => {
        hideContextMenus(e);
        onCreateLoop();
      },
      template: contextMenuItem
    },

    //edit duration
    {
      label: `${lang.editduration_actionbutton_menutext}`,
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-pencil",
      command: (e) => {
        hideContextMenus(e);

        if (!selectedStateRef.current || !selectedStateRef.current[0]) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select item to edit duration" });
          return;
        }
        if (selectedStateRef.current.length > 1) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select only one Item" });
          return;
        }

        setCustomSlotDuration(utility.convertMilisecondsToStringWithFrames((selectedStateRef.current[0]?.Duration ?? 0)))
        setEditDurationPopupOpen(true)
      },
      template: contextMenuItem
    },

    //split
    {
      label: `${lang.split_label}`,
      disabled: isDraftMode || !lockStatus.canModify || selectedStateRef.current?.[0]?.Type != SCHEDULETYPE.Segment,
      icon: "fa fa-lg fa-scissors",
      command: (e) => {
        hideContextMenus(e);

        if (!selectedStateRef.current || !selectedStateRef.current[0]) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select item to split" });
          return;
        }
        if (selectedStateRef.current.length > 1) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select only one Item" });
          return;
        }

        setSplitSegmentDuration(utility.convertMilisecondsToStringWithFrames((selectedStateRef.current[0]?.Duration ?? 0)))
        setSplitSegmentPopupOpen(true)
      },
      template: contextMenuItem
    },
    //Update Comments
    {
      label: `${lang.add_comment_actionbutton_menutext}`,
      icon: "pi pi-fw pi-comment",
      command: (e) => {
        hideContextMenus(e);
        setComment(selectedStateRef.current[0]?.Comment ?? '');
        setUpdateCommentPopupOpen(true)
      },
      template: contextMenuItem
    },

    // //se overview
    {
      label: `${lang.se_overview_actionbutton_menutext}`, disabled: showFilterGrid || !lockStatus.canModify, icon: 'pi pi-book',
      command: (e) => {
        hideContextMenus(e); showSecondaryEventOverviewDialogProp()
      }, template: contextMenuItem
    },
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: `${lang.global_replacement_actionbutton_menutext}`,
      icon: "pi pi-globe",
      command: (e) => {
        hideContextMenus(e);
        showGlobalReplacement();
      },
      template: contextMenuItem
    },
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: lang.delete_secondary_events_actionbutton_menutext,
      icon: "pi pi-trash",
      command: (e) => {
        hideContextMenus(e);
        deleteSelectedSecondaryEvent();
      },
      template: contextMenuItem
    },

    //ADD PROGRAM IN PROGRAM
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: lang.add_program_menutext,
      icon: 'pi pi-server',
      command: (e) => {
        hideContextMenus(e);
        setShowAddProgramPopup(true);
      },
      template: contextMenuItem
    },
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: lang.attach_mam_asset_tooltip,
      icon: 'pi pi-link',
      command: (e) => {
        hideContextMenus(e);
        onAttachMAMAsset();
      },
      template: contextMenuItem
    },
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: `${company?.Name?.toLowerCase() == "rock" ? lang.insert_cuetone_label : lang.insert_scte_label}`,
      icon: 'pi pi-hashtag',
      command: (e) => {
        hideContextMenus(e);
        onInsertCueTones();
      },
      template: contextMenuItem
    },
    {
      disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
      label: `${company?.Name?.toLowerCase() == "rock" ? lang.delete_cuetone_label : lang.delete_scte_label}`,
      icon: 'pi pi-minus',
      command: (e) => {
        hideContextMenus(e);
        onDeleteCueTones();
      },
      template: contextMenuItem
    },
  ]

  if (enableScheduleInsertLiveEvent) {
    childrenContextMenuModel.splice(1, 0, {
      label: lang.insert_live_event_actionbutton_menutext,
      disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || isBreakOnly,
      icon: "pi pi-fw pi-eye",
      command: (e) => {
        hideContextMenus(e);
        handleLiveEventPopup();
      },
      template: contextMenuItem
    })
  }

  const onLockUnlockItem = async (planningItem) => {

    let isPlanningItemLocked = planningItem?.isLocked ?? false;

    let res = await API.canLockUnlockItem(planningItem._id, !isPlanningItemLocked);
    let currHeaderIndex = schedulerDataRef.current.sort((a, b) => a.SlotDateTime - b.SlotDateTime).findIndex(data => data._id == planningItem._id);

    let nextHeaderStartTime = (currHeaderIndex + 1) < schedulerDataRef.current.length ? schedulerDataRef.current[currHeaderIndex + 1].SlotDateTime : null;

    if (res.success) {
      if (isPlanningItemLocked) {
        const result = await API.unlockItem(planningItem, res.data);
        if (result.success) {
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Scheduling item unlocked successfully` });
          let logData = { event: LOGEVENT.UNLOCK_SCHEDULING_ITEM, module: MODULE.SCHEDULING, data: { headerStartTime: planningItem.SlotDateTime, nextHeaderStartTime: nextHeaderStartTime, header: planningItem, segments: res.data }, message: LOGEVENT.UNLOCK_SCHEDULING_ITEM };
          API.SaveLogs(logData);
          schedulerDataRefSetter(schedulerDataRef.current.map(data => data._id == planningItem._id ? { ...data, isLocked: !isPlanningItemLocked } : data));
        } else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: result.message });
        }
        return;
      } else {
        // if can lock then show popup
        setHeaderLockPopup({
          show: true,
          segments: res.data,
          header: planningItem,
          nextHeaderStartTime: nextHeaderStartTime
        });
        console.log(res.data);
      }
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onFixFollowItem = async (planningItem) => {

    console.log("onFixFollowItem", planningItem)

    await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: planningItem._id,
      isFixed: !planningItem.isFixed
    });

    schedulerDataRefSetter(schedulerDataRef.current.map((data) => data._id == planningItem._id ? { ...data, isFixed: !planningItem.isFixed } : data));

  }
  const onCreateLoop = () => {
    console.log(copyPasteDataItemRef.current);

    if (copyPasteDataItemRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please copy alteast one item to create loop` });
      return;
    }
    setShowCreateLoopPopup(true);
  }

  return (
    <div style={{ height: "100%" }}>
      {
        isSchduleLoading ? <div className="ml-2 mt-2">
          <i style={{ fontSize: "20px", color: "GrayText" }} className="fas fa-spinner fa-pulse"></i>
        </div> : <div id="content-scroll" ref={scheduleScrollRef} className="content-scroll" style={{ height: "100%", overflow: "hidden" }} >
          {showFilterGrid ? (
            <Grid
              ref={gridRef}
              // style={{ userSelect: "none", height: "100%" }}
              style={{
                height: treeListHeight,
                overflow: "auto",
                width: "100%",
                userSelect: "none"
              }}
              data={orderBy(
                showFilterGridData.map((item) => {
                  item[SELECTED_FIELD] = selectedState.some(
                    (dataItem) => dataItem._id == item._id
                  );
                  return item;
                }),
                [
                  {
                    field: "SlotDateTime",
                    dir: "asc",
                  },
                ]
              )}

              // to remove virtual scrolling also remove e.skip from on selectionChange just go to to onselection change function i will guid you there
              //virtual scrolling implementation start
              rowHeight={20}
              pageSize={pageSize}
              total={showFilterGridData.length}
              skip={skip}
              scrollable="virtual"
              onPageChange={pageChange}
              //virtual scrolling implementation end
              rowRender={GridRowRenderFilterGrid}
              dataItemKey={DATA_ITEM_KEY}
              selectedField={SELECTED_FIELD}
              resizable={true}
              onColumnResize={handleColumnResize}
              selectable={{
                enabled: true,
                drag: true,
                cell: false,
                mode: {
                  value: "multiple",
                  label: "Multiple selection mode",
                },
              }}
              onSelectionChange={(e) => onSelectionChange(e, true)}
            >
              {dataColumns.map((col) => <Column {...gridPreferenceTreeColumn(col, true)} />)}
            </Grid>
          ) : (

            <TreeList
              ref={treeListRef}
              style={{
                height: treeListHeight,
                overflow: "auto",
                width: "100%",
                userSelect: "none"
              }}
              resizable={true}
              column
              rowHeight={ROW_HEIGHT}
              scrollable="virtual"

              //TO REMOVE UNWANTED DRAG N DROP ERROR SHOWING IN CONSOLE UN-COMMENT BELOW TWO PROPERTIES AND COMMENT ABOVE TWO PROPERTIES
              // rowHeight={undefined}

              dataItemKey={DATA_ITEM_KEY}
              tableProps={{
                style: {
                  tableLayout: "fixed",
                },
                onDragOver: (e) => {
                  e.preventDefault();
                },
                onDrop: (e) => {
                  console.log(e);
                  let dataItem = SchedulingHelper.getDataItemFromEvent(e, schedulerDataRef.current);
                  if (!dataItem) {
                    return;
                  } else {
                    onRowDrop(e, dataItem);
                  }
                },
                onClick: (e) => {
                  let dataItem = SchedulingHelper.getDataItemFromEvent(e, schedulerDataRef.current);
                  if (!dataItem) {
                    return;
                  } else {
                    if (dataItem.ParentProgramSchedule_id == null) {
                      setSelectedHeader(dataItem);
                      selectedStateRefSetter([dataItem]);
                    }

                    onSelectionChange(e, false, dataItem);
                    // onTreeSelectionChange(e, dataItem);
                    // selectedStateRefSetter([dataItem]);
                  }
                },
                onContextMenu: (e) => {
                  e.preventDefault();
                  console.log(e);
                  let dataItem = SchedulingHelper.getDataItemFromEvent(e, schedulerDataRef.current);
                  if (!dataItem) {
                    return;
                  }
                  else {
                    console.log(dataItem);
                    hideContextMenus(e);
                    //Parrent
                    if (dataItem.Type == SCHEDULETYPE.Header) {
                      hcm.current?.show(e);
                      setSelectedHeader(dataItem);
                      selectedStateRefSetter([dataItem]);
                    }
                    else {
                      if (dataItem[IS_BREAK_CHILDREN]) {
                        bc.current?.show(e);
                      } else {
                        cm.current?.show(e);
                      }

                      //for filter
                      let field = Object.keys(dataItem)[e.target.cellIndex];
                      schedulerChildrenFilterRef.current = { dataItem: dataItem, field: field }


                      if (selectedStateRef.current.length == 1 && selectedStateRef.current[0]._id == dataItem._id) {
                        selectedStateRefSetter([dataItem]);
                      } else if (selectedStateRef.current.length > 0 && dataItem.Type != SCHEDULETYPE.UnderRun && dataItem.Type != SCHEDULETYPE.OverRun) {

                        if (!selectedStateRef.current.some((item) => item._id == dataItem._id)) {
                          selectedStateRefSetter([dataItem]);
                        } else {
                          // selectedStateRefSetter([...selectedStateRef.current, dataItem]);

                          let dataToSelect = selectedStateRef.current.length > 1 && selectedStateRef.current.some((item) => item._id == dataItem._id) ? selectedStateRef.current : [...selectedStateRef.current, dataItem];
                          selectedStateRefSetter(dataToSelect);
                        }
                      } else {
                        selectedStateRefSetter([dataItem]);
                      }
                    }
                  }


                },
              }}
              data={orderBy(schedulerData.map(parent => {
                parent[SELECTED_FIELD] = selectedState.some(
                  (dataItem) => dataItem._id == parent._id
                );
                if (parent?.children?.length > 0) {
                  parent.children = orderBy(parent.children.map((item) => {
                    item[SELECTED_FIELD] = selectedState.some(
                      (dataItem) => dataItem._id == item._id
                    );
                    if (item?.children?.length > 0) {
                      item.children = orderBy(item.children.map((bc) => {
                        bc[SELECTED_FIELD] = selectedState.some(
                          (dataItem) => dataItem._id == bc._id
                        );
                        return bc
                      }), [
                        {
                          field: "SlotDateTime",
                          dir: "asc",
                        }
                      ])
                    }
                    return item
                  },), [
                    {
                      field: "SlotDateTime",
                      dir: "asc",
                    }
                  ])
                }
                return parent;
              }), [
                {
                  field: "SlotDateTime",
                  dir: "asc",
                },
              ])}
              expandField={EXPAND_FIELD}
              selectedField={SELECTED_FIELD}
              subItemsField={SUB_ITEM_FIELD}
              onExpandChange={onTreeExpandChange}
              columns={[{
                key: Math.random(),
                width: '30px',
                field: '',
                title: '',
                resizable: false,
                cell: (props) => {
                  if (props.dataItem?.Type == SCHEDULETYPE.Header || props.dataItem[IS_BREAK]) {
                    return <div id={props?.dataItem?._id} onClick={(e) => props.onExpandChange(e, props.dataItem)} style={{ width: '100%', height: "40px", cursor: "pointer", position: "relative", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "black", color: "white", ...props.dataItem?.Style }}>
                      <i className={props.dataItem.expanded ? "fa fa-minus" : "fa fa-plus"} />
                      {props?.dataItem?.isLocked && <i style={{ position: "absolute", bottom: "2px", right: "2px", fontSize: "10px" }} className="fa fa-lock pt-1" />}
                      {props?.dataItem?.isFixed && <i style={{ position: "absolute", bottom: "2px", right: "2px", fontSize: "10px" }} className="pi pi-calendar-clock pt-1" />}
                    </div>
                  } else if (props.dataItem[IS_BREAK_CHILDREN]) {
                    return <div id={props?.dataItem?._id} onClick={(e) => props.onExpandChange(e, props.dataItem)} style={{ width: '100%', height: "40px", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "black", color: "white", ...props.dataItem?.Style }}><i className={"fa fa-b fa-sm"} /></div>
                  }
                  else {
                    return <div id={props?.dataItem?._id} onClick={(e) => props.onExpandChange(e, props.dataItem)} style={{ width: '100%', height: "40px", backgroundColor: "white", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}></div>
                  }

                }
              }, ...dataColumns.map((col) => gridPreferenceTreeColumn(col))]}
              row={GridRowRenderTreeList}
              onRowDrop={(e) => {
                var destinationDataItem;
                // draggedOver = [0], [0,1],[0,2,4]
                if (e.draggedOver.length == 1) {
                  destinationDataItem = schedulerDataRef.current[e.draggedOver[0]];
                }
                else if (e.draggedOver.length == 2) {
                  destinationDataItem = schedulerDataRef.current[e.draggedOver[0]].children[e.draggedOver[1]];
                }
                else {
                  destinationDataItem = schedulerDataRef.current[e.draggedOver[0]].children[e.draggedOver[1]].children[e.draggedOver[2]];
                }
                let draggedItems = [];
                if (selectedStateRef.current.some(x => x._id == e.draggedItem._id)) {
                  draggedItems = selectedStateRef.current;
                } else {
                  draggedItems = [e.draggedItem];
                }

                let myEvent = {
                  ...e,
                  dataTransfer: {
                    getData: () => { return JSON.stringify({ src: ENTITYNAME.ProgramSchedule, propsData: draggedItems }) }
                  }
                }
                onRowDrop(myEvent, destinationDataItem);
              }}
              selectable={{
                enabled: true,
                // drag: false,
                // cell: false,
                mode: 'single',
              }}
              onColumnResize={onColumnResize}
            />
          )}
        </div>}


      {/* HEADER CONTEXT MENU */}
      {!showFilterGrid && <ContextMenu
        ref={hcm}
        model={[
          {
            disabled: selectedHeader.current.isLocked || isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            label: `${lang.edit_actionbutton_menutext}`,
            icon: "pi pi-fw pi-pencil",
            command: (e) => {
              hideContextMenus(e);
              setShowPlanningEditForm((old) => !old);
            },
            template: contextMenuItem
          },
          {
            disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            label: `${lang.select_all_Header_menutext}`,
            icon: "pi pi-fw pi-list",
            command: (e) => {
              hideContextMenus(e);
              selectAllHeaders();
            },
            template: contextMenuItem
          },
          {
            disabled: selectedHeader.current.isLocked || isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            label: `${lang.delete_header_actionbutton_menutext}`,
            icon: "pi pi-fw pi-trash",
            command: (e) => {
              hideContextMenus(e);
              scheduleHeaderDelete();
            },
            template: contextMenuItem
          },
          //Insert Place Holder
          {
            label: `${lang.insert_break_actionbutton_menutext}`,
            disabled: selectedHeader.current.isLocked || isDraftMode || showFilterGrid || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            icon: "pi pi-fw pi-envelope",
            command: (e) => {
              hideContextMenus(e);
              console.log(selectedStateRef.current);
              if (selectedStateRef.current.length == 0 || selectedStateRef.current.length > 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_target_item_from_schedule_error_message });
              } else {
                setShowInsertPlaceHolderFilter((old) => !old);
              }
            },
            template: contextMenuItem
          },
          {
            label: lang.lock_unlock_label + ' Item',
            disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            icon: "pi pi-fw pi-lock",
            command: (e) => {
              hideContextMenus(e);
              console.log(selectedStateRef.current);
              if (selectedStateRef.current.length == 0 || selectedStateRef.current.length > 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_target_item_from_schedule_error_message });
              } else {
                onLockUnlockItem(selectedStateRef.current[0]);
              }
            },
            template: contextMenuItem
          },
          {
            label: lang.fix_follow_label + ' Items',
            disabled: isDraftMode || showFilterGrid || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            icon: "pi pi-fw pi-calendar-clock",
            command: (e) => {
              hideContextMenus(e);
              console.log(selectedStateRef.current);
              if (selectedStateRef.current.length == 0 || selectedStateRef.current.length > 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_target_item_from_schedule_error_message });
              } else {
                onFixFollowItem(selectedStateRef.current[0]);
              }
            },
            template: contextMenuItem
          },
          // {
          //     label: `${"Create Breaks"}`, disabled: showFilterGrid, icon: 'pi pi-fw pi-envelope',command: (e) => {
          // hideContextMenus(e);
          //         if (selectedState.length == 0 || selectedState.length > 1) {
          // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Select target item from schedule' });
          //         } else {
          //             setLoopBreak(true);
          //             setShowInsertPlaceHolderFilter(old => !old);
          //         }
          //     }
          // },
          {
            disabled: selectedHeader.current.isLocked || isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            label: `${lang.program_replacement_actionbutton_menutext}`,
            icon: "pi pi-fw pi-sync",
            command: (e) => {
              hideContextMenus(e);
              setShowProgramReplacementDialog(true);
            },
            template: contextMenuItem
          },
          {
            label: lang.expand_all_breaks_label,
            icon: "pi pi-arrows-v",
            command: (e) => {
              hideContextMenus(e);
              expandMinimizeAllBreaks(true);
            },
            template: contextMenuItem
          },
          {
            label: lang.mnimize_all_breaks_label,
            icon: "pi pi-fw pi-minus",
            command: (e) => {
              hideContextMenus(e);
              expandMinimizeAllBreaks(false);
            },
            template: contextMenuItem
          },
          {
            disabled: selectedHeader.current.isLocked || isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
            label: `${lang.attach_format_reload_actionbutton_menutext}`,
            icon: "pi pi-fw pi-microsoft",
            command: (e) => {
              hideContextMenus(e);
              setShowFormatSelection(true);
            },
            template: contextMenuItem
          },
          //{ label: `${lang.history_actionbutton_menutext}`, icon: 'pi pi-fw pi-history',command: (e) => {
          // hideContextMenus(e); setShowHistory(true) } },
          //EDIT SEGMENTATION
          {
            label: `${lang.show_segmentation_actionbutton_menutext}`, icon: 'pi pi-fw pi-server',
            command: (e) => {
              hideContextMenus(e); props.handleTabChange(e, 5);
            },
            template: contextMenuItem
          },
          {
            label: `${lang.fast_segmentation_actionbutton_menutext}`, icon: 'pi pi-fw pi-bolt',
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e); setFastSegmentationPopupOpen(true);
            },
            template: contextMenuItem
          },

          //Update Tx Status
          {
            label: `${lang.update_txstatus_actionbutton_menutext}`,
            icon: "fa fa-lg fa-solid fa-satellite-dish",
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e);
              setTxStatus(selectedState[0]?.TXStatus);
              setUpdateTxStatusPopupOpen(true)
            },
            template: contextMenuItem
          },

          //Update Comments
          {
            label: `${lang.add_comment_actionbutton_menutext}`,
            icon: "pi pi-fw pi-comment",
            command: (e) => {
              hideContextMenus(e);
              setComment(selectedState[0]?.Comment ?? '');
              setUpdateCommentPopupOpen(true)
            },
            template: contextMenuItem
          },

          //Add Router Command
          {
            label: `${lang.add_router_command_actionbutton_menutext}`,
            icon: "fa-solid fa-lg fa-diamond-turn-right",
            command: (e) => {

              console.log(selectedStateRef.current[0])

              //VALIDATION FOR LIVE & SDD ONLY
              if (
                selectedStateRef.current[0]?.TXStatus?.SID != TX_STATUS.Live &&
                selectedStateRef.current[0]?.TXStatus?.SID != TX_STATUS.SDD
              ) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.router_command_can_only_be_added_for_live_and_sdd });
                return;
              }


              hideContextMenus(e);
              setRouterCommand(selectedStateRef.current[0]?.RouterCommand ?? '');
              setUpdateRouterCommandPopupOpen(true)
            },
            template: contextMenuItem
          },

          //Manage under Over run / Slot Auto Fill
          {
            label: `${lang.manage_underoverrun_schedule_menu_text}`,
            icon: "fa fa-lg fa-list",
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e);
              ManageUnderAndOverRuns([selectedState[0]?._id], false);
            },
            template: contextMenuItem
          },
          {
            label: `${lang.auto_fill_music}`,
            icon: "fa fa-lg fa-music",
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e);
              autoFillMusic(selectedState[0]);
            },
            template: contextMenuItem
          },

          //Copy Breaks
          {
            label: `${lang.copybreak_schedule_menu_text}`,
            icon: "fa fa-lg fa-copy",
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e);
              CopyHeaderBreakElements(selectedState[0]?._id);
            },
            template: contextMenuItem
          },

          //Paste Breaks
          {
            label: `${lang.pastebreak_schedule_menu_text}`,
            icon: "fa fa-lg fa-paste",
            disabled: selectedHeader.current.isLocked,
            command: (e) => {
              hideContextMenus(e);
              PasteHeaderBreakElements(selectedState[0]?._id);
            },
            template: contextMenuItem
          },
          //Update SCTE
          {
            label: `${company?.Name?.toLowerCase() == "rock" ? 'Update Cue Tone' : lang.update_SCTE_marker_actionbutton_menutext}`,//`${lang.update_SCTE_marker_actionbutton_menutext}`,
            icon: "pi pi-fw pi-flag-fill",
            command: (e) => {
              hideContextMenus(e);
              setUpdateSCTEPopupOpen(true);
              setSCTEHeaderData(selectedState[0].children);
            },
            template: contextMenuItem
          },
          // Remove Start and End Credits
          {
            label: lang.delete_start_end_credits_label,
            icon: "pi pi-fw pi-trash",
            items: [
              // Start Credits
              {
                label: `${lang.delete_start_credits_label}`,
                icon: "pi pi-fw pi-step-forward",
                command: (e) => {
                  hideContextMenus(e);
                  onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.StartCredit)
                },
                template: contextMenuItem
              },
              //End Credits
              {
                label: `${lang.delete_end_credits_label}`,
                icon: "pi pi-fw pi-step-backward",
                command: (e) => {
                  hideContextMenus(e);
                  onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.EndCredit)
                },
                template: contextMenuItem
              },
              //Both Credits
              {
                label: `${lang.delete_both_credits_label}`,
                icon: "pi pi-fw pi-arrows-h",
                command: (e) => {
                  hideContextMenus(e);
                  onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.Both)
                },
                template: contextMenuItem
              },
            ]
          },

          //Ripple Headers
          // {
          //   disabled: selectedHeader.current.isLocked || isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader || isBreakOnly,
          //   // label: `${lang.program_replacement_actionbutton_menutext}`,
          //   label: `Ripple`,
          //   icon: "pi pi-fw pi-sort-amount-down",
          //   command: (e) => {
          //     hideContextMenus(e);
          //     setShowHeaderRippleDialog(true);
          //     setSlotTime(utility.convertMilisecondsToStringWithFrames((selectedStateRef.current[0]?.SlotDateTime ?? 0)))
          //   },
          //   template: contextMenuItem
          // },
        ]}
      />}

      {!showFilterGrid && <ContextMenu
        ref={cm}
        model={childrenContextMenuModel}
      />}

      <ContextMenu
        ref={fg}
        model={[
          //filter
          showFilterGrid
            ? {
              label: `${lang.remove_filter_actionbutton_menutext}`,
              icon: "pi pi-fw pi-filter",
              command: (e) => {
                hideContextMenus(e);
                setShowFilterGrid(false);
              },
              template: contextMenuItem
            }
            : {
              label: `${lang.filter_actionbutton_menutext}`,
              icon: "pi pi-fw pi-filter",
              command: (e) => {
                onSchedulerChildrenFilter();
                hideContextMenus(e);
              },
              template: contextMenuItem
            },

          //delete
          {
            label: `${lang.delete_actionbutton_menutext}`,
            disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
            icon: "pi pi-fw pi-trash",
            command: (e) => {
              onDelete();
              hideContextMenus(e);
            },
            template: contextMenuItem
          },
          {
            disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
            label: `${lang.global_replacement_actionbutton_menutext}`,
            icon: "pi pi-fw pi-sync",
            command: (e) => {
              showGlobalReplacement();
              hideContextMenus(e);
            },
            template: contextMenuItem
          },
          {
            disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
            label: lang.delete_secondary_events_actionbutton_menutext,
            icon: "pi pi-fw pi-trash",
            command: (e) => {
              deleteSelectedSecondaryEvent();
              hideContextMenus(e);
            },
            template: contextMenuItem
          },
        ]}
      />
      {!showFilterGrid && <ContextMenu
        ref={bc}
        model={[
          //filter
          showFilterGrid
            ? {
              label: `${lang.remove_filter_actionbutton_menutext}`,
              icon: "fa fa-filter fa-lg",
              command: (e) => {
                hideContextMenus(e);
                setShowFilterGrid(false);
              },
              template: contextMenuItem
            }
            : {
              label: `${lang.filter_actionbutton_menutext}`,
              icon: "fa fa-filter fa-lg",
              command: (e) => {
                hideContextMenus(e);
                onSchedulerChildrenFilter();
              },
              template: contextMenuItem
            },
          //copy
          {
            label: `${lang.copy_actionbutton_menutext}`,
            disabled: isDraftMode || showFilterGrid || !lockStatus.canModify,
            icon: "fa fa-copy fa-lg",
            shortcut: 'Ctrl + C',
            command: (e) => {
              hideContextMenus(e);
              onCopy();
            },
            template: contextMenuItem
          },
          //paste
          {
            label: `${lang.paste_actionbutton_menutext}`,
            disabled: isDraftMode || showFilterGrid || !lockStatus.canModify,
            icon: "fa fa-paste fa-lg",
            shortcut: 'Ctrl + V',
            command: (e) => {
              hideContextMenus(e);
              onPaste();
            },
            template: contextMenuItem
          },

          //delete
          {
            label: `${lang.delete_actionbutton_menutext}`,
            disabled: isDraftMode || !lockStatus.canModify,
            icon: "pi pi-trash",
            shortcut: 'del',
            command: (e) => {
              hideContextMenus(e);
              onDelete();
            },
            template: contextMenuItem
          },

          //edit duration
          {
            label: `${lang.editduration_actionbutton_menutext}`,
            disabled: isDraftMode || !lockStatus.canModify || isBreakOnly,
            icon: "pi pi-pencil",
            command: (e) => {
              hideContextMenus(e);

              if (!selectedStateRef.current || !selectedStateRef.current[0]) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select item to edit duration" });
                return;
              }
              if (selectedStateRef.current.length > 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select only one Item" });
                return;
              }

              setCustomSlotDuration(utility.convertMilisecondsToStringWithFrames((selectedStateRef.current[0]?.Duration ?? 0)))
              setEditDurationPopupOpen(true)
            },
            template: contextMenuItem
          },
          //split
          {
            label: `${lang.split_label}`,
            disabled: isDraftMode || !lockStatus.canModify || selectedStateRef.current?.[0]?.Type != SCHEDULETYPE.Segment,
            icon: "fa fa-lg fa-scissors",
            command: (e) => {
              hideContextMenus(e);

              if (!selectedStateRef.current || !selectedStateRef.current[0]) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select item to split" });
                return;
              }
              if (selectedStateRef.current.length > 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Select only one Item" });
                return;
              }

              setSplitSegmentDuration(utility.convertMilisecondsToStringWithFrames((selectedStateRef.current[0]?.Duration ?? 0)))
              setSplitSegmentPopupOpen(true)
            },
            template: contextMenuItem
          },
          //Update Comments
          {
            label: `${lang.add_comment_actionbutton_menutext}`,
            icon: "pi pi-fw pi-comment",
            command: (e) => {
              hideContextMenus(e);
              setComment(selectedStateRef.current[0]?.Comment ?? '');
              setUpdateCommentPopupOpen(true)
            },
            template: contextMenuItem
          },

          // //se overview
          {
            label: `${lang.se_overview_actionbutton_menutext}`, disabled: showFilterGrid || !lockStatus.canModify, icon: 'pi pi-book',
            command: (e) => {
              hideContextMenus(e); showSecondaryEventOverviewDialogProp()
            }, template: contextMenuItem
          },
          {
            label: `${lang.global_replacement_actionbutton_menutext}`, disabled: !lockStatus.canModify || isBreakOnly, icon: 'pi pi-globe',
            command: (e) => {
              hideContextMenus(e); showGlobalReplacement();
            }, template: contextMenuItem
          },
        ]}
      />}

      {!showFilterGrid && <ContextMenu
        ref={scteg}
        model={[
          {
            label: `Apply ${company?.Name?.toLowerCase() == "rock" ? 'Cue Tone IN' : 'SCTE Marker ON'}`,
            icon: "pi pi-fw pi-angle-double-up",
            command: (e) => {
              onUpdateSCTEMarker(SCTE_TYPE.SCTE_START);
              hideContextMenus(e);
            },
            template: contextMenuItem
          },
          {
            label: `Apply ${company?.Name?.toLowerCase() == "rock" ? 'Cue Tone OUT' : 'SCTE Marker OFF'}`, //`${lang.scte_off_actionbutton_menutext}`,
            icon: "pi pi-fw pi-angle-double-down",
            command: (e) => {
              onUpdateSCTEMarker(SCTE_TYPE.SCTE_END);
              hideContextMenus(e);
            },
            template: contextMenuItem
          },
          {
            label: `Remove ${company?.Name?.toLowerCase() == "rock" ? 'Cue Tone' : 'SCTE Marker'}`, //`${lang.remove_scte_actionbutton_menutext}`,
            icon: "pi pi-fw pi-times",
            command: (e) => {
              onUpdateSCTEMarker(SCTE_TYPE.NO_SCTE);
              hideContextMenus(e);
            },
            template: contextMenuItem
          }
        ]}
      />}

      {showPlanningEditForm && (
        <PlanningEditForm
          isOpenFromSchedule={true}
          onClose={() => setShowPlanningEditForm((old) => !old)}
          dataItem={{
            ...selectedHeader.current,
            Title: selectedHeader.current.mediaEpisode.Title,
            Channel: selectedHeader.current.Channel,
            ChannelSID: selectedHeader.current.Channel.SID,
            // ExhibitionNumber: selectedHeader.current.ExhibitionNumber ?? 0,
            // RepeatNumber: selectedHeader.current.RepeatNumber ?? 0,
            //ExhibitionNumber missing
            //RepeatNumber missing
            //ActualDuration missing
            //Nominalduration missing
          }}
          onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm}
          closeEditForm={() => setShowPlanningEditForm((old) => !old)}
          module={MODULE.SCHEDULING}
        />
      )}
      {showInsertPlaceHolderFilter && (
        <BossDialog
          title={lang.insert_break_label}
          onClose={() => setShowInsertPlaceHolderFilter(false)}
          width={"400px"}
        >
          <div className="row">
            <div className="col-md-12 mt-2">
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label htmlFor="">{lang.media_category_label}*</label>
                    <DropDownList
                      data={mediaCategory}
                      name="MediaCategory"
                      textField="Description"
                      dataItemKey="_id"
                      value={breakdataItemForPopup.MediaCategory}
                      onChange={onChangeBreakDataItemPopup}
                    />
                  </div>
                </div>

                <div className="col-6">
                  <div className="form-group">
                    <label htmlFor="TabView">{lang.media_category_type_label}*</label>
                    <DropDownList
                      data={filterMediaCategoryType}
                      name="MediaCategoryType"
                      textField="Description"
                      dataItemKey="_id"
                      value={breakdataItemForPopup.MediaCategoryType ?? mediaCategoryType[0]}
                      onChange={onChangeBreakDataItemPopup}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="">{lang.duration_label} *</label>
                    <TimePickerWithFormat
                      name="Duration"
                      value={breakdataItemForPopup.Duration}
                      onChange={(e) => onChangeBreakDataItemPopup(e)}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bg-danger text-white"
              onClick={() => setShowInsertPlaceHolderFilter(false)}
            >
              {lang.cancel_button_text}
            </button>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bg-primary text-white"
              onClick={setSelectedPlaceHolderMedia}
            >
              {lang.add_button_text}
            </button>
          </DialogActionsBar>
        </BossDialog>

        // <CollectionSelection
        //   entityname={ENTITYNAME.MediaEpisode}
        //   wherestatement={["IsBreak", "=", true]}
        //   setDataList={setSelectedPlaceHolderMedia}
        //   mode={"single"}
        //   closeForm={() => {
        //     setShowInsertPlaceHolderFilter((old) => !old);
        //   }}
        //   title={lang.add_insert_break_label}
        //   width="50vw"
        //   height="64vh"
        // />
      )}

      {showProgramReplacementDialog && (<>
        <ContractCollectionSelection
          title={`${lang.select_program_to_replace_with_collection_title}`}
          entityname={ENTITYNAME.MediaEpisode}
          wherestatement={["MediaCategory.isLong", "=", true]}
          setDataList={programReplacement}
          hideSeriesSeason={true}
          mediaCategory={selectedHeader?.current?.mediaEpisode?.MediaCategory}
          mode={"single"}
          closeForm={() => {
            setShowProgramReplacementDialog(false);
          }}
          width={"50vw"} />
      </>
      )}

      {showHeaderRippleDialog && (
        <BossDialog
          title={'Ripple Header'}
          width={"300px"}
          onClose={() => setShowHeaderRippleDialog(false)}
        >
          <>
            <EditPageHeader title={""} onSubmit={onHeaderRipple} onCancel={() => setShowHeaderRippleDialog(false)} showTitle={false} />

            <div className="form-group">
              <label htmlFor="">{lang.slot_time_label} *</label>
              <TimePickerWithFormat
                name="Time"
                value={slotTime}
                onChange={(e) => { setSlotTime(e.target.value) }}
                required
              />

            </div>
          </>
        </BossDialog>
      )}

      {showAutoPlotPromo && <AutoPlotPromo
        data={selectedPromoRef.current}
        onSave={autoPlotPromoSchedule}
        setData={setSelectedPromo}
        cancelEdit={() => setShowAutoPlotPromo(false)}
      />}

      {showGlobalReplacementDialog && (
        <GlobalReplacement
          gloabalFindAndReplace={gloabalFindAndReplace}
          selectedState={selectedStateRef.current}
          scheduleData={schedulerDataRef.current}
          closeForm={() => {
            setShowGlobalReplacementDialog(false);
          }}
        />
      )}

      {showCheckList && (
        <CheckLists
          closeForm={onCheckList}
          onGoToSchedule={onGoToSchedule}
          data={schedulerData}
          offsetTime={offsetTime}
          scheduleTimeInfo={props.scheduleTimeInfo}
          bookedCommercialData={props.bookedCommercialData}
          onExport={(checkList) => exportSchedule(props.selectedChannel.Automation.SID, props.selectedChannel, checkList)}
        />
      )}

      {showMediaDealRightsPopup && (

        <div className="row" style={{ marginLeft: "-02px", width: "570px" }}>
          <div className="col-12">
            <CollectionSelection
              title={
                lang.please_choose_one_publishing_rights_collection_header
              }
              entityname={ENTITYNAME.MediaDealRights}
              wherestatement={[[
                "media_id",
                "=",
                programToReplaceRef.current._id,
              ], ["PlatformType.SID", '=', PLATFORMTYPE[0].SID]]} // 0 indes is Linear
              setDataList={replaceProgramWithSelectedDealRight}
              mode={"single"}
              closeForm={onCancelMediaDealRightPopup}
            />
          </div>
        </div>

      )}

      {showFormatSelection && (
        <CollectionSelection
          addButtonTitle={"Apply"}
          entityname={ENTITYNAME.Format}
          wherestatement={["Channel.SID", "=", selectedChannel.SID]}
          setDataList={onApplyFormatClick}
          closeForm={() => setShowFormatSelection(false)}
          existingItems={[]}
          checkDuplicate={false}
          mode={"single"}
          width="42vw"
        />
      )}

      {styleSheetSelectionOpen && (
        <CollectionSelection
          title={lang.style_sheet_dialog_header}
          addButtonTitle={"Apply"}
          entityname={ENTITYNAME.SecondaryEventStyleSheet}
          wherestatement={["Channel.SID", "=", selectedChannel.SID]}
          setDataList={onStyleSheetSelectionClose}
          closeForm={onStyleSheetSelection}
          existingItems={[]}
          checkDuplicate={false}
          width={"50vw"}
        />
      )}

      {/* {interstitialGroupSelectionOpen && (
        <CollectionSelection
          addButtonTitle={"Apply"}
          title={'Select Interstitial Group'}
          entityname={ENTITYNAME.MediaEpisodeGroup}
          wherestatement={['MediaCategory.isLong', '=', false]}
          setDataList={fillUnderOverRun}
          closeForm={() => setInterstitialGroupSelectionOpen(false)}
          existingItems={[]}
          checkDuplicate={false}
          width={"45vw"}
          height={"64vh"}
          mode={'single'}
        />
      )} */}

      {showSecondaryEventOverviewDialog &&
        <SchedulePrototypeOverview
          DATA_ITEM_KEY={DATA_ITEM_KEY}
          SELECTED_FIELD={SELECTED_FIELD}
          selectedItem={selectedState}
          MyTimeCell={TimeCell}
          setShowSecondaryEventOverviewDialog={setShowSecondaryEventOverviewDialog}
          saveSecondaryChangedData={saveSecondaryChangedData}
          data={schedulerDataRef.current}
        />}

      {fastSegmentationPopupOpen && <MediaFastSegmentationPopup mediaEpisodeEntity={selectedState[0].mediaEpisode} programScheduleEntity={selectedState[0]} refreshSegments={loadSavedSegments} onClose={() => setFastSegmentationPopupOpen(false)} source={'scheduling'} />}

      {updateTxStatusPopupOpen && (
        <BossDialog
          title={lang.update_txstatus_actionbutton_menutext}
          width={"300px"}
          onClose={() => setUpdateTxStatusPopupOpen(false)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group">
                <label htmlFor="TabView">{lang.tx_status_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={txStatusData}
                  name="txStatus"
                  textField="Description"
                  dataItemKey="SID"
                  value={txStatus}
                  onChange={(e) => { setTxStatus(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateTxStatus} onCancel={() => setUpdateTxStatusPopupOpen(false)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {updateCommentPopupOpen && (
        <BossDialog
          title={comment.length > 0 ? lang.update_comment_actionbutton_menutext : lang.add_comment_actionbutton_menutext}
          width={"300px"}
          onClose={() => setUpdateCommentPopupOpen(false)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="TabView">{lang.comment_label}</label>
              </div>
              <div className="col-12 form-group">
                <textarea className="pl-2"
                  type="text"
                  value={comment}
                  style={{ border: 'solid lightgrey 1px', height: '50px', width: '270px' }}
                  onChange={(e) => { setComment(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateProgramScheduleComment} onCancel={() => setUpdateCommentPopupOpen(false)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {updateRouterCommandPopupOpen && (
        <BossDialog
          title={routerCommand.length > 0 ? lang.update_router_command_actionbutton_menutext : lang.add_router_command_actionbutton_menutext}
          width={"300px"}
          onClose={() => setUpdateRouterCommandPopupOpen(false)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="TabView">{lang.router_command_label}</label>
              </div>
              <div className="col-12 form-group">
                <textarea className="pl-2"
                  type="text"
                  value={routerCommand}
                  style={{ border: 'solid lightgrey 1px', height: '50px', width: '270px' }}
                  onChange={(e) => { setRouterCommand(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateProgramScheduleRouterCommand} onCancel={() => setUpdateRouterCommandPopupOpen(false)} showTitle={false} />
          </>
        </BossDialog>
      )}



      {updateSCTEPopupOpen && (
        <BossDialog
          title={company?.Name?.toLowerCase() == "rock" ? 'Update Cue Tone' : lang.update_SCTE_marker_actionbutton_menutext}
          width={"80vw"}
          onClose={() => setUpdateSCTEPopupOpen(false)}
        >
          <>
            <EditPageHeader title={""} onSubmit={onSaveUpdateProgramScheduleSCTE} onCancel={() => setUpdateSCTEPopupOpen(false)} showTitle={false} />
            <div className="row">
              <div className="col-12 form-group">
                <Grid
                  ref={scteGridRef}
                  data={orderBy(
                    scteHeaderData.map((item) => {
                      item[SELECTED_FIELD] = selectedState.some(
                        (dataItem) => dataItem._id == item._id
                      );
                      return item;
                    }),
                    [
                      {
                        field: "SlotDateTime",
                        dir: "asc",
                      },
                    ]
                  )}

                  // to remove virtual scrolling also remove e.skip from on selectionChange just go to to onselection change function i will guid you there
                  //virtual scrolling implementation start
                  rowHeight={20}
                  scrollable="virtual"
                  rowRender={GridRowRenderSCTEGrid}
                  dataItemKey={DATA_ITEM_KEY}
                  selectedField={SELECTED_FIELD}
                  resizable={true}
                  selectable={{
                    enabled: true,
                    drag: true,
                    cell: false,
                    mode: {
                      value: "multiple",
                      label: "Multiple selection mode",
                    },
                  }}
                  onSelectionChange={(e) => { }}
                >
                  {dataColumns.map((col) => <Column {...gridPreferenceTreeColumn(col, true)} />)}
                </Grid>
              </div>

            </div>
          </>
        </BossDialog>
      )}

      {showVirtualSegmentation &&
        <VirtualSegmentationPopup onCancelVirtualSegmentationPopup={onCancelVirtualSegmentationPopup} onVirtualSegmentationSplitClick={() => {
          SchedulingHelper.onVirtualSegmentationSplitClick(virtualSegmentationData, setVirtualSegmentationData, selectedStateRef.current[0])
        }} onSaveVirtualSegmentation={() => SchedulingHelper.onSaveVirtualSegmentation(virtualSegmentationData, selectedStateRef.current[0], onCancelVirtualSegmentationPopup, loaddata)} inlineEdit={(event) => SchedulingHelper.inlineEdit(event, virtualSegmentationData, setVirtualSegmentationData, selectedStateRef.current[0])} virtualSegmentationData={virtualSegmentationData} setVirtualSegmentationData={setVirtualSegmentationData} selectedSegment={selectedStateRef.current[0]} />
      }

      {showGoToSchedulePopup && <GoToSchedulePopup close={() => setShowGoToSchedulePopup(false)} onGoToSchedule={onGoToSchedule} schedulerData={schedulerDataRef.current} />}

      {showProgressBar.progressBarPopup && <div id='myProgressBar'>
        <div className='myProgressBarBox' style={enableBossAI ? { paddingTop: '30px', height: "200px" } : {}}>

          {enableBossAI && <img src={bossAIPng} alt="Boss AI" className={progressData.progress == 100 ? "" : 'pop-effect'} style={{ width: '50px', height: '50px' }} />}

          <ProgressBar
            label={(props) => {
              return <strong>{props.value}%</strong>;
            }}
            labelPlacement='center'
            progressStyle={{ backgroundColor: enableBossAI ? "#6719b3" : "green" }}
            value={progressData.progress}
            style={{ width: "360px" }}
          />
          <div className='message' style={enableBossAI ? { top: "145px" } : {}}>
            <p>{progressData.message}</p>
          </div>
          {showProgressBar.okButton && <button
            onClick={() => { setShowProgressBar({ ...showProgressBar, progressBarPopup: false }); }}
            style={{ width: "50px", backgroundColor: enableBossAI ? "#3D365C" : "green" }}
            className='k-button k-button-md k-rounded-md k-button-solid k-button-solid-base text-white' >
            OK
          </button>
          }
        </div>
      </div>}
      {showSaveScheduleDraftPopup && <ScheduleDraftEditForm scheduleDate={payloadref.current.ScheduleDate} scheduleEndDate={payloadref.current.ScheduleEndDate} channel={selectedChannel} close={handleSaveScheduleDraftPopup} />}

      {editDurationPopupOpen && (
        <BossDialog
          title={'Set Custom Duration'}
          width={"300px"}
          onClose={() => setEditDurationPopupOpen(false)}
        >
          <>
            <EditPageHeader title={""} onSubmit={onEditCustomDuration} onCancel={() => setEditDurationPopupOpen(false)} showTitle={false} />

            <div className="form-group">
              <label htmlFor="">{lang.duration_label} *</label>
              <TimePickerWithFormat
                name="Duration"
                value={customSlotDuration}
                onChange={(e) => {
                  setCustomSlotDuration(e.target.value);
                }}
                required
              />

            </div>
          </>
        </BossDialog>
      )}

      {splitSegmentPopupOpen && (
        <BossDialog
          title={'Split Segment'}
          width={"300px"}
          onClose={() => setSplitSegmentPopupOpen(false)}
        >
          <>
            <EditPageHeader title={""} onSubmit={onSplitSegment} onCancel={() => setSplitSegmentPopupOpen(false)} showTitle={false} />

            <div className="form-group">
              <label htmlFor="">{lang.duration_label} *</label>
              <TimePickerWithFormat
                name="Duration"
                value={splitSegmentDuration}
                onChange={(e) => {
                  setSplitSegmentDuration(e.target.value);
                }}
                required
              />

            </div>
          </>
        </BossDialog>
      )}

      {showAddProgramPopup && <AddProgramSchedulePopup
        offsetTime={selectedStateRef.current[0].SlotDateTime}
        date={selectedStateRef.current[0].SlotDateTime}
        addScheduleItems={addScheduleItems}

        // offsetTime={offsetTime} 
        // date={date}
        channel={selectedChannel}
        selectedItem={selectedStateRef.current[0]}
        onClose={() => setShowAddProgramPopup(false)}
        onScheduleRefresh={() => loaddata(true)}
        schedulerData={schedulerData}
        isFromInternal={true}
      />}

      {showImportCommercialPopup && <ImportCommercialPopup
        channel={selectedChannel}
        onClose={() => setShowImportCommercialPopup(false)}
        onScheduleRefresh={() => loaddata(true)}
        schedulerData={schedulerDataRef.current}
        onImportCommercialFile={onImportCommercialFile}
        scheduleMediaLibraryPayload={props.scheduleMediaLibraryPayload}
        date={props.date}
        getCommcialBreakDropDestination={getCommcialBreakDropDestination}
        importCommercialProgress={importCommercialProgress}
      />}

      {headerLockPopup.show && <HeaderLockPopup onClose={(refresh = false) => {
        setHeaderLockPopup({ show: false, segments: [], header: null, nextHeaderStartTime: null });
        if (refresh) {
          loaddata();
          //NEED TO ASK
          // refreshPlanning();
        }
      }} segments={headerLockPopup.segments} header={headerLockPopup.header} nextHeaderStartTime={headerLockPopup.nextHeaderStartTime} />
      }

      {showCreateLoopPopup &&
        <CreateLoopForm
          getSelectedChannel={getSelectedChannel}
          schedulerData={schedulerDataRef.current}
          copyPasteDataItem={copyPasteDataItemRef.current}
          onClose={() => setShowCreateLoopPopup(false)}
          selectedItem={selectedStateRef.current.length > 0 ? selectedStateRef.current[0] : {}}
          addScheduleItems={addScheduleItems}
          saveCompleteScheduleChildrenandRefresh={saveCompleteScheduleChildrenandRefresh}
        />
      }

      {showMissingMamIDPopup && <ScheduleMAMAssetReportPopup data={missingMamIDReportData} offsetTime={offsetTime} date={null} channel={selectedChannel} onClose={() => setShowMissingMamIDPopup(false)} onScheduleRefresh={() => { }} />}
      {showMamAssetCollectionSelection && <CollectionSelection entityname={ENTITYNAME.MediaMamAssets} customColumns={MediaMamAssetColumns} title={lang.attach_mam_asset_tooltip} closeForm={() => setShowMamAssetCollectionSelection(false)} setDataList={onBrowseMamAsset} mode={"single"} width={"50vw"} />}

    </div>
  );
};

export default memo(forwardRef(SchedulingMainTree));
